var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _rect, _rect2, _rect3, _rect4, _rect5, _circle, _rect6, _rect7, _rect8, _rect9, _circle2, _rect10, _rect11, _rect12, _rect13, _circle3, _rect14, _rect15, _rect16, _rect17, _circle4, _rect18, _rect19, _rect20, _rect21, _circle5, _rect22, _rect23, _rect24, _rect25, _circle6, _rect26, _rect27, _rect28, _rect29, _circle7, _rect30, _rect31, _rect32, _rect33, _circle8, _rect34, _rect35, _rect36, _rect37, _circle9, _rect38, _rect39, _rect40, _rect41, _circle10, _rect42, _rect43, _rect44, _rect45, _circle11, _rect46, _rect47, _rect48, _rect49, _circle12, _rect50, _rect51, _rect52, _rect53, _circle13, _rect54, _rect55, _rect56, _rect57, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _path169, _path170, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _path171, _path172, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _path173, _path174, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _path1302, _path1303, _path1304, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _path1313, _path1314, _path1315, _path1316, _path1317, _path1318, _path1319, _path1320, _path1321, _path1322, _path1323, _path1324, _path1325, _path1326, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _path1327, _path1328, _path1329, _path1330, _path1331, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _path1340, _path1341, _path1342, _path1343, _path1344, _path1345, _path1346, _path1347, _path1348, _path1349, _path1350, _path1351, _path1352, _path1353, _path1354, _path1355, _path1356, _path1357, _path1358, _path1359, _path1360, _path1361, _path1362, _path1363, _path1364, _path1365, _path1366, _path1367, _path1368, _path1369, _path1370, _path1371, _path1372, _path1373, _path1374, _path1375, _path1376, _path1377, _path1378, _path1379, _path1380, _path1381, _path1382, _path1383, _path1384, _path1385, _path1386, _path1387, _path1388, _path1389, _path1390, _path1391, _path1392, _path1393, _path1394, _path1395, _path1396, _path1397, _path1398, _path1399, _path1400, _path1401, _path1402, _path1403, _path1404, _path1405, _path1406, _path1407, _path1408, _path1409, _path1410, _path1411, _path1412, _path1413, _path1414, _path1415, _path1416, _path1417, _path1418, _path1419, _path1420, _path1421, _path1422, _path1423, _path1424, _path1425, _path1426, _path1427, _path1428, _path1429, _path1430, _path1431, _path1432, _path1433, _path1434, _path1435, _path1436, _path1437, _path1438, _path1439, _path1440, _path1441, _path1442, _path1443, _path1444, _path1445, _path1446, _path1447, _path1448, _path1449, _path1450, _path1451, _path1452, _path1453, _path1454, _path1455, _path1456, _path1457, _path1458, _path1459, _path1460, _path1461, _path1462, _path1463, _path1464, _path1465, _path1466, _path1467, _path1468, _path1469, _path1470, _path1471, _path1472, _path1473, _path1474, _path1475, _path1476, _path1477, _path1478, _path1479, _path1480, _path1481, _path1482, _path1483, _path1484, _path1485, _path1486, _path1487, _path1488, _path1489, _path1490, _path1491, _path1492, _path1493, _path1494, _path1495, _path1496, _path1497, _path1498, _path1499, _path1500, _path1501, _path1502, _path1503, _path1504, _path1505, _path1506, _path1507, _path1508, _path1509, _path1510, _path1511, _path1512, _path1513, _path1514, _path1515, _path1516, _path1517, _path1518, _path1519, _path1520, _path1521, _path1522, _path1523, _path1524, _path1525, _path1526, _path1527, _path1528, _path1529, _path1530, _path1531, _path1532, _path1533, _path1534, _path1535, _path1536, _path1537, _path1538, _path1539, _path1540, _path1541, _path1542, _path1543, _path1544, _path1545, _path1546, _path1547, _path1548, _path1549, _path1550, _path1551, _path1552, _path1553, _path1554, _path1555, _path1556, _path1557, _path1558, _path1559, _path1560, _path1561, _path1562, _path1563, _path1564, _path1565, _path1566, _path1567, _path1568, _path1569, _path1570, _path1571, _path1572, _path1573, _path1574, _path1575, _path1576, _path1577, _path1578, _path1579, _path1580, _path1581, _path1582, _path1583, _path1584, _path1585, _path1586, _path1587, _path1588, _path1589, _path1590, _path1591, _path1592, _path1593, _path1594, _path1595, _path1596, _path1597, _path1598, _path1599, _path1600, _path1601, _path1602, _path1603, _path1604, _path1605, _path1606, _path1607, _path1608, _path1609, _path1610, _path1611, _path1612, _path1613, _path1614, _path1615, _path1616, _path1617, _path1618, _path1619, _path1620, _path1621, _path1622, _path1623, _path1624, _path1625, _path1626, _path1627, _path1628, _path1629, _path1630, _path1631, _path1632, _path1633, _path1634, _path1635, _path1636, _path1637, _path1638, _path1639, _path1640, _path1641, _path1642, _path1643, _path1644, _path1645, _path1646, _path1647, _path1648, _path1649, _path1650, _path1651, _path1652, _path1653, _path1654, _path1655, _path1656, _path1657, _path1658, _path1659, _path1660, _path1661, _path1662, _path1663, _path1664, _path1665, _path1666, _path1667, _path1668, _path1669, _path1670, _path1671, _path1672, _path1673, _path1674, _path1675, _path1676, _path1677, _path1678, _path1679, _path1680, _path1681, _path1682, _path1683, _path1684, _path1685, _path1686, _path1687, _path1688, _path1689, _path1690, _path1691, _path1692, _path1693, _path1694, _path1695, _path1696, _path1697, _path1698, _path1699, _path1700, _path1701, _path1702, _path1703, _path1704, _path1705, _path1706, _path1707, _path1708, _path1709, _path1710, _path1711, _path1712, _path1713, _path1714, _path1715, _path1716, _path1717, _path1718, _path1719, _path1720, _path1721, _path1722, _path1723, _path1724, _path1725, _path1726, _path1727, _path1728, _path1729, _path1730, _path1731, _path1732, _path1733, _path1734, _path1735, _path1736, _path1737, _path1738, _path1739, _path1740, _path1741, _path1742, _path1743, _path1744, _path1745, _path1746, _path1747, _path1748, _path1749, _path1750, _path1751, _path1752, _path1753, _path1754, _path1755, _path1756, _path1757, _path1758, _path1759, _path1760, _path1761, _path1762, _path1763, _path1764, _path1765, _path1766, _path1767, _path1768, _path1769, _path1770, _path1771, _path1772, _path1773, _path1774, _path1775, _path1776, _path1777, _path1778, _path1779, _path1780, _path1781, _path1782, _path1783, _path1784, _path1785, _path1786, _path1787, _path1788, _path1789, _path1790, _path1791, _path1792, _path1793, _path1794, _path1795, _path1796, _path1797, _path1798, _path1799, _path1800, _path1801, _path1802, _path1803, _path1804, _path1805, _path1806, _path1807, _path1808, _path1809, _path1810, _path1811, _path1812, _path1813, _path1814, _path1815, _path1816, _path1817, _path1818, _path1819, _path1820, _path1821, _path1822, _path1823, _path1824, _path1825, _path1826, _path1827, _path1828, _path1829, _path1830, _path1831, _path1832, _path1833, _path1834, _path1835, _path1836, _path1837, _path1838, _path1839, _path1840, _path1841, _path1842, _path1843, _path1844, _path1845, _path1846, _path1847, _path1848, _path1849, _path1850, _path1851, _path1852, _path1853, _path1854, _path1855, _path1856, _path1857, _path1858, _path1859, _path1860, _path1861, _path1862, _path1863, _path1864, _path1865, _path1866, _path1867, _path1868, _path1869, _path1870, _path1871, _path1872, _path1873, _path1874, _path1875, _path1876, _path1877, _path1878, _path1879, _path1880, _path1881, _path1882, _path1883, _path1884, _path1885, _path1886, _path1887, _path1888, _path1889, _path1890, _path1891, _path1892, _path1893, _path1894, _path1895, _path1896, _path1897, _path1898, _path1899, _path1900, _path1901, _path1902, _path1903, _path1904, _path1905, _path1906, _path1907, _path1908, _path1909, _path1910, _path1911, _path1912, _rect83, _path1913, _rect84, _path1914, _rect85, _path1915, _rect86, _path1916, _rect87, _path1917, _path1918, _path1919, _path1920, _path1921, _path1922, _path1923, _path1924, _path1925, _path1926, _path1927, _path1928, _path1929, _path1930, _path1931, _path1932, _path1933, _path1934, _path1935, _path1936, _path1937, _path1938, _path1939, _path1940, _path1941, _path1942, _path1943, _path1944, _path1945, _path1946, _path1947, _path1948, _path1949, _path1950, _path1951, _path1952, _path1953, _path1954, _path1955, _path1956, _path1957, _path1958, _path1959, _path1960, _path1961, _path1962, _path1963, _path1964, _path1965;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFloormapMain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1339,
    height: 628,
    viewBox: "0 0 1339 628",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1337 72.2119H176V103.212H1328.88V94.9664L1337 102.379",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M429 72.2119V103.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M409 73.2119V100.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M361 73.2119V100.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M364 73.2119V100.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M342 73.2119V100.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M277 73.2119V100.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M232 73.2119V100.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M209 73.2119V100.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M321 73.2119V100.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M435 72.2119V103.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M440 72.2119V103.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M446 72.2119V103.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M451 72.2119V103.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M457 72.2119V103.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M461 72.2119V103.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M467 72.2119V103.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M470 72.2119V103.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M476 72.2119V103.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M482 72.2119V103.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M487 72.2119V103.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M491 72.2119V103.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M497 72.2119V103.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M423 84.2119H435",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M357 84.2119H367",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M252 73.2119V100.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M256 73.2119V100.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M248 84.2119H259",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M292 73.2119V100.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M296 73.2119V100.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M288 84.2119H299",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M489 85.2119H500",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M321 84.3269L310.578 95.2119V86.3199H299V81.1457H310.578L310.911 73.2119L321 84.3269Z",
    stroke: "#2CAD39",
    strokeWidth: 0.7007,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M204 463.84L213.937 474.212V465.702H225V460.808H213.937L213.619 453.212L204 463.84Z",
    stroke: "#2CAD39",
    strokeWidth: 0.7007,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M230 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M225 464.212H238",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M247 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M242 464.212H255",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M275 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M270 464.212H283",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M285 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M280 464.212H293",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M293 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M288 464.212H301",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M300 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M295 464.212H308",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M311 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M305 464.212H318",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M327 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M318 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M333 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M342 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M348 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M356 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M322 464.212H334",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M384 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M387 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M391 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M395 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M398 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M402 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M406 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M409 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M413 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M344 464.212H356",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M177 464.212H189",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M1306.72 464.971L1316.68 475.196V466.807H1327.78V461.982H1316.68L1316.36 454.493L1306.72 464.971Z",
    stroke: "#2CAD39",
    strokeWidth: 0.7007,
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M1081.35 464.971L1091.34 475.196V466.807H1102.41V461.982H1091.34L1091 454.493L1081.35 464.971Z",
    stroke: "#2CAD39",
    strokeWidth: 0.7007,
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M1081.35 464.863H1068.93",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M853.915 464.971L863.882 475.196V466.807H874.978V461.982H863.882L863.562 454.493L853.915 464.971Z",
    stroke: "#2CAD39",
    strokeWidth: 0.7007,
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M853.915 464.863H841.499",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M1245.32 450.496V479.192",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M1250.36 464.863H1237.95",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M1187.83 450.496V479.192",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M1192.9 464.863H1180.49",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M1131.76 450.496V479.192",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M1136.81 464.863H1124.39",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M1338.47 87.3421L1333.32 82.0497V86.3917H1327.57V88.8889H1333.32L1333.48 92.7651L1338.47 87.3421Z",
    stroke: "#2CAD39",
    strokeWidth: 0.7007,
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M1239.66 87.3421L1234.49 82.0497V86.3917H1228.76V88.8889H1234.49L1234.67 92.7651L1239.66 87.3421Z",
    stroke: "#2CAD39",
    strokeWidth: 0.7007,
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M1222.33 87.4167H1228.76",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M1313.62 94.8339V79.9814",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M1309.81 87.4167H1316.23",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M1283.87 94.8339V79.9814",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M1280.07 87.4167H1286.49",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M1254.85 94.8339V79.9814",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M1251.03 87.4167H1257.46",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M1018.03 450.496V479.192",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M1023.08 464.863H1010.66",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M967.004 464.863H954.588",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M910.14 464.863H897.723",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M156 437.55L155.371 125.212H124V283.325V440.212",
    stroke: "#2CAD39",
    strokeWidth: 0.7948,
    strokeMiterlimit: 10
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M176 72.2119C176 72.2119 147.033 77.2494 136.447 91.2161C126.637 104.224 124 125.212 124 125.212H155.586C155.586 125.212 158.279 116.041 161.109 110.862C163.94 105.682 176 102.141 176 102.141V72.2119Z",
    stroke: "#2CAD39",
    strokeWidth: 0.7948,
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M168 105.212L150 81.2119",
    stroke: "#2CAD39",
    strokeWidth: 0.7948,
    strokeMiterlimit: 10
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M160 114.212L131 100.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8852,
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M124 264.212H156",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M124 270.212H156",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 379.284L156.449 379.142",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 384.095H156.076",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 388.057H156.076",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 393.01H156.076",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 397.963H156.076",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 401.926H156.076",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 406.879H156.076",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 411.832H156.076",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 416.785H156.449",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 421.738H156.449",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 426.691H156.449",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 327.774L156.449 327.631",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 332.584H156.076",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 336.547H156.076",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 341.5H156.076",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 346.453H156.076",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 350.415H156.076",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 355.368H156.076",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 360.321H156.076",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 365.274H156.449",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 370.227H156.449",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 375.18H156.449",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 276.262L156.449 276.119",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 281.073H156.076",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 285.035H156.076",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 289.988H156.076",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 294.941H156.076",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 298.903H156.076",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 303.856H156.076",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 308.809H156.076",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 313.762H156.449",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 318.715H156.449",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 323.668H156.449",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 212.864L156.449 212.722",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 217.675H156.076",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 221.638H156.076",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 226.591H156.076",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 231.543H156.076",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 235.506H156.076",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 240.459H156.076",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 245.412H156.076",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 250.365H156.449",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 255.318H156.449",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 260.271H156.449",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 161.353L156.449 161.21",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 166.163H156.076",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 170.126H156.076",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 175.079H156.076",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 180.032H156.076",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 183.994H156.076",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 188.947H156.076",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 193.9H156.076",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 198.853H156.449",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 203.806H156.449",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 208.759H156.449",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 128.521H156.076",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 132.483H156.076",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 137.436H156.076",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 142.389H156.076",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 147.342H156.449",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 152.295H156.449",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 157.248H156.449",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M123.76 437.588L156.449 437.093",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M1337 450.212H183V479.212H1337V450.212Z",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M133.414 453.602L156.715 437.212C156.715 437.212 159.583 444.497 165.399 447.425C171.214 450.353 183 450.201 183 450.201V479.202C183 479.202 167.686 479.991 147.953 467.35C135.469 459.316 124 439.944 124 439.944",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M148 468.212L165 447.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M178 477.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M236.915 459.212H235.085C233.927 459.212 233 458.285 233 457.127V455.297C233 454.139 233.927 453.212 235.085 453.212H236.915C238.073 453.212 239 454.139 239 455.297V457.127C239 458.285 238.05 459.212 236.915 459.212Z",
    stroke: "#59B974",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6434 287.217L38.6074 289.03C38.5847 290.177 37.6487 291.076 36.5015 291.054L34.689 291.018C33.5418 290.995 32.6422 290.059 32.665 288.912L32.701 287.099C32.7238 285.952 33.6597 285.052 34.8069 285.075L36.6194 285.111C37.7666 285.134 38.6657 286.093 38.6434 287.217Z",
    stroke: "#59B974",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M243.915 459.212H242.085C240.927 459.212 240 458.285 240 457.127V455.297C240 454.139 240.927 453.212 242.085 453.212H243.915C245.073 453.212 246 454.139 246 455.297V457.127C246 458.285 245.05 459.212 243.915 459.212Z",
    stroke: "#59B974",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7811 280.284L38.7451 282.097C38.7224 283.244 37.7864 284.144 36.6392 284.121L34.8266 284.085C33.6795 284.062 32.7799 283.126 32.8027 281.979L32.8387 280.166C32.8615 279.019 33.7974 278.12 34.9446 278.143L36.7571 278.178C37.9043 278.201 38.8034 279.16 38.7811 280.284Z",
    stroke: "#59B974",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M417.915 450.212H416.085C414.927 450.212 414 449.285 414 448.127V446.297C414 445.139 414.927 444.212 416.085 444.212H417.915C419.073 444.212 420 445.139 420 446.297V448.127C420 449.285 419.073 450.212 417.915 450.212Z",
    stroke: "#59B974",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1006,
    y: 29.2119,
    width: 235,
    height: 197,
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 800.289,
    y: 479.692,
    width: 32.6803,
    height: 49.5205,
    stroke: "#2CAD39"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 800.289,
    y: 479.692,
    width: 32.6803,
    height: 16.8308,
    stroke: "#2CAD39"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 811.186,
    y: 484.645,
    width: 11.8778,
    height: 3.95299,
    stroke: "#2CAD39"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 804.251,
    y: 505.448,
    width: 24.7555,
    height: 15.8402,
    stroke: "#2CAD39"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 816.629,
    cy: 512.873,
    r: 15.3496,
    stroke: "#2CAD39"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 800.289,
    y: 530.213,
    width: 32.6803,
    height: 49.5205,
    stroke: "#2CAD39"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 800.289,
    y: 530.213,
    width: 32.6803,
    height: 16.8308,
    stroke: "#2CAD39"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 811.186,
    y: 535.166,
    width: 11.8778,
    height: 3.95299,
    stroke: "#2CAD39"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 804.251,
    y: 555.968,
    width: 24.7555,
    height: 15.8402,
    stroke: "#2CAD39"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 816.629,
    cy: 563.393,
    r: 15.3496,
    stroke: "#2CAD39"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 951.07,
    y: 479.692,
    width: 32.6803,
    height: 49.5205,
    stroke: "#2CAD39"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 951.07,
    y: 479.692,
    width: 32.6803,
    height: 16.8308,
    stroke: "#2CAD39"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 961.967,
    y: 484.645,
    width: 11.8778,
    height: 3.95299,
    stroke: "#2CAD39"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 955.032,
    y: 505.448,
    width: 24.7555,
    height: 15.8402,
    stroke: "#2CAD39"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 967.41,
    cy: 512.873,
    r: 15.3496,
    stroke: "#2CAD39"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 951.07,
    y: 530.213,
    width: 32.6803,
    height: 49.5205,
    stroke: "#2CAD39"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 951.07,
    y: 530.213,
    width: 32.6803,
    height: 16.8308,
    stroke: "#2CAD39"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 961.967,
    y: 535.166,
    width: 11.8778,
    height: 3.95299,
    stroke: "#2CAD39"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 955.032,
    y: 555.968,
    width: 24.7555,
    height: 15.8402,
    stroke: "#2CAD39"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 967.41,
    cy: 563.393,
    r: 15.3496,
    stroke: "#2CAD39"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 1101.85,
    y: 479.692,
    width: 32.6803,
    height: 49.5205,
    stroke: "#2CAD39"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 1101.85,
    y: 479.692,
    width: 32.6803,
    height: 16.8308,
    stroke: "#2CAD39"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 1112.75,
    y: 484.645,
    width: 11.8778,
    height: 3.95299,
    stroke: "#2CAD39"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 1105.81,
    y: 505.448,
    width: 24.7555,
    height: 15.8402,
    stroke: "#2CAD39"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1118.19,
    cy: 512.873,
    r: 15.3496,
    stroke: "#2CAD39"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 1101.85,
    y: 530.213,
    width: 32.6803,
    height: 49.5205,
    stroke: "#2CAD39"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 1101.85,
    y: 530.213,
    width: 32.6803,
    height: 16.8308,
    stroke: "#2CAD39"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 1112.75,
    y: 535.166,
    width: 11.8778,
    height: 3.95299,
    stroke: "#2CAD39"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 1105.81,
    y: 555.968,
    width: 24.7555,
    height: 15.8402,
    stroke: "#2CAD39"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1118.19,
    cy: 563.393,
    r: 15.3496,
    stroke: "#2CAD39"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 1252.63,
    y: 479.692,
    width: 32.6803,
    height: 49.5205,
    stroke: "#2CAD39"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 1252.63,
    y: 479.692,
    width: 32.6803,
    height: 16.8308,
    stroke: "#2CAD39"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 1263.53,
    y: 484.645,
    width: 11.8778,
    height: 3.95299,
    stroke: "#2CAD39"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 1256.6,
    y: 505.448,
    width: 24.7555,
    height: 15.8402,
    stroke: "#2CAD39"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 1268.97,
    cy: 512.873,
    r: 15.3496,
    stroke: "#2CAD39"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 1252.63,
    y: 530.213,
    width: 32.6803,
    height: 49.5205,
    stroke: "#2CAD39"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 1252.63,
    y: 530.213,
    width: 32.6803,
    height: 16.8308,
    stroke: "#2CAD39"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 1263.53,
    y: 535.166,
    width: 11.8778,
    height: 3.95299,
    stroke: "#2CAD39"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 1256.6,
    y: 555.968,
    width: 24.7555,
    height: 15.8402,
    stroke: "#2CAD39"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 1268.97,
    cy: 563.393,
    r: 15.3496,
    stroke: "#2CAD39"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 875.814,
    y: 479.692,
    width: 32.6803,
    height: 49.5205,
    stroke: "#2CAD39"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 875.814,
    y: 479.692,
    width: 32.6803,
    height: 16.8308,
    stroke: "#2CAD39"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 886.711,
    y: 484.645,
    width: 11.8778,
    height: 3.95299,
    stroke: "#2CAD39"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 879.776,
    y: 505.448,
    width: 24.7555,
    height: 15.8402,
    stroke: "#2CAD39"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 892.154,
    cy: 512.873,
    r: 15.3496,
    stroke: "#2CAD39"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 875.814,
    y: 530.213,
    width: 32.6803,
    height: 49.5205,
    stroke: "#2CAD39"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 875.814,
    y: 530.213,
    width: 32.6803,
    height: 16.8308,
    stroke: "#2CAD39"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 886.711,
    y: 535.166,
    width: 11.8778,
    height: 3.95299,
    stroke: "#2CAD39"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 879.776,
    y: 555.968,
    width: 24.7555,
    height: 15.8402,
    stroke: "#2CAD39"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 892.154,
    cy: 563.393,
    r: 15.3496,
    stroke: "#2CAD39"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 1026.6,
    y: 479.692,
    width: 32.6803,
    height: 49.5205,
    stroke: "#2CAD39"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 1026.6,
    y: 479.692,
    width: 32.6803,
    height: 16.8308,
    stroke: "#2CAD39"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 1037.49,
    y: 484.645,
    width: 11.8778,
    height: 3.95299,
    stroke: "#2CAD39"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 1030.56,
    y: 505.448,
    width: 24.7555,
    height: 15.8402,
    stroke: "#2CAD39"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 1042.94,
    cy: 512.873,
    r: 15.3496,
    stroke: "#2CAD39"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 1026.6,
    y: 530.213,
    width: 32.6803,
    height: 49.5205,
    stroke: "#2CAD39"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 1026.6,
    y: 530.213,
    width: 32.6803,
    height: 16.8308,
    stroke: "#2CAD39"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 1037.49,
    y: 535.166,
    width: 11.8778,
    height: 3.95299,
    stroke: "#2CAD39"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 1030.56,
    y: 555.968,
    width: 24.7555,
    height: 15.8402,
    stroke: "#2CAD39"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 1042.94,
    cy: 563.393,
    r: 15.3496,
    stroke: "#2CAD39"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 1177.38,
    y: 479.692,
    width: 32.6803,
    height: 49.5205,
    stroke: "#2CAD39"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 1177.38,
    y: 479.692,
    width: 32.6803,
    height: 16.8308,
    stroke: "#2CAD39"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 1188.27,
    y: 484.645,
    width: 11.8778,
    height: 3.95299,
    stroke: "#2CAD39"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 1181.34,
    y: 505.448,
    width: 24.7555,
    height: 15.8402,
    stroke: "#2CAD39"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 1193.72,
    cy: 512.873,
    r: 15.3496,
    stroke: "#2CAD39"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 1177.38,
    y: 530.213,
    width: 32.6803,
    height: 49.5205,
    stroke: "#2CAD39"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 1177.38,
    y: 530.213,
    width: 32.6803,
    height: 16.8308,
    stroke: "#2CAD39"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 1188.27,
    y: 535.166,
    width: 11.8778,
    height: 3.95299,
    stroke: "#2CAD39"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 1181.34,
    y: 555.968,
    width: 24.7555,
    height: 15.8402,
    stroke: "#2CAD39"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 1193.72,
    cy: 563.393,
    r: 15.3496,
    stroke: "#2CAD39"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 843,
    cy: 505.212,
    r: 5.5,
    stroke: "#2CAD39"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 843,
    cy: 555.212,
    r: 5.5,
    stroke: "#2CAD39"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 994,
    cy: 505.212,
    r: 5.5,
    stroke: "#2CAD39"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 994,
    cy: 555.212,
    r: 5.5,
    stroke: "#2CAD39"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 1145,
    cy: 505.212,
    r: 5.5,
    stroke: "#2CAD39"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 1145,
    cy: 555.212,
    r: 5.5,
    stroke: "#2CAD39"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 1296,
    cy: 505.212,
    r: 5.5,
    stroke: "#2CAD39"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 1296,
    cy: 555.212,
    r: 5.5,
    stroke: "#2CAD39"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 919,
    cy: 505.212,
    r: 5.5,
    stroke: "#2CAD39"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 919,
    cy: 555.212,
    r: 5.5,
    stroke: "#2CAD39"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 1070,
    cy: 505.212,
    r: 5.5,
    stroke: "#2CAD39"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 1070,
    cy: 555.212,
    r: 5.5,
    stroke: "#2CAD39"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M1225.5 505.212C1225.5 508.291 1223.22 510.712 1220.5 510.712C1217.78 510.712 1215.5 508.291 1215.5 505.212C1215.5 502.133 1217.78 499.712 1220.5 499.712C1223.22 499.712 1225.5 502.133 1225.5 505.212Z",
    stroke: "#2CAD39"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M1225.5 555.212C1225.5 558.291 1223.22 560.712 1220.5 560.712C1217.78 560.712 1215.5 558.291 1215.5 555.212C1215.5 552.133 1217.78 549.712 1220.5 549.712C1223.22 549.712 1225.5 552.133 1225.5 555.212Z",
    stroke: "#2CAD39"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 843,
    cy: 491.212,
    r: 5.5,
    stroke: "#2CAD39"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 843,
    cy: 541.212,
    r: 5.5,
    stroke: "#2CAD39"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 994,
    cy: 491.212,
    r: 5.5,
    stroke: "#2CAD39"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 994,
    cy: 541.212,
    r: 5.5,
    stroke: "#2CAD39"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 1145,
    cy: 491.212,
    r: 5.5,
    stroke: "#2CAD39"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 1145,
    cy: 541.212,
    r: 5.5,
    stroke: "#2CAD39"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 1296,
    cy: 491.212,
    r: 5.5,
    stroke: "#2CAD39"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 1296,
    cy: 541.212,
    r: 5.5,
    stroke: "#2CAD39"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 919,
    cy: 491.212,
    r: 5.5,
    stroke: "#2CAD39"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 919,
    cy: 541.212,
    r: 5.5,
    stroke: "#2CAD39"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 1070,
    cy: 491.212,
    r: 5.5,
    stroke: "#2CAD39"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 1070,
    cy: 541.212,
    r: 5.5,
    stroke: "#2CAD39"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M1225.5 491.212C1225.5 494.291 1223.22 496.712 1220.5 496.712C1217.78 496.712 1215.5 494.291 1215.5 491.212C1215.5 488.133 1217.78 485.712 1220.5 485.712C1223.22 485.712 1225.5 488.133 1225.5 491.212Z",
    stroke: "#2CAD39"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M1225.5 541.212C1225.5 544.291 1223.22 546.712 1220.5 546.712C1217.78 546.712 1215.5 544.291 1215.5 541.212C1215.5 538.133 1217.78 535.712 1220.5 535.712C1223.22 535.712 1225.5 538.133 1225.5 541.212Z",
    stroke: "#2CAD39"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 859,
    cy: 505.212,
    r: 5.5,
    stroke: "#2CAD39"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 859,
    cy: 555.212,
    r: 5.5,
    stroke: "#2CAD39"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 1010,
    cy: 505.212,
    r: 5.5,
    stroke: "#2CAD39"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 1010,
    cy: 555.212,
    r: 5.5,
    stroke: "#2CAD39"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 1161,
    cy: 505.212,
    r: 5.5,
    stroke: "#2CAD39"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 1161,
    cy: 555.212,
    r: 5.5,
    stroke: "#2CAD39"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 1312,
    cy: 505.212,
    r: 5.5,
    stroke: "#2CAD39"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 1312,
    cy: 555.212,
    r: 5.5,
    stroke: "#2CAD39"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 935,
    cy: 505.212,
    r: 5.5,
    stroke: "#2CAD39"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 935,
    cy: 555.212,
    r: 5.5,
    stroke: "#2CAD39"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M1090.5 505.212C1090.5 508.291 1088.22 510.712 1085.5 510.712C1082.78 510.712 1080.5 508.291 1080.5 505.212C1080.5 502.133 1082.78 499.712 1085.5 499.712C1088.22 499.712 1090.5 502.133 1090.5 505.212Z",
    stroke: "#2CAD39"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M1090.5 555.212C1090.5 558.291 1088.22 560.712 1085.5 560.712C1082.78 560.712 1080.5 558.291 1080.5 555.212C1080.5 552.133 1082.78 549.712 1085.5 549.712C1088.22 549.712 1090.5 552.133 1090.5 555.212Z",
    stroke: "#2CAD39"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 1236,
    cy: 505.212,
    r: 5.5,
    stroke: "#2CAD39"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 1236,
    cy: 555.212,
    r: 5.5,
    stroke: "#2CAD39"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 843,
    cy: 519.212,
    r: 5.5,
    stroke: "#2CAD39"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 843,
    cy: 569.212,
    r: 5.5,
    stroke: "#2CAD39"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 994,
    cy: 519.212,
    r: 5.5,
    stroke: "#2CAD39"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 994,
    cy: 569.212,
    r: 5.5,
    stroke: "#2CAD39"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 1145,
    cy: 519.212,
    r: 5.5,
    stroke: "#2CAD39"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 1145,
    cy: 569.212,
    r: 5.5,
    stroke: "#2CAD39"
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: 1296,
    cy: 519.212,
    r: 5.5,
    stroke: "#2CAD39"
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: 1296,
    cy: 569.212,
    r: 5.5,
    stroke: "#2CAD39"
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: 919,
    cy: 519.212,
    r: 5.5,
    stroke: "#2CAD39"
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: 919,
    cy: 569.212,
    r: 5.5,
    stroke: "#2CAD39"
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: 1070,
    cy: 519.212,
    r: 5.5,
    stroke: "#2CAD39"
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: 1070,
    cy: 569.212,
    r: 5.5,
    stroke: "#2CAD39"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M1225.5 519.212C1225.5 522.291 1223.22 524.712 1220.5 524.712C1217.78 524.712 1215.5 522.291 1215.5 519.212C1215.5 516.133 1217.78 513.712 1220.5 513.712C1223.22 513.712 1225.5 516.133 1225.5 519.212Z",
    stroke: "#2CAD39"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M1225.5 569.212C1225.5 572.291 1223.22 574.712 1220.5 574.712C1217.78 574.712 1215.5 572.291 1215.5 569.212C1215.5 566.133 1217.78 563.712 1220.5 563.712C1223.22 563.712 1225.5 566.133 1225.5 569.212Z",
    stroke: "#2CAD39"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M491.658 449.474V445.735H511.819V449.474",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M519.659 449.474V445.735H539.82V449.474",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M547.66 449.474V445.735H567.821V449.474",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M576.78 449.474V445.735H596.941V449.474",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M488.919 426.419V429.534H489.919V428.788H491.659V427.788H489.919V426.419H488.919Z",
    fill: "#2CAD39"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M516.92 426.419V429.534H517.92V428.788H519.66V427.788H517.92V426.419H516.92Z",
    fill: "#2CAD39"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M544.92 426.419V429.534H545.92V428.788H547.66V427.788H545.92V426.419H544.92Z",
    fill: "#2CAD39"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M574.04 426.419V429.534H575.04V428.788H576.78V427.788H575.04V426.419H574.04Z",
    fill: "#2CAD39"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M488.919 420.187V423.303H489.919V422.556H491.659V421.556H489.919V420.187H488.919Z",
    fill: "#2CAD39"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M516.92 420.187V423.303H517.92V422.556H519.66V421.556H517.92V420.187H516.92Z",
    fill: "#2CAD39"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M544.92 420.187V423.303H545.92V422.556H547.66V421.556H545.92V420.187H544.92Z",
    fill: "#2CAD39"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M574.04 420.187V423.303H575.04V422.556H576.78V421.556H575.04V420.187H574.04Z",
    fill: "#2CAD39"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M488.919 433.897V437.012H489.919V436.266H491.659V435.266H489.919V433.897H488.919Z",
    fill: "#2CAD39"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M516.92 433.897V437.012H517.92V436.266H519.66V435.266H517.92V433.897H516.92Z",
    fill: "#2CAD39"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M544.92 433.897V437.012H545.92V436.266H547.66V435.266H545.92V433.897H544.92Z",
    fill: "#2CAD39"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M574.04 433.897V437.012H575.04V436.266H576.78V435.266H575.04V433.897H574.04Z",
    fill: "#2CAD39"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M512.879 426.419V429.534H511.879V428.788H510.139V427.788H511.879V426.419H512.879Z",
    fill: "#2CAD39"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M540.88 426.419V429.534H539.88V428.788H538.14V427.788H539.88V426.419H540.88Z",
    fill: "#2CAD39"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M568.88 426.419V429.534H567.88V428.788H566.14V427.788H567.88V426.419H568.88Z",
    fill: "#2CAD39"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M598.001 426.419V429.534H597.001V428.788H595.261V427.788H597.001V426.419H598.001Z",
    fill: "#2CAD39"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M512.879 420.187V423.303H511.879V422.556H510.139V421.556H511.879V420.187H512.879Z",
    fill: "#2CAD39"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M540.88 420.187V423.303H539.88V422.556H538.14V421.556H539.88V420.187H540.88Z",
    fill: "#2CAD39"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M568.88 420.187V423.303H567.88V422.556H566.14V421.556H567.88V420.187H568.88Z",
    fill: "#2CAD39"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M598.001 420.187V423.303H597.001V422.556H595.261V421.556H597.001V420.187H598.001Z",
    fill: "#2CAD39"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M512.879 433.897V437.012H511.879V436.266H510.139V435.266H511.879V433.897H512.879Z",
    fill: "#2CAD39"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M540.88 433.897V437.012H539.88V436.266H538.14V435.266H539.88V433.897H540.88Z",
    fill: "#2CAD39"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M568.88 433.897V437.012H567.88V436.266H566.14V435.266H567.88V433.897H568.88Z",
    fill: "#2CAD39"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M598.001 433.897V437.012H597.001V436.266H595.261V435.266H597.001V433.897H598.001Z",
    fill: "#2CAD39"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M488.299 410.841V413.333H513.499V410.841",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M516.299 410.841V413.333H541.499V410.841",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M544.3 410.841V413.333H569.5V410.841",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M573.421 410.841V413.333H598.621V410.841",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M488.859 446.358V443.866H514.06V446.358",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M516.859 446.358V443.866H542.06V446.358",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M544.86 446.358V443.866H570.061V446.358",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M573.98 446.358V443.866H599.181V446.358",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M488.859 415.826H491.659V440.75H489.419",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M516.859 415.826H519.659V440.75H517.419",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M544.86 415.826H547.66V440.75H545.42",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M573.98 415.826H576.781V440.75H574.54",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M512.939 416.449H510.139V441.373H512.379",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M540.939 416.449H538.139V441.373H540.379",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M568.94 416.449H566.14V441.373H568.38",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M598.062 416.449H595.261V441.373H597.502",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M493.339 427.665V417.072H507.899V427.665",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M521.339 427.665V417.072H535.899V427.665",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M549.34 427.665V417.072H563.9V427.665",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M578.461 427.665V417.072H593.021V427.665",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M493.339 441.996V431.403H507.899V441.996",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M521.339 441.996V431.403H535.899V441.996",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M549.34 441.996V431.403H563.9V441.996",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M578.461 441.996V431.403H593.021V441.996",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M491.658 414.58V410.842H511.819V414.58",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M519.659 414.58V410.842H539.82V414.58",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M547.66 414.58V410.842H567.821V414.58",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M576.78 414.58V410.842H596.941V414.58",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M488.919 391.525V394.641H489.919V393.894H491.659V392.894H489.919V391.525H488.919Z",
    fill: "#59B974"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M516.92 391.525V394.641H517.92V393.894H519.66V392.894H517.92V391.525H516.92Z",
    fill: "#59B974"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M544.92 391.525V394.641H545.92V393.894H547.66V392.894H545.92V391.525H544.92Z",
    fill: "#59B974"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M574.04 391.525V394.641H575.04V393.894H576.78V392.894H575.04V391.525H574.04Z",
    fill: "#59B974"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M488.919 385.294V388.409H489.919V387.663H491.659V386.663H489.919V385.294H488.919Z",
    fill: "#59B974"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M516.92 385.294V388.409H517.92V387.663H519.66V386.663H517.92V385.294H516.92Z",
    fill: "#59B974"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M544.92 385.294V388.409H545.92V387.663H547.66V386.663H545.92V385.294H544.92Z",
    fill: "#59B974"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M574.04 385.294V388.409H575.04V387.663H576.78V386.663H575.04V385.294H574.04Z",
    fill: "#59B974"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M488.919 399.002V402.118H489.919V401.371H491.659V400.371H489.919V399.002H488.919Z",
    fill: "#59B974"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M516.92 399.002V402.118H517.92V401.371H519.66V400.371H517.92V399.002H516.92Z",
    fill: "#59B974"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M544.92 399.002V402.118H545.92V401.371H547.66V400.371H545.92V399.002H544.92Z",
    fill: "#59B974"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M574.04 399.002V402.118H575.04V401.371H576.78V400.371H575.04V399.002H574.04Z",
    fill: "#59B974"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M512.879 391.525V394.641H511.879V393.894H510.139V392.894H511.879V391.525H512.879Z",
    fill: "#59B974"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M540.88 391.525V394.641H539.88V393.894H538.14V392.894H539.88V391.525H540.88Z",
    fill: "#59B974"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M568.88 391.525V394.641H567.88V393.894H566.14V392.894H567.88V391.525H568.88Z",
    fill: "#59B974"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M598.001 391.525V394.641H597.001V393.894H595.261V392.894H597.001V391.525H598.001Z",
    fill: "#59B974"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M512.879 385.294V388.409H511.879V387.663H510.139V386.663H511.879V385.294H512.879Z",
    fill: "#59B974"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M540.88 385.294V388.409H539.88V387.663H538.14V386.663H539.88V385.294H540.88Z",
    fill: "#59B974"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M568.88 385.294V388.409H567.88V387.663H566.14V386.663H567.88V385.294H568.88Z",
    fill: "#59B974"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M598.001 385.294V388.409H597.001V387.663H595.261V386.663H597.001V385.294H598.001Z",
    fill: "#59B974"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M512.879 399.002V402.118H511.879V401.371H510.139V400.371H511.879V399.002H512.879Z",
    fill: "#59B974"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M540.88 399.002V402.118H539.88V401.371H538.14V400.371H539.88V399.002H540.88Z",
    fill: "#59B974"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M568.88 399.002V402.118H567.88V401.371H566.14V400.371H567.88V399.002H568.88Z",
    fill: "#59B974"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M598.001 399.002V402.118H597.001V401.371H595.261V400.371H597.001V399.002H598.001Z",
    fill: "#59B974"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M488.299 375.947V378.44H513.499V375.947",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M516.299 375.947V378.44H541.499V375.947",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M544.3 375.947V378.44H569.5V375.947",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M573.421 375.947V378.44H598.621V375.947",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M488.859 411.465V408.972H514.06V411.465",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M516.859 411.465V408.972H542.06V411.465",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M544.86 411.465V408.972H570.061V411.465",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M573.98 411.465V408.972H599.181V411.465",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M488.859 380.932H491.659V405.857H489.419",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M516.859 380.932H519.659V405.857H517.419",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M544.86 380.932H547.66V405.857H545.42",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M573.98 380.932H576.781V405.857H574.54",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M512.939 381.555H510.139V406.48H512.379",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M540.939 381.555H538.139V406.48H540.379",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M568.94 381.555H566.14V406.48H568.38",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M598.062 381.555H595.261V406.48H597.502",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M493.339 392.771V382.178H507.899V392.771",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M521.339 392.771V382.178H535.899V392.771",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M549.34 392.771V382.178H563.9V392.771",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M578.461 392.771V382.178H593.021V392.771",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M493.339 407.103V396.51H507.899V407.103",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M521.339 407.103V396.51H535.899V407.103",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M549.34 407.103V396.51H563.9V407.103",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M578.461 407.103V396.51H593.021V407.103",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M491.658 379.685V375.946H511.819V379.685",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M519.659 379.685V375.946H539.82V379.685",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M547.66 379.685V375.946H567.821V379.685",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M576.78 379.685V375.946H596.941V379.685",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M488.919 356.63V359.745H489.919V358.999H491.659V357.999H489.919V356.63H488.919Z",
    fill: "#59B974"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M516.92 356.63V359.745H517.92V358.999H519.66V357.999H517.92V356.63H516.92Z",
    fill: "#59B974"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M544.92 356.63V359.745H545.92V358.999H547.66V357.999H545.92V356.63H544.92Z",
    fill: "#59B974"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M574.04 356.63V359.745H575.04V358.999H576.78V357.999H575.04V356.63H574.04Z",
    fill: "#59B974"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M488.919 350.399V353.514H489.919V352.768H491.659V351.768H489.919V350.399H488.919Z",
    fill: "#59B974"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M516.92 350.399V353.514H517.92V352.768H519.66V351.768H517.92V350.399H516.92Z",
    fill: "#59B974"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M544.92 350.399V353.514H545.92V352.768H547.66V351.768H545.92V350.399H544.92Z",
    fill: "#59B974"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M574.04 350.399V353.514H575.04V352.768H576.78V351.768H575.04V350.399H574.04Z",
    fill: "#59B974"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M488.919 364.107V367.223H489.919V366.476H491.659V365.476H489.919V364.107H488.919Z",
    fill: "#59B974"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M516.92 364.107V367.223H517.92V366.476H519.66V365.476H517.92V364.107H516.92Z",
    fill: "#59B974"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M544.92 364.107V367.223H545.92V366.476H547.66V365.476H545.92V364.107H544.92Z",
    fill: "#59B974"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M574.04 364.107V367.223H575.04V366.476H576.78V365.476H575.04V364.107H574.04Z",
    fill: "#59B974"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M512.879 356.63V359.745H511.879V358.999H510.139V357.999H511.879V356.63H512.879Z",
    fill: "#59B974"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M540.88 356.63V359.745H539.88V358.999H538.14V357.999H539.88V356.63H540.88Z",
    fill: "#59B974"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M568.88 356.63V359.745H567.88V358.999H566.14V357.999H567.88V356.63H568.88Z",
    fill: "#59B974"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M598.001 356.63V359.745H597.001V358.999H595.261V357.999H597.001V356.63H598.001Z",
    fill: "#59B974"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M512.879 350.399V353.514H511.879V352.768H510.139V351.768H511.879V350.399H512.879Z",
    fill: "#59B974"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M540.88 350.399V353.514H539.88V352.768H538.14V351.768H539.88V350.399H540.88Z",
    fill: "#59B974"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M568.88 350.399V353.514H567.88V352.768H566.14V351.768H567.88V350.399H568.88Z",
    fill: "#59B974"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M598.001 350.399V353.514H597.001V352.768H595.261V351.768H597.001V350.399H598.001Z",
    fill: "#59B974"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M512.879 364.107V367.223H511.879V366.476H510.139V365.476H511.879V364.107H512.879Z",
    fill: "#59B974"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M540.88 364.107V367.223H539.88V366.476H538.14V365.476H539.88V364.107H540.88Z",
    fill: "#59B974"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M568.88 364.107V367.223H567.88V366.476H566.14V365.476H567.88V364.107H568.88Z",
    fill: "#59B974"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M598.001 364.107V367.223H597.001V366.476H595.261V365.476H597.001V364.107H598.001Z",
    fill: "#59B974"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M488.299 341.052V343.544H513.499V341.052",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M516.299 341.052V343.544H541.499V341.052",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M544.3 341.052V343.544H569.5V341.052",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M573.421 341.052V343.544H598.621V341.052",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M488.859 376.569V374.077H514.06V376.569",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M516.859 376.569V374.077H542.06V376.569",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M544.86 376.569V374.077H570.061V376.569",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M573.98 376.569V374.077H599.181V376.569",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M488.859 346.037H491.659V370.961H489.419",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M516.859 346.037H519.659V370.961H517.419",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M544.86 346.037H547.66V370.961H545.42",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M573.98 346.037H576.781V370.961H574.54",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M512.939 346.66H510.139V371.584H512.379",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M540.939 346.66H538.139V371.584H540.379",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M568.94 346.66H566.14V371.584H568.38",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M598.062 346.66H595.261V371.584H597.502",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M493.339 357.876V347.283H507.899V357.876",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M521.339 357.876V347.283H535.899V357.876",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M549.34 357.876V347.283H563.9V357.876",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M578.461 357.876V347.283H593.021V357.876",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M493.339 372.207V361.614H507.899V372.207",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M521.339 372.207V361.614H535.899V372.207",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M549.34 372.207V361.614H563.9V372.207",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M578.461 372.207V361.614H593.021V372.207",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M491.658 344.79V341.052H511.819V344.79",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M519.659 344.79V341.052H539.82V344.79",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M547.66 344.79V341.052H567.821V344.79",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M576.78 344.79V341.052H596.941V344.79",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M488.919 321.734V324.85H489.919V324.103H491.659V323.103H489.919V321.734H488.919Z",
    fill: "#59B974"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M516.92 321.734V324.85H517.92V324.103H519.66V323.103H517.92V321.734H516.92Z",
    fill: "#59B974"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M544.92 321.734V324.85H545.92V324.103H547.66V323.103H545.92V321.734H544.92Z",
    fill: "#59B974"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M574.04 321.734V324.85H575.04V324.103H576.78V323.103H575.04V321.734H574.04Z",
    fill: "#59B974"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M488.919 315.504V318.62H489.919V317.873H491.659V316.873H489.919V315.504H488.919Z",
    fill: "#59B974"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M516.92 315.504V318.62H517.92V317.873H519.66V316.873H517.92V315.504H516.92Z",
    fill: "#59B974"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M544.92 315.504V318.62H545.92V317.873H547.66V316.873H545.92V315.504H544.92Z",
    fill: "#59B974"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M574.04 315.504V318.62H575.04V317.873H576.78V316.873H575.04V315.504H574.04Z",
    fill: "#59B974"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M488.919 329.213V332.328H489.919V331.582H491.659V330.582H489.919V329.213H488.919Z",
    fill: "#59B974"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M516.92 329.213V332.328H517.92V331.582H519.66V330.582H517.92V329.213H516.92Z",
    fill: "#59B974"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M544.92 329.213V332.328H545.92V331.582H547.66V330.582H545.92V329.213H544.92Z",
    fill: "#59B974"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M574.04 329.213V332.328H575.04V331.582H576.78V330.582H575.04V329.213H574.04Z",
    fill: "#59B974"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M512.879 321.734V324.85H511.879V324.103H510.139V323.103H511.879V321.734H512.879Z",
    fill: "#59B974"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M540.88 321.734V324.85H539.88V324.103H538.14V323.103H539.88V321.734H540.88Z",
    fill: "#59B974"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M568.88 321.734V324.85H567.88V324.103H566.14V323.103H567.88V321.734H568.88Z",
    fill: "#59B974"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M598.001 321.734V324.85H597.001V324.103H595.261V323.103H597.001V321.734H598.001Z",
    fill: "#59B974"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M512.879 315.504V318.62H511.879V317.873H510.139V316.873H511.879V315.504H512.879Z",
    fill: "#59B974"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M540.88 315.504V318.62H539.88V317.873H538.14V316.873H539.88V315.504H540.88Z",
    fill: "#59B974"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M568.88 315.504V318.62H567.88V317.873H566.14V316.873H567.88V315.504H568.88Z",
    fill: "#59B974"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M598.001 315.504V318.62H597.001V317.873H595.261V316.873H597.001V315.504H598.001Z",
    fill: "#59B974"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M512.879 329.213V332.328H511.879V331.582H510.139V330.582H511.879V329.213H512.879Z",
    fill: "#59B974"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M540.88 329.213V332.328H539.88V331.582H538.14V330.582H539.88V329.213H540.88Z",
    fill: "#59B974"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M568.88 329.213V332.328H567.88V331.582H566.14V330.582H567.88V329.213H568.88Z",
    fill: "#59B974"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M598.001 329.213V332.328H597.001V331.582H595.261V330.582H597.001V329.213H598.001Z",
    fill: "#59B974"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M488.299 306.157V308.65H513.499V306.157",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M516.299 306.157V308.65H541.499V306.157",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M544.3 306.157V308.65H569.5V306.157",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M573.421 306.157V308.65H598.621V306.157",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M488.859 341.675V339.182H514.06V341.675",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M516.859 341.675V339.182H542.06V341.675",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M544.86 341.675V339.182H570.061V341.675",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M573.98 341.675V339.182H599.181V341.675",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M488.859 311.142H491.659V336.067H489.419",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M516.859 311.142H519.659V336.067H517.419",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M544.86 311.142H547.66V336.067H545.42",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M573.98 311.142H576.781V336.067H574.54",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M512.939 311.765H510.139V336.69H512.379",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M540.939 311.765H538.139V336.69H540.379",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M568.94 311.765H566.14V336.69H568.38",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M598.062 311.765H595.261V336.69H597.502",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M493.339 322.981V312.388H507.899V322.981",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M521.339 322.981V312.388H535.899V322.981",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M549.34 322.981V312.388H563.9V322.981",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M578.461 322.981V312.388H593.021V322.981",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M493.339 337.313V326.72H507.899V337.313",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M521.339 337.313V326.72H535.899V337.313",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M549.34 337.313V326.72H563.9V337.313",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M578.461 337.313V326.72H593.021V337.313",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M491.658 309.896V306.157H511.819V309.896",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M519.659 309.896V306.157H539.82V309.896",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M547.66 309.896V306.157H567.821V309.896",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M576.78 309.896V306.157H596.941V309.896",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M488.919 286.84V289.956H489.919V289.209H491.659V288.209H489.919V286.84H488.919Z",
    fill: "#59B974"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M516.92 286.84V289.956H517.92V289.209H519.66V288.209H517.92V286.84H516.92Z",
    fill: "#59B974"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M544.92 286.84V289.956H545.92V289.209H547.66V288.209H545.92V286.84H544.92Z",
    fill: "#59B974"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M574.04 286.84V289.956H575.04V289.209H576.78V288.209H575.04V286.84H574.04Z",
    fill: "#59B974"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M488.919 280.61V283.725H489.919V282.979H491.659V281.979H489.919V280.61H488.919Z",
    fill: "#59B974"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M516.92 280.61V283.725H517.92V282.979H519.66V281.979H517.92V280.61H516.92Z",
    fill: "#59B974"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M544.92 280.61V283.725H545.92V282.979H547.66V281.979H545.92V280.61H544.92Z",
    fill: "#59B974"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M574.04 280.61V283.725H575.04V282.979H576.78V281.979H575.04V280.61H574.04Z",
    fill: "#59B974"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M488.919 294.318V297.434H489.919V296.687H491.659V295.687H489.919V294.318H488.919Z",
    fill: "#59B974"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M516.92 294.318V297.434H517.92V296.687H519.66V295.687H517.92V294.318H516.92Z",
    fill: "#59B974"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M544.92 294.318V297.434H545.92V296.687H547.66V295.687H545.92V294.318H544.92Z",
    fill: "#59B974"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M574.04 294.318V297.434H575.04V296.687H576.78V295.687H575.04V294.318H574.04Z",
    fill: "#59B974"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M512.879 286.84V289.956H511.879V289.209H510.139V288.209H511.879V286.84H512.879Z",
    fill: "#59B974"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M540.88 286.84V289.956H539.88V289.209H538.14V288.209H539.88V286.84H540.88Z",
    fill: "#59B974"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M568.88 286.84V289.956H567.88V289.209H566.14V288.209H567.88V286.84H568.88Z",
    fill: "#59B974"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M598.001 286.84V289.956H597.001V289.209H595.261V288.209H597.001V286.84H598.001Z",
    fill: "#59B974"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M512.879 280.61V283.725H511.879V282.979H510.139V281.979H511.879V280.61H512.879Z",
    fill: "#59B974"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M540.88 280.61V283.725H539.88V282.979H538.14V281.979H539.88V280.61H540.88Z",
    fill: "#59B974"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M568.88 280.61V283.725H567.88V282.979H566.14V281.979H567.88V280.61H568.88Z",
    fill: "#59B974"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M598.001 280.61V283.725H597.001V282.979H595.261V281.979H597.001V280.61H598.001Z",
    fill: "#59B974"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M512.879 294.318V297.434H511.879V296.687H510.139V295.687H511.879V294.318H512.879Z",
    fill: "#59B974"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M540.88 294.318V297.434H539.88V296.687H538.14V295.687H539.88V294.318H540.88Z",
    fill: "#59B974"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M568.88 294.318V297.434H567.88V296.687H566.14V295.687H567.88V294.318H568.88Z",
    fill: "#59B974"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M598.001 294.318V297.434H597.001V296.687H595.261V295.687H597.001V294.318H598.001Z",
    fill: "#59B974"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M488.299 271.263V273.755H513.499V271.263",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M516.299 271.263V273.755H541.499V271.263",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M544.3 271.263V273.755H569.5V271.263",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M573.421 271.263V273.755H598.621V271.263",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M488.859 306.78V304.288H514.06V306.78",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M516.859 306.78V304.288H542.06V306.78",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M544.86 306.78V304.288H570.061V306.78",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M573.98 306.78V304.288H599.181V306.78",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M488.859 276.248H491.659V301.172H489.419",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M516.859 276.248H519.659V301.172H517.419",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M544.86 276.248H547.66V301.172H545.42",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M573.98 276.248H576.781V301.172H574.54",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M512.939 276.871H510.139V301.795H512.379",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M540.939 276.871H538.139V301.795H540.379",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M568.94 276.871H566.14V301.795H568.38",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M598.062 276.871H595.261V301.795H597.502",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M493.339 288.087V277.494H507.899V288.087",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M521.339 288.087V277.494H535.899V288.087",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M549.34 288.087V277.494H563.9V288.087",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M578.461 288.087V277.494H593.021V288.087",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M493.339 302.418V291.825H507.899V302.418",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M521.339 302.418V291.825H535.899V302.418",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M549.34 302.418V291.825H563.9V302.418",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M578.461 302.418V291.825H593.021V302.418",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M1098.89 449.474V445.735H1119.05V449.474",
    stroke: "#2CAD39",
    strokeWidth: 1.5
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M1126.9 449.474V445.735H1147.06V449.474",
    stroke: "#2CAD39",
    strokeWidth: 1.5
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M1154.9 449.474V445.735H1175.06V449.474",
    stroke: "#2CAD39",
    strokeWidth: 1.5
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M1184.02 449.474V445.735H1204.18V449.474",
    stroke: "#2CAD39",
    strokeWidth: 1.5
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1096.16 426.419V429.534H1097.16V428.788H1098.9V427.788H1097.16V426.419H1096.16Z",
    fill: "#59B974"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1124.16 426.419V429.534H1125.16V428.788H1126.9V427.788H1125.16V426.419H1124.16Z",
    fill: "#59B974"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1152.16 426.419V429.534H1153.16V428.788H1154.9V427.788H1153.16V426.419H1152.16Z",
    fill: "#59B974"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1181.28 426.419V429.534H1182.28V428.788H1184.02V427.788H1182.28V426.419H1181.28Z",
    fill: "#59B974"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1096.16 420.187V423.303H1097.16V422.556H1098.9V421.556H1097.16V420.187H1096.16Z",
    fill: "#59B974"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1124.16 420.187V423.303H1125.16V422.556H1126.9V421.556H1125.16V420.187H1124.16Z",
    fill: "#59B974"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1152.16 420.187V423.303H1153.16V422.556H1154.9V421.556H1153.16V420.187H1152.16Z",
    fill: "#59B974"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1181.28 420.187V423.303H1182.28V422.556H1184.02V421.556H1182.28V420.187H1181.28Z",
    fill: "#59B974"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1096.16 433.897V437.012H1097.16V436.266H1098.9V435.266H1097.16V433.897H1096.16Z",
    fill: "#59B974"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1124.16 433.897V437.012H1125.16V436.266H1126.9V435.266H1125.16V433.897H1124.16Z",
    fill: "#59B974"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1152.16 433.897V437.012H1153.16V436.266H1154.9V435.266H1153.16V433.897H1152.16Z",
    fill: "#59B974"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1181.28 433.897V437.012H1182.28V436.266H1184.02V435.266H1182.28V433.897H1181.28Z",
    fill: "#59B974"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1120.12 426.419V429.534H1119.12V428.788H1117.38V427.788H1119.12V426.419H1120.12Z",
    fill: "#59B974"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1148.12 426.419V429.534H1147.12V428.788H1145.38V427.788H1147.12V426.419H1148.12Z",
    fill: "#59B974"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1176.12 426.419V429.534H1175.12V428.788H1173.38V427.788H1175.12V426.419H1176.12Z",
    fill: "#59B974"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1205.24 426.419V429.534H1204.24V428.788H1202.5V427.788H1204.24V426.419H1205.24Z",
    fill: "#59B974"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1120.12 420.187V423.303H1119.12V422.556H1117.38V421.556H1119.12V420.187H1120.12Z",
    fill: "#59B974"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1148.12 420.187V423.303H1147.12V422.556H1145.38V421.556H1147.12V420.187H1148.12Z",
    fill: "#59B974"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1176.12 420.187V423.303H1175.12V422.556H1173.38V421.556H1175.12V420.187H1176.12Z",
    fill: "#59B974"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1205.24 420.187V423.303H1204.24V422.556H1202.5V421.556H1204.24V420.187H1205.24Z",
    fill: "#59B974"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1120.12 433.897V437.012H1119.12V436.266H1117.38V435.266H1119.12V433.897H1120.12Z",
    fill: "#59B974"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1148.12 433.897V437.012H1147.12V436.266H1145.38V435.266H1147.12V433.897H1148.12Z",
    fill: "#59B974"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1176.12 433.897V437.012H1175.12V436.266H1173.38V435.266H1175.12V433.897H1176.12Z",
    fill: "#59B974"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1205.24 433.897V437.012H1204.24V436.266H1202.5V435.266H1204.24V433.897H1205.24Z",
    fill: "#59B974"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M1095.54 410.841V413.333H1120.74V410.841",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M1123.54 410.841V413.333H1148.74V410.841",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M1151.54 410.841V413.333H1176.74V410.841",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M1180.66 410.841V413.333H1205.86V410.841",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M1096.1 446.358V443.866H1121.3V446.358",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M1124.1 446.358V443.866H1149.3V446.358",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M1152.1 446.358V443.866H1177.3V446.358",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M1181.22 446.358V443.866H1206.42V446.358",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M1096.1 415.826H1098.9V440.75H1096.66",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M1124.1 415.826H1126.9V440.75H1124.66",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M1152.1 415.826H1154.9V440.75H1152.66",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M1181.22 415.826H1184.02V440.75H1181.78",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M1120.18 416.449H1117.38V441.373H1119.62",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M1148.18 416.449H1145.38V441.373H1147.62",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M1176.18 416.449H1173.38V441.373H1175.62",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M1205.3 416.449H1202.5V441.373H1204.74",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M1100.58 427.665V417.072H1115.14V427.665",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M1128.58 427.665V417.072H1143.14V427.665",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M1156.58 427.665V417.072H1171.14V427.665",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M1185.7 427.665V417.072H1200.26V427.665",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M1100.58 441.996V431.403H1115.14V441.996",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M1128.58 441.996V431.403H1143.14V441.996",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M1156.58 441.996V431.403H1171.14V441.996",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M1185.7 441.996V431.403H1200.26V441.996",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M802.058 449.474V445.735H822.218V449.474",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M830.059 449.474V445.735H850.219V449.474",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M858.06 449.474V445.735H878.22V449.474",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M887.18 449.474V445.735H907.34V449.474",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M799.318 426.419V429.534H800.318V428.788H802.058V427.788H800.318V426.419H799.318Z",
    fill: "#59B974"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M827.318 426.419V429.534H828.318V428.788H830.058V427.788H828.318V426.419H827.318Z",
    fill: "#59B974"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M855.319 426.419V429.534H856.319V428.788H858.059V427.788H856.319V426.419H855.319Z",
    fill: "#59B974"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M884.439 426.419V429.534H885.439V428.788H887.179V427.788H885.439V426.419H884.439Z",
    fill: "#59B974"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M799.318 420.187V423.303H800.318V422.556H802.058V421.556H800.318V420.187H799.318Z",
    fill: "#59B974"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M827.318 420.187V423.303H828.318V422.556H830.058V421.556H828.318V420.187H827.318Z",
    fill: "#59B974"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M855.319 420.187V423.303H856.319V422.556H858.059V421.556H856.319V420.187H855.319Z",
    fill: "#59B974"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M884.439 420.187V423.303H885.439V422.556H887.179V421.556H885.439V420.187H884.439Z",
    fill: "#59B974"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M799.318 433.897V437.012H800.318V436.266H802.058V435.266H800.318V433.897H799.318Z",
    fill: "#59B974"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M827.318 433.897V437.012H828.318V436.266H830.058V435.266H828.318V433.897H827.318Z",
    fill: "#59B974"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M855.319 433.897V437.012H856.319V436.266H858.059V435.266H856.319V433.897H855.319Z",
    fill: "#59B974"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M884.439 433.897V437.012H885.439V436.266H887.179V435.266H885.439V433.897H884.439Z",
    fill: "#59B974"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M823.278 426.419V429.534H822.278V428.788H820.538V427.788H822.278V426.419H823.278Z",
    fill: "#59B974"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M851.279 426.419V429.534H850.279V428.788H848.539V427.788H850.279V426.419H851.279Z",
    fill: "#59B974"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M879.279 426.419V429.534H878.279V428.788H876.539V427.788H878.279V426.419H879.279Z",
    fill: "#59B974"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M908.4 426.419V429.534H907.4V428.788H905.66V427.788H907.4V426.419H908.4Z",
    fill: "#59B974"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M823.278 420.187V423.303H822.278V422.556H820.538V421.556H822.278V420.187H823.278Z",
    fill: "#59B974"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M851.279 420.187V423.303H850.279V422.556H848.539V421.556H850.279V420.187H851.279Z",
    fill: "#59B974"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M879.279 420.187V423.303H878.279V422.556H876.539V421.556H878.279V420.187H879.279Z",
    fill: "#59B974"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M908.4 420.187V423.303H907.4V422.556H905.66V421.556H907.4V420.187H908.4Z",
    fill: "#59B974"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M823.278 433.897V437.012H822.278V436.266H820.538V435.266H822.278V433.897H823.278Z",
    fill: "#59B974"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M851.279 433.897V437.012H850.279V436.266H848.539V435.266H850.279V433.897H851.279Z",
    fill: "#59B974"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M879.279 433.897V437.012H878.279V436.266H876.539V435.266H878.279V433.897H879.279Z",
    fill: "#59B974"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M908.4 433.897V437.012H907.4V436.266H905.66V435.266H907.4V433.897H908.4Z",
    fill: "#59B974"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M798.698 410.841V413.333H823.899V410.841",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M826.698 410.841V413.333H851.899V410.841",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M854.699 410.841V413.333H879.9V410.841",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M883.82 410.841V413.333H909.021V410.841",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M799.259 446.358V443.866H824.459V446.358",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M827.259 446.358V443.866H852.459V446.358",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M855.26 446.358V443.866H880.46V446.358",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M884.38 446.358V443.866H909.58V446.358",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M799.259 415.826H802.059V440.75H799.819",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M827.259 415.826H830.059V440.75H827.819",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M855.26 415.826H858.06V440.75H855.82",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M884.38 415.826H887.18V440.75H884.94",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M823.339 416.449H820.539V441.373H822.779",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M851.339 416.449H848.539V441.373H850.779",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M879.34 416.449H876.54V441.373H878.78",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M908.461 416.449H905.661V441.373H907.901",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M803.738 427.665V417.072H818.299V427.665",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M831.738 427.665V417.072H846.299V427.665",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M859.739 427.665V417.072H874.3V427.665",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M888.86 427.665V417.072H903.421V427.665",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M803.738 441.996V431.403H818.299V441.996",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M831.738 441.996V431.403H846.299V441.996",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M859.739 441.996V431.403H874.3V441.996",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M888.86 441.996V431.403H903.421V441.996",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M802.058 413.333V409.595H822.218V413.333",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M830.059 413.333V409.595H850.219V413.333",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M858.06 413.333V409.595H878.22V413.333",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M887.18 413.333V409.595H907.34V413.333",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M799.318 390.278V393.394H800.318V392.647H802.058V391.647H800.318V390.278H799.318Z",
    fill: "#59B974"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M827.318 390.278V393.394H828.318V392.647H830.058V391.647H828.318V390.278H827.318Z",
    fill: "#59B974"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M855.319 390.278V393.394H856.319V392.647H858.059V391.647H856.319V390.278H855.319Z",
    fill: "#59B974"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M884.439 390.278V393.394H885.439V392.647H887.179V391.647H885.439V390.278H884.439Z",
    fill: "#59B974"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M799.318 384.047V387.162H800.318V386.416H802.058V385.416H800.318V384.047H799.318Z",
    fill: "#59B974"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M827.318 384.047V387.162H828.318V386.416H830.058V385.416H828.318V384.047H827.318Z",
    fill: "#59B974"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M855.319 384.047V387.162H856.319V386.416H858.059V385.416H856.319V384.047H855.319Z",
    fill: "#59B974"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M884.439 384.047V387.162H885.439V386.416H887.179V385.416H885.439V384.047H884.439Z",
    fill: "#59B974"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M799.318 397.755V400.871H800.318V400.124H802.058V399.124H800.318V397.755H799.318Z",
    fill: "#59B974"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M827.318 397.755V400.871H828.318V400.124H830.058V399.124H828.318V397.755H827.318Z",
    fill: "#59B974"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M855.319 397.755V400.871H856.319V400.124H858.059V399.124H856.319V397.755H855.319Z",
    fill: "#59B974"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M884.439 397.755V400.871H885.439V400.124H887.179V399.124H885.439V397.755H884.439Z",
    fill: "#59B974"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M823.278 390.278V393.394H822.278V392.647H820.538V391.647H822.278V390.278H823.278Z",
    fill: "#59B974"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M851.279 390.278V393.394H850.279V392.647H848.539V391.647H850.279V390.278H851.279Z",
    fill: "#59B974"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M879.279 390.278V393.394H878.279V392.647H876.539V391.647H878.279V390.278H879.279Z",
    fill: "#59B974"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M908.4 390.278V393.394H907.4V392.647H905.66V391.647H907.4V390.278H908.4Z",
    fill: "#59B974"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M823.278 384.047V387.162H822.278V386.416H820.538V385.416H822.278V384.047H823.278Z",
    fill: "#59B974"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M851.279 384.047V387.162H850.279V386.416H848.539V385.416H850.279V384.047H851.279Z",
    fill: "#59B974"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M879.279 384.047V387.162H878.279V386.416H876.539V385.416H878.279V384.047H879.279Z",
    fill: "#59B974"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M908.4 384.047V387.162H907.4V386.416H905.66V385.416H907.4V384.047H908.4Z",
    fill: "#59B974"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M823.278 397.755V400.871H822.278V400.124H820.538V399.124H822.278V397.755H823.278Z",
    fill: "#59B974"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M851.279 397.755V400.871H850.279V400.124H848.539V399.124H850.279V397.755H851.279Z",
    fill: "#59B974"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M879.279 397.755V400.871H878.279V400.124H876.539V399.124H878.279V397.755H879.279Z",
    fill: "#59B974"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M908.4 397.755V400.871H907.4V400.124H905.66V399.124H907.4V397.755H908.4Z",
    fill: "#59B974"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M798.698 374.7V377.193H823.899V374.7",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M826.698 374.7V377.193H851.899V374.7",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M854.699 374.7V377.193H879.9V374.7",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M883.82 374.7V377.193H909.021V374.7",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M799.259 410.218V407.725H824.459V410.218",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M827.259 410.218V407.725H852.459V410.218",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M855.26 410.218V407.725H880.46V410.218",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M884.38 410.218V407.725H909.58V410.218",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M799.259 379.685H802.059V404.61H799.819",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M827.259 379.685H830.059V404.61H827.819",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M855.26 379.685H858.06V404.61H855.82",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M884.38 379.685H887.18V404.61H884.94",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M823.339 380.308H820.539V405.233H822.779",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M851.339 380.308H848.539V405.233H850.779",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M879.34 380.308H876.54V405.233H878.78",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M908.461 380.308H905.661V405.233H907.901",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M803.738 391.524V380.931H818.299V391.524",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M831.738 391.524V380.931H846.299V391.524",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M859.739 391.524V380.931H874.3V391.524",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M888.86 391.524V380.931H903.421V391.524",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M803.738 405.856V395.263H818.299V405.856",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M831.738 405.856V395.263H846.299V405.856",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M859.739 405.856V395.263H874.3V405.856",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M888.86 405.856V395.263H903.421V405.856",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M603.661 449.474V445.735H623.822V449.474",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M631.662 449.474V445.735H651.823V449.474",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M659.663 449.474V445.735H679.823V449.474",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M688.783 449.474V445.735H708.944V449.474",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M600.922 426.419V429.534H601.922V428.788H603.662V427.788H601.922V426.419H600.922Z",
    fill: "#2CAD39"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M628.922 426.419V429.534H629.922V428.788H631.662V427.788H629.922V426.419H628.922Z",
    fill: "#2CAD39"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M656.923 426.419V429.534H657.923V428.788H659.663V427.788H657.923V426.419H656.923Z",
    fill: "#2CAD39"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M686.043 426.419V429.534H687.043V428.788H688.783V427.788H687.043V426.419H686.043Z",
    fill: "#2CAD39"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M600.922 420.187V423.303H601.922V422.556H603.662V421.556H601.922V420.187H600.922Z",
    fill: "#2CAD39"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M628.922 420.187V423.303H629.922V422.556H631.662V421.556H629.922V420.187H628.922Z",
    fill: "#2CAD39"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M656.923 420.187V423.303H657.923V422.556H659.663V421.556H657.923V420.187H656.923Z",
    fill: "#2CAD39"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M686.043 420.187V423.303H687.043V422.556H688.783V421.556H687.043V420.187H686.043Z",
    fill: "#2CAD39"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M600.922 433.897V437.012H601.922V436.266H603.662V435.266H601.922V433.897H600.922Z",
    fill: "#2CAD39"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M628.922 433.897V437.012H629.922V436.266H631.662V435.266H629.922V433.897H628.922Z",
    fill: "#2CAD39"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M656.923 433.897V437.012H657.923V436.266H659.663V435.266H657.923V433.897H656.923Z",
    fill: "#2CAD39"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M686.043 433.897V437.012H687.043V436.266H688.783V435.266H687.043V433.897H686.043Z",
    fill: "#2CAD39"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M624.882 426.419V429.534H623.882V428.788H622.142V427.788H623.882V426.419H624.882Z",
    fill: "#2CAD39"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M652.883 426.419V429.534H651.883V428.788H650.143V427.788H651.883V426.419H652.883Z",
    fill: "#2CAD39"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M680.883 426.419V429.534H679.883V428.788H678.143V427.788H679.883V426.419H680.883Z",
    fill: "#2CAD39"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M710.005 426.419V429.534H709.005V428.788H707.265V427.788H709.005V426.419H710.005Z",
    fill: "#2CAD39"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M624.882 420.187V423.303H623.882V422.556H622.142V421.556H623.882V420.187H624.882Z",
    fill: "#2CAD39"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M652.883 420.187V423.303H651.883V422.556H650.143V421.556H651.883V420.187H652.883Z",
    fill: "#2CAD39"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M680.883 420.187V423.303H679.883V422.556H678.143V421.556H679.883V420.187H680.883Z",
    fill: "#2CAD39"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M710.005 420.187V423.303H709.005V422.556H707.265V421.556H709.005V420.187H710.005Z",
    fill: "#2CAD39"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M624.882 433.897V437.012H623.882V436.266H622.142V435.266H623.882V433.897H624.882Z",
    fill: "#2CAD39"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M652.883 433.897V437.012H651.883V436.266H650.143V435.266H651.883V433.897H652.883Z",
    fill: "#2CAD39"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M680.883 433.897V437.012H679.883V436.266H678.143V435.266H679.883V433.897H680.883Z",
    fill: "#2CAD39"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M710.005 433.897V437.012H709.005V436.266H707.265V435.266H709.005V433.897H710.005Z",
    fill: "#2CAD39"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M600.302 410.841V413.333H625.502V410.841",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M628.302 410.841V413.333H653.502V410.841",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M656.303 410.841V413.333H681.503V410.841",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M685.424 410.841V413.333H710.624V410.841",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M600.862 446.358V443.866H626.063V446.358",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M628.862 446.358V443.866H654.063V446.358",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M656.863 446.358V443.866H682.064V446.358",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M685.983 446.358V443.866H711.184V446.358",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M600.862 415.826H603.662V440.75H601.422",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M628.862 415.826H631.662V440.75H629.422",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M656.863 415.826H659.663V440.75H657.423",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M685.983 415.826H688.783V440.75H686.543",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M624.942 416.449H622.142V441.373H624.382",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M652.942 416.449H650.142V441.373H652.382",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M680.943 416.449H678.143V441.373H680.383",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M710.064 416.449H707.264V441.373H709.504",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M605.342 427.665V417.072H619.902V427.665",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M633.342 427.665V417.072H647.902V427.665",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M661.343 427.665V417.072H675.903V427.665",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M690.464 427.665V417.072H705.024V427.665",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M605.342 441.996V431.403H619.902V441.996",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M633.342 441.996V431.403H647.902V441.996",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M661.343 441.996V431.403H675.903V441.996",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M690.464 441.996V431.403H705.024V441.996",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M1091.6 449.474V445.735H1111.76V449.474",
    stroke: "#2CAD39",
    strokeWidth: 1.5
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M1119.6 449.474V445.735H1139.76V449.474",
    stroke: "#2CAD39",
    strokeWidth: 1.5
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M1147.6 449.474V445.735H1167.76V449.474",
    stroke: "#2CAD39",
    strokeWidth: 1.5
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M1176.72 449.474V445.735H1196.88V449.474",
    stroke: "#2CAD39",
    strokeWidth: 1.5
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1088.86 426.419V429.534H1089.86V428.788H1091.6V427.788H1089.86V426.419H1088.86Z",
    fill: "#59B974"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1116.86 426.419V429.534H1117.86V428.788H1119.6V427.788H1117.86V426.419H1116.86Z",
    fill: "#59B974"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1144.86 426.419V429.534H1145.86V428.788H1147.6V427.788H1145.86V426.419H1144.86Z",
    fill: "#59B974"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1173.98 426.419V429.534H1174.98V428.788H1176.72V427.788H1174.98V426.419H1173.98Z",
    fill: "#59B974"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1088.86 420.187V423.303H1089.86V422.556H1091.6V421.556H1089.86V420.187H1088.86Z",
    fill: "#59B974"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1116.86 420.187V423.303H1117.86V422.556H1119.6V421.556H1117.86V420.187H1116.86Z",
    fill: "#59B974"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1144.86 420.187V423.303H1145.86V422.556H1147.6V421.556H1145.86V420.187H1144.86Z",
    fill: "#59B974"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1173.98 420.187V423.303H1174.98V422.556H1176.72V421.556H1174.98V420.187H1173.98Z",
    fill: "#59B974"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1088.86 433.897V437.012H1089.86V436.266H1091.6V435.266H1089.86V433.897H1088.86Z",
    fill: "#59B974"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1116.86 433.897V437.012H1117.86V436.266H1119.6V435.266H1117.86V433.897H1116.86Z",
    fill: "#59B974"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1144.86 433.897V437.012H1145.86V436.266H1147.6V435.266H1145.86V433.897H1144.86Z",
    fill: "#59B974"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1173.98 433.897V437.012H1174.98V436.266H1176.72V435.266H1174.98V433.897H1173.98Z",
    fill: "#59B974"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1112.82 426.419V429.534H1111.82V428.788H1110.08V427.788H1111.82V426.419H1112.82Z",
    fill: "#59B974"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1140.82 426.419V429.534H1139.82V428.788H1138.08V427.788H1139.82V426.419H1140.82Z",
    fill: "#59B974"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1168.82 426.419V429.534H1167.82V428.788H1166.08V427.788H1167.82V426.419H1168.82Z",
    fill: "#59B974"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1197.94 426.419V429.534H1196.94V428.788H1195.2V427.788H1196.94V426.419H1197.94Z",
    fill: "#59B974"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1112.82 420.187V423.303H1111.82V422.556H1110.08V421.556H1111.82V420.187H1112.82Z",
    fill: "#59B974"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1140.82 420.187V423.303H1139.82V422.556H1138.08V421.556H1139.82V420.187H1140.82Z",
    fill: "#59B974"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1168.82 420.187V423.303H1167.82V422.556H1166.08V421.556H1167.82V420.187H1168.82Z",
    fill: "#59B974"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1197.94 420.187V423.303H1196.94V422.556H1195.2V421.556H1196.94V420.187H1197.94Z",
    fill: "#59B974"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1112.82 433.897V437.012H1111.82V436.266H1110.08V435.266H1111.82V433.897H1112.82Z",
    fill: "#59B974"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1140.82 433.897V437.012H1139.82V436.266H1138.08V435.266H1139.82V433.897H1140.82Z",
    fill: "#59B974"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1168.82 433.897V437.012H1167.82V436.266H1166.08V435.266H1167.82V433.897H1168.82Z",
    fill: "#59B974"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1197.94 433.897V437.012H1196.94V436.266H1195.2V435.266H1196.94V433.897H1197.94Z",
    fill: "#59B974"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M1088.24 410.841V413.333H1113.44V410.841",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M1116.24 410.841V413.333H1141.44V410.841",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M1144.24 410.841V413.333H1169.44V410.841",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M1173.36 410.841V413.333H1198.56V410.841",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M1088.8 446.358V443.866H1114V446.358",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M1116.8 446.358V443.866H1142V446.358",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M1144.8 446.358V443.866H1170V446.358",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M1173.92 446.358V443.866H1199.12V446.358",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M1088.8 415.826H1091.6V440.75H1089.36",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M1116.8 415.826H1119.6V440.75H1117.36",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M1144.8 415.826H1147.6V440.75H1145.36",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M1173.92 415.826H1176.72V440.75H1174.48",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M1112.88 416.449H1110.08V441.373H1112.32",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M1140.88 416.449H1138.08V441.373H1140.32",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M1168.88 416.449H1166.08V441.373H1168.32",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M1198 416.449H1195.2V441.373H1197.44",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M1093.28 427.665V417.072H1107.84V427.665",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M1121.28 427.665V417.072H1135.84V427.665",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M1149.28 427.665V417.072H1163.84V427.665",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M1178.4 427.665V417.072H1192.96V427.665",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M1093.28 441.996V431.403H1107.84V441.996",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M1121.28 441.996V431.403H1135.84V441.996",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M1149.28 441.996V431.403H1163.84V441.996",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M1178.4 441.996V431.403H1192.96V441.996",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M1106.92 418.012V414.634H1125.14V418.012",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M1132.22 418.012V414.634H1150.44V418.012",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M1157.52 418.012V414.634H1175.73V418.012",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M1183.83 418.012V414.634H1202.04V418.012",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1104.4 397.182V399.997H1105.4V399.371H1106.92V398.371H1105.4V397.182H1104.4Z",
    fill: "#59B974"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1129.7 397.182V399.997H1130.7V399.371H1132.22V398.371H1130.7V397.182H1129.7Z",
    fill: "#59B974"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1155 397.182V399.997H1156V399.371H1157.52V398.371H1156V397.182H1155Z",
    fill: "#59B974"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1181.3 397.182V399.997H1182.3V399.371H1183.83V398.371H1182.3V397.182H1181.3Z",
    fill: "#59B974"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1104.4 391.552V394.367H1105.4V393.741H1106.92V392.741H1105.4V391.552H1104.4Z",
    fill: "#59B974"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1129.7 391.552V394.367H1130.7V393.741H1132.22V392.741H1130.7V391.552H1129.7Z",
    fill: "#59B974"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1155 391.552V394.367H1156V393.741H1157.52V392.741H1156V391.552H1155Z",
    fill: "#59B974"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1181.3 391.552V394.367H1182.3V393.741H1183.83V392.741H1182.3V391.552H1181.3Z",
    fill: "#59B974"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1104.4 403.937V406.752H1105.4V406.126H1106.92V405.126H1105.4V403.937H1104.4Z",
    fill: "#59B974"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1129.7 403.937V406.752H1130.7V406.126H1132.22V405.126H1130.7V403.937H1129.7Z",
    fill: "#59B974"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1155 403.937V406.752H1156V406.126H1157.52V405.126H1156V403.937H1155Z",
    fill: "#59B974"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1181.3 403.937V406.752H1182.3V406.126H1183.83V405.126H1182.3V403.937H1181.3Z",
    fill: "#59B974"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1126.14 397.182V399.997H1125.14V399.371H1123.62V398.371H1125.14V397.182H1126.14Z",
    fill: "#59B974"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1151.44 397.182V399.997H1150.44V399.371H1148.92V398.371H1150.44V397.182H1151.44Z",
    fill: "#59B974"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1176.74 397.182V399.997H1175.74V399.371H1174.22V398.371H1175.74V397.182H1176.74Z",
    fill: "#59B974"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1203.05 397.182V399.997H1202.05V399.371H1200.52V398.371H1202.05V397.182H1203.05Z",
    fill: "#59B974"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1126.14 391.552V394.367H1125.14V393.741H1123.62V392.741H1125.14V391.552H1126.14Z",
    fill: "#59B974"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1151.44 391.552V394.367H1150.44V393.741H1148.92V392.741H1150.44V391.552H1151.44Z",
    fill: "#59B974"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1176.74 391.552V394.367H1175.74V393.741H1174.22V392.741H1175.74V391.552H1176.74Z",
    fill: "#59B974"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1203.05 391.552V394.367H1202.05V393.741H1200.52V392.741H1202.05V391.552H1203.05Z",
    fill: "#59B974"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1126.14 403.937V406.752H1125.14V406.126H1123.62V405.126H1125.14V403.937H1126.14Z",
    fill: "#59B974"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1151.44 403.937V406.752H1150.44V406.126H1148.92V405.126H1150.44V403.937H1151.44Z",
    fill: "#59B974"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1176.74 403.937V406.752H1175.74V406.126H1174.22V405.126H1175.74V403.937H1176.74Z",
    fill: "#59B974"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1203.05 403.937V406.752H1202.05V406.126H1200.52V405.126H1202.05V403.937H1203.05Z",
    fill: "#59B974"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M1103.89 383.107V385.359H1126.66V383.107",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M1129.18 383.107V385.359H1151.95V383.107",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M1154.48 383.107V385.359H1177.25V383.107",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M1180.79 383.107V385.359H1203.56V383.107",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M1104.39 415.197V412.945H1127.16V415.197",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M1129.69 415.197V412.945H1152.46V415.197",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M1154.99 415.197V412.945H1177.76V415.197",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M1181.3 415.197V412.945H1204.07V415.197",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M1104.39 387.612H1106.92V410.131H1104.9",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M1129.69 387.612H1132.22V410.131H1130.2",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M1154.99 387.612H1157.52V410.131H1155.5",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M1181.3 387.612H1183.83V410.131H1181.8",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M1126.15 388.175H1123.62V410.694H1125.64",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M1151.45 388.175H1148.92V410.694H1150.94",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M1176.75 388.175H1174.22V410.694H1176.24",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M1203.06 388.175H1200.53V410.694H1202.55",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M1108.44 398.307V388.737H1121.6V398.307",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M1133.74 398.307V388.737H1146.89V398.307",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M1159.04 398.307V388.737H1172.19V398.307",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M1185.35 398.307V388.737H1198.5V398.307",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M1108.44 411.257V401.686H1121.6V411.257",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M1133.74 411.257V401.686H1146.89V411.257",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M1159.04 411.257V401.686H1172.19V411.257",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M1185.35 411.257V401.686H1198.5V411.257",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M603.661 414.58V410.842H623.822V414.58",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M631.662 414.58V410.842H651.823V414.58",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M659.663 414.58V410.842H679.823V414.58",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M688.783 414.58V410.842H708.944V414.58",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M600.922 391.525V394.641H601.922V393.894H603.662V392.894H601.922V391.525H600.922Z",
    fill: "#59B974"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M628.922 391.525V394.641H629.922V393.894H631.662V392.894H629.922V391.525H628.922Z",
    fill: "#59B974"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M656.923 391.525V394.641H657.923V393.894H659.663V392.894H657.923V391.525H656.923Z",
    fill: "#59B974"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M686.043 391.525V394.641H687.043V393.894H688.783V392.894H687.043V391.525H686.043Z",
    fill: "#59B974"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M600.922 385.294V388.409H601.922V387.663H603.662V386.663H601.922V385.294H600.922Z",
    fill: "#59B974"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M628.922 385.294V388.409H629.922V387.663H631.662V386.663H629.922V385.294H628.922Z",
    fill: "#59B974"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M656.923 385.294V388.409H657.923V387.663H659.663V386.663H657.923V385.294H656.923Z",
    fill: "#59B974"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M686.043 385.294V388.409H687.043V387.663H688.783V386.663H687.043V385.294H686.043Z",
    fill: "#59B974"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M600.922 399.002V402.118H601.922V401.371H603.662V400.371H601.922V399.002H600.922Z",
    fill: "#59B974"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M628.922 399.002V402.118H629.922V401.371H631.662V400.371H629.922V399.002H628.922Z",
    fill: "#59B974"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M656.923 399.002V402.118H657.923V401.371H659.663V400.371H657.923V399.002H656.923Z",
    fill: "#59B974"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M686.043 399.002V402.118H687.043V401.371H688.783V400.371H687.043V399.002H686.043Z",
    fill: "#59B974"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M624.882 391.525V394.641H623.882V393.894H622.142V392.894H623.882V391.525H624.882Z",
    fill: "#59B974"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M652.883 391.525V394.641H651.883V393.894H650.143V392.894H651.883V391.525H652.883Z",
    fill: "#59B974"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M680.883 391.525V394.641H679.883V393.894H678.143V392.894H679.883V391.525H680.883Z",
    fill: "#59B974"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M710.005 391.525V394.641H709.005V393.894H707.265V392.894H709.005V391.525H710.005Z",
    fill: "#59B974"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M624.882 385.294V388.409H623.882V387.663H622.142V386.663H623.882V385.294H624.882Z",
    fill: "#59B974"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M652.883 385.294V388.409H651.883V387.663H650.143V386.663H651.883V385.294H652.883Z",
    fill: "#59B974"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M680.883 385.294V388.409H679.883V387.663H678.143V386.663H679.883V385.294H680.883Z",
    fill: "#59B974"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M710.005 385.294V388.409H709.005V387.663H707.265V386.663H709.005V385.294H710.005Z",
    fill: "#59B974"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M624.882 399.002V402.118H623.882V401.371H622.142V400.371H623.882V399.002H624.882Z",
    fill: "#59B974"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M652.883 399.002V402.118H651.883V401.371H650.143V400.371H651.883V399.002H652.883Z",
    fill: "#59B974"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M680.883 399.002V402.118H679.883V401.371H678.143V400.371H679.883V399.002H680.883Z",
    fill: "#59B974"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M710.005 399.002V402.118H709.005V401.371H707.265V400.371H709.005V399.002H710.005Z",
    fill: "#59B974"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M600.302 375.947V378.44H625.502V375.947",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M628.302 375.947V378.44H653.502V375.947",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M656.303 375.947V378.44H681.503V375.947",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M685.424 375.947V378.44H710.624V375.947",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M600.862 411.465V408.972H626.063V411.465",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M628.862 411.465V408.972H654.063V411.465",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M656.863 411.465V408.972H682.064V411.465",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M685.983 411.465V408.972H711.184V411.465",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M600.862 380.932H603.662V405.857H601.422",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M628.862 380.932H631.662V405.857H629.422",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M656.863 380.932H659.663V405.857H657.423",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M685.983 380.932H688.783V405.857H686.543",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M624.942 381.555H622.142V406.48H624.382",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M652.942 381.555H650.142V406.48H652.382",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M680.943 381.555H678.143V406.48H680.383",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M710.064 381.555H707.264V406.48H709.504",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M605.342 392.771V382.178H619.902V392.771",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M633.342 392.771V382.178H647.902V392.771",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M661.343 392.771V382.178H675.903V392.771",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M690.464 392.771V382.178H705.024V392.771",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M605.342 407.103V396.51H619.902V407.103",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M633.342 407.103V396.51H647.902V407.103",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M661.343 407.103V396.51H675.903V407.103",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M690.464 407.103V396.51H705.024V407.103",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M603.661 379.685V375.946H623.822V379.685",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M631.662 379.685V375.946H651.823V379.685",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M659.663 379.685V375.946H679.823V379.685",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M688.783 379.685V375.946H708.944V379.685",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M600.922 356.63V359.745H601.922V358.999H603.662V357.999H601.922V356.63H600.922Z",
    fill: "#59B974"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M628.922 356.63V359.745H629.922V358.999H631.662V357.999H629.922V356.63H628.922Z",
    fill: "#59B974"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M656.923 356.63V359.745H657.923V358.999H659.663V357.999H657.923V356.63H656.923Z",
    fill: "#59B974"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M686.043 356.63V359.745H687.043V358.999H688.783V357.999H687.043V356.63H686.043Z",
    fill: "#59B974"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M600.922 350.399V353.514H601.922V352.768H603.662V351.768H601.922V350.399H600.922Z",
    fill: "#59B974"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M628.922 350.399V353.514H629.922V352.768H631.662V351.768H629.922V350.399H628.922Z",
    fill: "#59B974"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M656.923 350.399V353.514H657.923V352.768H659.663V351.768H657.923V350.399H656.923Z",
    fill: "#59B974"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M686.043 350.399V353.514H687.043V352.768H688.783V351.768H687.043V350.399H686.043Z",
    fill: "#59B974"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M600.922 364.107V367.223H601.922V366.476H603.662V365.476H601.922V364.107H600.922Z",
    fill: "#59B974"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M628.922 364.107V367.223H629.922V366.476H631.662V365.476H629.922V364.107H628.922Z",
    fill: "#59B974"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M656.923 364.107V367.223H657.923V366.476H659.663V365.476H657.923V364.107H656.923Z",
    fill: "#59B974"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M686.043 364.107V367.223H687.043V366.476H688.783V365.476H687.043V364.107H686.043Z",
    fill: "#59B974"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M624.882 356.63V359.745H623.882V358.999H622.142V357.999H623.882V356.63H624.882Z",
    fill: "#59B974"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M652.883 356.63V359.745H651.883V358.999H650.143V357.999H651.883V356.63H652.883Z",
    fill: "#59B974"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M680.883 356.63V359.745H679.883V358.999H678.143V357.999H679.883V356.63H680.883Z",
    fill: "#59B974"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M710.005 356.63V359.745H709.005V358.999H707.265V357.999H709.005V356.63H710.005Z",
    fill: "#59B974"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M624.882 350.399V353.514H623.882V352.768H622.142V351.768H623.882V350.399H624.882Z",
    fill: "#59B974"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M652.883 350.399V353.514H651.883V352.768H650.143V351.768H651.883V350.399H652.883Z",
    fill: "#59B974"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M680.883 350.399V353.514H679.883V352.768H678.143V351.768H679.883V350.399H680.883Z",
    fill: "#59B974"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M710.005 350.399V353.514H709.005V352.768H707.265V351.768H709.005V350.399H710.005Z",
    fill: "#59B974"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M624.882 364.107V367.223H623.882V366.476H622.142V365.476H623.882V364.107H624.882Z",
    fill: "#59B974"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M652.883 364.107V367.223H651.883V366.476H650.143V365.476H651.883V364.107H652.883Z",
    fill: "#59B974"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M680.883 364.107V367.223H679.883V366.476H678.143V365.476H679.883V364.107H680.883Z",
    fill: "#59B974"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M710.005 364.107V367.223H709.005V366.476H707.265V365.476H709.005V364.107H710.005Z",
    fill: "#59B974"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M600.302 341.052V343.544H625.502V341.052",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M628.302 341.052V343.544H653.502V341.052",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M656.303 341.052V343.544H681.503V341.052",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M685.424 341.052V343.544H710.624V341.052",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M600.862 376.569V374.077H626.063V376.569",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M628.862 376.569V374.077H654.063V376.569",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M656.863 376.569V374.077H682.064V376.569",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M685.983 376.569V374.077H711.184V376.569",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M600.862 346.037H603.662V370.961H601.422",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M628.862 346.037H631.662V370.961H629.422",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M656.863 346.037H659.663V370.961H657.423",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M685.983 346.037H688.783V370.961H686.543",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M624.942 346.66H622.142V371.584H624.382",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M652.942 346.66H650.142V371.584H652.382",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M680.943 346.66H678.143V371.584H680.383",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M710.064 346.66H707.264V371.584H709.504",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M605.342 357.876V347.283H619.902V357.876",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M633.342 357.876V347.283H647.902V357.876",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M661.343 357.876V347.283H675.903V357.876",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M690.464 357.876V347.283H705.024V357.876",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M605.342 372.207V361.614H619.902V372.207",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M633.342 372.207V361.614H647.902V372.207",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M661.343 372.207V361.614H675.903V372.207",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M690.464 372.207V361.614H705.024V372.207",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M603.661 344.79V341.052H623.822V344.79",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M631.662 344.79V341.052H651.823V344.79",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M659.663 344.79V341.052H679.823V344.79",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M688.783 344.79V341.052H708.944V344.79",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M600.922 321.734V324.85H601.922V324.103H603.662V323.103H601.922V321.734H600.922Z",
    fill: "#59B974"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M628.922 321.734V324.85H629.922V324.103H631.662V323.103H629.922V321.734H628.922Z",
    fill: "#59B974"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M656.923 321.734V324.85H657.923V324.103H659.663V323.103H657.923V321.734H656.923Z",
    fill: "#59B974"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M686.043 321.734V324.85H687.043V324.103H688.783V323.103H687.043V321.734H686.043Z",
    fill: "#59B974"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M600.922 315.504V318.62H601.922V317.873H603.662V316.873H601.922V315.504H600.922Z",
    fill: "#59B974"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M628.922 315.504V318.62H629.922V317.873H631.662V316.873H629.922V315.504H628.922Z",
    fill: "#59B974"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M656.923 315.504V318.62H657.923V317.873H659.663V316.873H657.923V315.504H656.923Z",
    fill: "#59B974"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M686.043 315.504V318.62H687.043V317.873H688.783V316.873H687.043V315.504H686.043Z",
    fill: "#59B974"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M600.922 329.213V332.328H601.922V331.582H603.662V330.582H601.922V329.213H600.922Z",
    fill: "#59B974"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M628.922 329.213V332.328H629.922V331.582H631.662V330.582H629.922V329.213H628.922Z",
    fill: "#59B974"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M656.923 329.213V332.328H657.923V331.582H659.663V330.582H657.923V329.213H656.923Z",
    fill: "#59B974"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M686.043 329.213V332.328H687.043V331.582H688.783V330.582H687.043V329.213H686.043Z",
    fill: "#59B974"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M624.882 321.734V324.85H623.882V324.103H622.142V323.103H623.882V321.734H624.882Z",
    fill: "#59B974"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M652.883 321.734V324.85H651.883V324.103H650.143V323.103H651.883V321.734H652.883Z",
    fill: "#59B974"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M680.883 321.734V324.85H679.883V324.103H678.143V323.103H679.883V321.734H680.883Z",
    fill: "#59B974"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M710.005 321.734V324.85H709.005V324.103H707.265V323.103H709.005V321.734H710.005Z",
    fill: "#59B974"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M624.882 315.504V318.62H623.882V317.873H622.142V316.873H623.882V315.504H624.882Z",
    fill: "#59B974"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M652.883 315.504V318.62H651.883V317.873H650.143V316.873H651.883V315.504H652.883Z",
    fill: "#59B974"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M680.883 315.504V318.62H679.883V317.873H678.143V316.873H679.883V315.504H680.883Z",
    fill: "#59B974"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M710.005 315.504V318.62H709.005V317.873H707.265V316.873H709.005V315.504H710.005Z",
    fill: "#59B974"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M624.882 329.213V332.328H623.882V331.582H622.142V330.582H623.882V329.213H624.882Z",
    fill: "#59B974"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M652.883 329.213V332.328H651.883V331.582H650.143V330.582H651.883V329.213H652.883Z",
    fill: "#59B974"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M680.883 329.213V332.328H679.883V331.582H678.143V330.582H679.883V329.213H680.883Z",
    fill: "#59B974"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M710.005 329.213V332.328H709.005V331.582H707.265V330.582H709.005V329.213H710.005Z",
    fill: "#59B974"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M600.302 306.157V308.65H625.502V306.157",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M628.302 306.157V308.65H653.502V306.157",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M656.303 306.157V308.65H681.503V306.157",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M685.424 306.157V308.65H710.624V306.157",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M600.862 341.675V339.182H626.063V341.675",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M628.862 341.675V339.182H654.063V341.675",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M656.863 341.675V339.182H682.064V341.675",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M685.983 341.675V339.182H711.184V341.675",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M600.862 311.142H603.662V336.067H601.422",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M628.862 311.142H631.662V336.067H629.422",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M656.863 311.142H659.663V336.067H657.423",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M685.983 311.142H688.783V336.067H686.543",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M624.942 311.765H622.142V336.69H624.382",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M652.942 311.765H650.142V336.69H652.382",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M680.943 311.765H678.143V336.69H680.383",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M710.064 311.765H707.264V336.69H709.504",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M605.342 322.981V312.388H619.902V322.981",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M633.342 322.981V312.388H647.902V322.981",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M661.343 322.981V312.388H675.903V322.981",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M690.464 322.981V312.388H705.024V322.981",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M605.342 337.313V326.72H619.902V337.313",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M633.342 337.313V326.72H647.902V337.313",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M661.343 337.313V326.72H675.903V337.313",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M690.464 337.313V326.72H705.024V337.313",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M603.661 309.896V306.157H623.822V309.896",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M631.662 309.896V306.157H651.823V309.896",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M659.663 309.896V306.157H679.823V309.896",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M688.783 309.896V306.157H708.944V309.896",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M600.922 286.84V289.956H601.922V289.209H603.662V288.209H601.922V286.84H600.922Z",
    fill: "#59B974"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M628.922 286.84V289.956H629.922V289.209H631.662V288.209H629.922V286.84H628.922Z",
    fill: "#59B974"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M656.923 286.84V289.956H657.923V289.209H659.663V288.209H657.923V286.84H656.923Z",
    fill: "#59B974"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M686.043 286.84V289.956H687.043V289.209H688.783V288.209H687.043V286.84H686.043Z",
    fill: "#59B974"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M600.922 280.61V283.725H601.922V282.979H603.662V281.979H601.922V280.61H600.922Z",
    fill: "#59B974"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M628.922 280.61V283.725H629.922V282.979H631.662V281.979H629.922V280.61H628.922Z",
    fill: "#59B974"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M656.923 280.61V283.725H657.923V282.979H659.663V281.979H657.923V280.61H656.923Z",
    fill: "#59B974"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M686.043 280.61V283.725H687.043V282.979H688.783V281.979H687.043V280.61H686.043Z",
    fill: "#59B974"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M600.922 294.318V297.434H601.922V296.687H603.662V295.687H601.922V294.318H600.922Z",
    fill: "#59B974"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M628.922 294.318V297.434H629.922V296.687H631.662V295.687H629.922V294.318H628.922Z",
    fill: "#59B974"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M656.923 294.318V297.434H657.923V296.687H659.663V295.687H657.923V294.318H656.923Z",
    fill: "#59B974"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M686.043 294.318V297.434H687.043V296.687H688.783V295.687H687.043V294.318H686.043Z",
    fill: "#59B974"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M624.882 286.84V289.956H623.882V289.209H622.142V288.209H623.882V286.84H624.882Z",
    fill: "#59B974"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M652.883 286.84V289.956H651.883V289.209H650.143V288.209H651.883V286.84H652.883Z",
    fill: "#59B974"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M680.883 286.84V289.956H679.883V289.209H678.143V288.209H679.883V286.84H680.883Z",
    fill: "#59B974"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M710.005 286.84V289.956H709.005V289.209H707.265V288.209H709.005V286.84H710.005Z",
    fill: "#59B974"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M624.882 280.61V283.725H623.882V282.979H622.142V281.979H623.882V280.61H624.882Z",
    fill: "#59B974"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M652.883 280.61V283.725H651.883V282.979H650.143V281.979H651.883V280.61H652.883Z",
    fill: "#59B974"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M680.883 280.61V283.725H679.883V282.979H678.143V281.979H679.883V280.61H680.883Z",
    fill: "#59B974"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M710.005 280.61V283.725H709.005V282.979H707.265V281.979H709.005V280.61H710.005Z",
    fill: "#59B974"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M624.882 294.318V297.434H623.882V296.687H622.142V295.687H623.882V294.318H624.882Z",
    fill: "#59B974"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M652.883 294.318V297.434H651.883V296.687H650.143V295.687H651.883V294.318H652.883Z",
    fill: "#59B974"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M680.883 294.318V297.434H679.883V296.687H678.143V295.687H679.883V294.318H680.883Z",
    fill: "#59B974"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M710.005 294.318V297.434H709.005V296.687H707.265V295.687H709.005V294.318H710.005Z",
    fill: "#59B974"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "M600.302 271.263V273.755H625.502V271.263",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "M628.302 271.263V273.755H653.502V271.263",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M656.303 271.263V273.755H681.503V271.263",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M685.424 271.263V273.755H710.624V271.263",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M600.862 306.78V304.288H626.063V306.78",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "M628.862 306.78V304.288H654.063V306.78",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "M656.863 306.78V304.288H682.064V306.78",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "M685.983 306.78V304.288H711.184V306.78",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "M600.862 276.248H603.662V301.172H601.422",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "M628.862 276.248H631.662V301.172H629.422",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "M656.863 276.248H659.663V301.172H657.423",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "M685.983 276.248H688.783V301.172H686.543",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "M624.942 276.871H622.142V301.795H624.382",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "M652.942 276.871H650.142V301.795H652.382",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "M680.943 276.871H678.143V301.795H680.383",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "M710.064 276.871H707.264V301.795H709.504",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "M605.342 288.087V277.494H619.902V288.087",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "M633.342 288.087V277.494H647.902V288.087",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "M661.343 288.087V277.494H675.903V288.087",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "M690.464 288.087V277.494H705.024V288.087",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "M605.342 302.418V291.825H619.902V302.418",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "M633.342 302.418V291.825H647.902V302.418",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "M661.343 302.418V291.825H675.903V302.418",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "M690.464 302.418V291.825H705.024V302.418",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "M1210.9 449.474V445.735H1231.06V449.474",
    stroke: "#2CAD39",
    strokeWidth: 1.5
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "M1238.9 449.474V445.735H1259.06V449.474",
    stroke: "#2CAD39",
    strokeWidth: 1.5
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "M1266.9 449.474V445.735H1287.06V449.474",
    stroke: "#2CAD39",
    strokeWidth: 1.5
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "M1296.02 449.474V445.735H1316.18V449.474",
    stroke: "#2CAD39",
    strokeWidth: 1.5
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1208.16 426.419V429.534H1209.16V428.788H1210.9V427.788H1209.16V426.419H1208.16Z",
    fill: "#59B974"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1236.16 426.419V429.534H1237.16V428.788H1238.9V427.788H1237.16V426.419H1236.16Z",
    fill: "#59B974"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1264.16 426.419V429.534H1265.16V428.788H1266.9V427.788H1265.16V426.419H1264.16Z",
    fill: "#59B974"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1293.28 426.419V429.534H1294.28V428.788H1296.02V427.788H1294.28V426.419H1293.28Z",
    fill: "#59B974"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1208.16 420.187V423.303H1209.16V422.556H1210.9V421.556H1209.16V420.187H1208.16Z",
    fill: "#59B974"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1236.16 420.187V423.303H1237.16V422.556H1238.9V421.556H1237.16V420.187H1236.16Z",
    fill: "#59B974"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1264.16 420.187V423.303H1265.16V422.556H1266.9V421.556H1265.16V420.187H1264.16Z",
    fill: "#59B974"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1293.28 420.187V423.303H1294.28V422.556H1296.02V421.556H1294.28V420.187H1293.28Z",
    fill: "#59B974"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1208.16 433.897V437.012H1209.16V436.266H1210.9V435.266H1209.16V433.897H1208.16Z",
    fill: "#59B974"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1236.16 433.897V437.012H1237.16V436.266H1238.9V435.266H1237.16V433.897H1236.16Z",
    fill: "#59B974"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1264.16 433.897V437.012H1265.16V436.266H1266.9V435.266H1265.16V433.897H1264.16Z",
    fill: "#59B974"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1293.28 433.897V437.012H1294.28V436.266H1296.02V435.266H1294.28V433.897H1293.28Z",
    fill: "#59B974"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1232.12 426.419V429.534H1231.12V428.788H1229.38V427.788H1231.12V426.419H1232.12Z",
    fill: "#59B974"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1260.12 426.419V429.534H1259.12V428.788H1257.38V427.788H1259.12V426.419H1260.12Z",
    fill: "#59B974"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1288.12 426.419V429.534H1287.12V428.788H1285.38V427.788H1287.12V426.419H1288.12Z",
    fill: "#59B974"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1317.24 426.419V429.534H1316.24V428.788H1314.5V427.788H1316.24V426.419H1317.24Z",
    fill: "#59B974"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1232.12 420.187V423.303H1231.12V422.556H1229.38V421.556H1231.12V420.187H1232.12Z",
    fill: "#59B974"
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1260.12 420.187V423.303H1259.12V422.556H1257.38V421.556H1259.12V420.187H1260.12Z",
    fill: "#59B974"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1288.12 420.187V423.303H1287.12V422.556H1285.38V421.556H1287.12V420.187H1288.12Z",
    fill: "#59B974"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1317.24 420.187V423.303H1316.24V422.556H1314.5V421.556H1316.24V420.187H1317.24Z",
    fill: "#59B974"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1232.12 433.897V437.012H1231.12V436.266H1229.38V435.266H1231.12V433.897H1232.12Z",
    fill: "#59B974"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1260.12 433.897V437.012H1259.12V436.266H1257.38V435.266H1259.12V433.897H1260.12Z",
    fill: "#59B974"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1288.12 433.897V437.012H1287.12V436.266H1285.38V435.266H1287.12V433.897H1288.12Z",
    fill: "#59B974"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1317.24 433.897V437.012H1316.24V436.266H1314.5V435.266H1316.24V433.897H1317.24Z",
    fill: "#59B974"
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "M1207.54 410.841V413.333H1232.74V410.841",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "M1235.54 410.841V413.333H1260.74V410.841",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "M1263.54 410.841V413.333H1288.74V410.841",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "M1292.66 410.841V413.333H1317.86V410.841",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "M1208.1 446.358V443.866H1233.3V446.358",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "M1236.1 446.358V443.866H1261.3V446.358",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "M1264.1 446.358V443.866H1289.3V446.358",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "M1293.22 446.358V443.866H1318.42V446.358",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "M1208.1 415.826H1210.9V440.75H1208.66",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "M1236.1 415.826H1238.9V440.75H1236.66",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "M1264.1 415.826H1266.9V440.75H1264.66",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "M1293.22 415.826H1296.02V440.75H1293.78",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "M1232.18 416.449H1229.38V441.373H1231.62",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "M1260.18 416.449H1257.38V441.373H1259.62",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "M1288.18 416.449H1285.38V441.373H1287.62",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "M1317.3 416.449H1314.5V441.373H1316.74",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "M1212.58 427.665V417.072H1227.14V427.665",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "M1240.58 427.665V417.072H1255.14V427.665",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "M1268.58 427.665V417.072H1283.14V427.665",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "M1297.7 427.665V417.072H1312.26V427.665",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "M1212.58 441.996V431.403H1227.14V441.996",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "M1240.58 441.996V431.403H1255.14V441.996",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "M1268.58 441.996V431.403H1283.14V441.996",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "M1297.7 441.996V431.403H1312.26V441.996",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    d: "M914.061 449.474V445.735H934.221V449.474",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    d: "M942.062 449.474V445.735H962.222V449.474",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    d: "M970.062 449.474V445.735H990.223V449.474",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    d: "M999.183 449.474V445.735H1019.34V449.474",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M911.321 426.419V429.534H912.321V428.788H914.061V427.788H912.321V426.419H911.321Z",
    fill: "#59B974"
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M939.322 426.419V429.534H940.322V428.788H942.062V427.788H940.322V426.419H939.322Z",
    fill: "#59B974"
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M967.322 426.419V429.534H968.322V428.788H970.062V427.788H968.322V426.419H967.322Z",
    fill: "#59B974"
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M996.442 426.419V429.534H997.442V428.788H999.182V427.788H997.442V426.419H996.442Z",
    fill: "#59B974"
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M911.321 420.187V423.303H912.321V422.556H914.061V421.556H912.321V420.187H911.321Z",
    fill: "#59B974"
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M939.322 420.187V423.303H940.322V422.556H942.062V421.556H940.322V420.187H939.322Z",
    fill: "#59B974"
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M967.322 420.187V423.303H968.322V422.556H970.062V421.556H968.322V420.187H967.322Z",
    fill: "#59B974"
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M996.442 420.187V423.303H997.442V422.556H999.182V421.556H997.442V420.187H996.442Z",
    fill: "#59B974"
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M911.321 433.897V437.012H912.321V436.266H914.061V435.266H912.321V433.897H911.321Z",
    fill: "#59B974"
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M939.322 433.897V437.012H940.322V436.266H942.062V435.266H940.322V433.897H939.322Z",
    fill: "#59B974"
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M967.322 433.897V437.012H968.322V436.266H970.062V435.266H968.322V433.897H967.322Z",
    fill: "#59B974"
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M996.442 433.897V437.012H997.442V436.266H999.182V435.266H997.442V433.897H996.442Z",
    fill: "#59B974"
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M935.281 426.419V429.534H934.281V428.788H932.541V427.788H934.281V426.419H935.281Z",
    fill: "#59B974"
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M963.282 426.419V429.534H962.282V428.788H960.542V427.788H962.282V426.419H963.282Z",
    fill: "#59B974"
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M991.282 426.419V429.534H990.282V428.788H988.542V427.788H990.282V426.419H991.282Z",
    fill: "#59B974"
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1020.4 426.419V429.534H1019.4V428.788H1017.66V427.788H1019.4V426.419H1020.4Z",
    fill: "#59B974"
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M935.281 420.187V423.303H934.281V422.556H932.541V421.556H934.281V420.187H935.281Z",
    fill: "#59B974"
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M963.282 420.187V423.303H962.282V422.556H960.542V421.556H962.282V420.187H963.282Z",
    fill: "#59B974"
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M991.282 420.187V423.303H990.282V422.556H988.542V421.556H990.282V420.187H991.282Z",
    fill: "#59B974"
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1020.4 420.187V423.303H1019.4V422.556H1017.66V421.556H1019.4V420.187H1020.4Z",
    fill: "#59B974"
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M935.281 433.897V437.012H934.281V436.266H932.541V435.266H934.281V433.897H935.281Z",
    fill: "#59B974"
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M963.282 433.897V437.012H962.282V436.266H960.542V435.266H962.282V433.897H963.282Z",
    fill: "#59B974"
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M991.282 433.897V437.012H990.282V436.266H988.542V435.266H990.282V433.897H991.282Z",
    fill: "#59B974"
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1020.4 433.897V437.012H1019.4V436.266H1017.66V435.266H1019.4V433.897H1020.4Z",
    fill: "#59B974"
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "M910.701 410.841V413.333H935.902V410.841",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "M938.701 410.841V413.333H963.902V410.841",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "M966.702 410.841V413.333H991.903V410.841",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "M995.823 410.841V413.333H1021.02V410.841",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    d: "M911.262 446.358V443.866H936.462V446.358",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    d: "M939.262 446.358V443.866H964.462V446.358",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    d: "M967.263 446.358V443.866H992.463V446.358",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    d: "M996.383 446.358V443.866H1021.58V446.358",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    d: "M911.262 415.826H914.062V440.75H911.822",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    d: "M939.262 415.826H942.062V440.75H939.822",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    d: "M967.263 415.826H970.063V440.75H967.823",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    d: "M996.383 415.826H999.183V440.75H996.943",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    d: "M935.342 416.449H932.542V441.373H934.782",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    d: "M963.342 416.449H960.542V441.373H962.782",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    d: "M991.343 416.449H988.543V441.373H990.783",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.46 416.449H1017.66V441.373H1019.9",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    d: "M915.741 427.665V417.072H930.302V427.665",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    d: "M943.741 427.665V417.072H958.302V427.665",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    d: "M971.742 427.665V417.072H986.302V427.665",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    d: "M1000.86 427.665V417.072H1015.42V427.665",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    d: "M915.741 441.996V431.403H930.302V441.996",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    d: "M943.741 441.996V431.403H958.302V441.996",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    d: "M971.742 441.996V431.403H986.302V441.996",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    d: "M1000.86 441.996V431.403H1015.42V441.996",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    d: "M914.061 413.333V409.595H934.221V413.333",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    d: "M942.062 413.333V409.595H962.222V413.333",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    d: "M970.062 413.333V409.595H990.223V413.333",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    d: "M999.183 413.333V409.595H1019.34V413.333",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M911.321 390.278V393.394H912.321V392.647H914.061V391.647H912.321V390.278H911.321Z",
    fill: "#59B974"
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M939.322 390.278V393.394H940.322V392.647H942.062V391.647H940.322V390.278H939.322Z",
    fill: "#59B974"
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M967.322 390.278V393.394H968.322V392.647H970.062V391.647H968.322V390.278H967.322Z",
    fill: "#59B974"
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M996.442 390.278V393.394H997.442V392.647H999.182V391.647H997.442V390.278H996.442Z",
    fill: "#59B974"
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M911.321 384.047V387.162H912.321V386.416H914.061V385.416H912.321V384.047H911.321Z",
    fill: "#59B974"
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M939.322 384.047V387.162H940.322V386.416H942.062V385.416H940.322V384.047H939.322Z",
    fill: "#59B974"
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M967.322 384.047V387.162H968.322V386.416H970.062V385.416H968.322V384.047H967.322Z",
    fill: "#59B974"
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M996.442 384.047V387.162H997.442V386.416H999.182V385.416H997.442V384.047H996.442Z",
    fill: "#59B974"
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M911.321 397.755V400.871H912.321V400.124H914.061V399.124H912.321V397.755H911.321Z",
    fill: "#59B974"
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M939.322 397.755V400.871H940.322V400.124H942.062V399.124H940.322V397.755H939.322Z",
    fill: "#59B974"
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M967.322 397.755V400.871H968.322V400.124H970.062V399.124H968.322V397.755H967.322Z",
    fill: "#59B974"
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M996.442 397.755V400.871H997.442V400.124H999.182V399.124H997.442V397.755H996.442Z",
    fill: "#59B974"
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M935.281 390.278V393.394H934.281V392.647H932.541V391.647H934.281V390.278H935.281Z",
    fill: "#59B974"
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M963.282 390.278V393.394H962.282V392.647H960.542V391.647H962.282V390.278H963.282Z",
    fill: "#59B974"
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M991.282 390.278V393.394H990.282V392.647H988.542V391.647H990.282V390.278H991.282Z",
    fill: "#59B974"
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1020.4 390.278V393.394H1019.4V392.647H1017.66V391.647H1019.4V390.278H1020.4Z",
    fill: "#59B974"
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M935.281 384.047V387.162H934.281V386.416H932.541V385.416H934.281V384.047H935.281Z",
    fill: "#59B974"
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M963.282 384.047V387.162H962.282V386.416H960.542V385.416H962.282V384.047H963.282Z",
    fill: "#59B974"
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M991.282 384.047V387.162H990.282V386.416H988.542V385.416H990.282V384.047H991.282Z",
    fill: "#59B974"
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1020.4 384.047V387.162H1019.4V386.416H1017.66V385.416H1019.4V384.047H1020.4Z",
    fill: "#59B974"
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M935.281 397.755V400.871H934.281V400.124H932.541V399.124H934.281V397.755H935.281Z",
    fill: "#59B974"
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M963.282 397.755V400.871H962.282V400.124H960.542V399.124H962.282V397.755H963.282Z",
    fill: "#59B974"
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M991.282 397.755V400.871H990.282V400.124H988.542V399.124H990.282V397.755H991.282Z",
    fill: "#59B974"
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1020.4 397.755V400.871H1019.4V400.124H1017.66V399.124H1019.4V397.755H1020.4Z",
    fill: "#59B974"
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    d: "M910.701 374.7V377.193H935.902V374.7",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    d: "M938.701 374.7V377.193H963.902V374.7",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    d: "M966.702 374.7V377.193H991.903V374.7",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    d: "M995.823 374.7V377.193H1021.02V374.7",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    d: "M911.262 410.218V407.725H936.462V410.218",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    d: "M939.262 410.218V407.725H964.462V410.218",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    d: "M967.263 410.218V407.725H992.463V410.218",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    d: "M996.383 410.218V407.725H1021.58V410.218",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    d: "M911.262 379.685H914.062V404.61H911.822",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    d: "M939.262 379.685H942.062V404.61H939.822",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    d: "M967.263 379.685H970.063V404.61H967.823",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    d: "M996.383 379.685H999.183V404.61H996.943",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    d: "M935.342 380.308H932.542V405.233H934.782",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    d: "M963.342 380.308H960.542V405.233H962.782",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    d: "M991.343 380.308H988.543V405.233H990.783",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.46 380.308H1017.66V405.233H1019.9",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    d: "M915.741 391.524V380.931H930.302V391.524",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    d: "M943.741 391.524V380.931H958.302V391.524",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    d: "M971.742 391.524V380.931H986.302V391.524",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    d: "M1000.86 391.524V380.931H1015.42V391.524",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    d: "M915.741 405.856V395.263H930.302V405.856",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    d: "M943.741 405.856V395.263H958.302V405.856",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    d: "M971.742 405.856V395.263H986.302V405.856",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    d: "M1000.86 405.856V395.263H1015.42V405.856",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    d: "M1203.6 449.474V445.735H1223.76V449.474",
    stroke: "#2CAD39",
    strokeWidth: 1.5
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    d: "M1231.6 449.474V445.735H1251.76V449.474",
    stroke: "#2CAD39",
    strokeWidth: 1.5
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    d: "M1259.6 449.474V445.735H1279.76V449.474",
    stroke: "#2CAD39",
    strokeWidth: 1.5
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    d: "M1288.72 449.474V445.735H1308.88V449.474",
    stroke: "#2CAD39",
    strokeWidth: 1.5
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1200.86 426.419V429.534H1201.86V428.788H1203.6V427.788H1201.86V426.419H1200.86Z",
    fill: "#59B974"
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1228.86 426.419V429.534H1229.86V428.788H1231.6V427.788H1229.86V426.419H1228.86Z",
    fill: "#59B974"
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1256.86 426.419V429.534H1257.86V428.788H1259.6V427.788H1257.86V426.419H1256.86Z",
    fill: "#59B974"
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1285.98 426.419V429.534H1286.98V428.788H1288.72V427.788H1286.98V426.419H1285.98Z",
    fill: "#59B974"
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1200.86 420.187V423.303H1201.86V422.556H1203.6V421.556H1201.86V420.187H1200.86Z",
    fill: "#59B974"
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1228.86 420.187V423.303H1229.86V422.556H1231.6V421.556H1229.86V420.187H1228.86Z",
    fill: "#59B974"
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1256.86 420.187V423.303H1257.86V422.556H1259.6V421.556H1257.86V420.187H1256.86Z",
    fill: "#59B974"
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1285.98 420.187V423.303H1286.98V422.556H1288.72V421.556H1286.98V420.187H1285.98Z",
    fill: "#59B974"
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1200.86 433.897V437.012H1201.86V436.266H1203.6V435.266H1201.86V433.897H1200.86Z",
    fill: "#59B974"
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1228.86 433.897V437.012H1229.86V436.266H1231.6V435.266H1229.86V433.897H1228.86Z",
    fill: "#59B974"
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1256.86 433.897V437.012H1257.86V436.266H1259.6V435.266H1257.86V433.897H1256.86Z",
    fill: "#59B974"
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1285.98 433.897V437.012H1286.98V436.266H1288.72V435.266H1286.98V433.897H1285.98Z",
    fill: "#59B974"
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1224.82 426.419V429.534H1223.82V428.788H1222.08V427.788H1223.82V426.419H1224.82Z",
    fill: "#59B974"
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1252.82 426.419V429.534H1251.82V428.788H1250.08V427.788H1251.82V426.419H1252.82Z",
    fill: "#59B974"
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1280.82 426.419V429.534H1279.82V428.788H1278.08V427.788H1279.82V426.419H1280.82Z",
    fill: "#59B974"
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1309.94 426.419V429.534H1308.94V428.788H1307.2V427.788H1308.94V426.419H1309.94Z",
    fill: "#59B974"
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1224.82 420.187V423.303H1223.82V422.556H1222.08V421.556H1223.82V420.187H1224.82Z",
    fill: "#59B974"
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1252.82 420.187V423.303H1251.82V422.556H1250.08V421.556H1251.82V420.187H1252.82Z",
    fill: "#59B974"
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1280.82 420.187V423.303H1279.82V422.556H1278.08V421.556H1279.82V420.187H1280.82Z",
    fill: "#59B974"
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1309.94 420.187V423.303H1308.94V422.556H1307.2V421.556H1308.94V420.187H1309.94Z",
    fill: "#59B974"
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1224.82 433.897V437.012H1223.82V436.266H1222.08V435.266H1223.82V433.897H1224.82Z",
    fill: "#59B974"
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1252.82 433.897V437.012H1251.82V436.266H1250.08V435.266H1251.82V433.897H1252.82Z",
    fill: "#59B974"
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1280.82 433.897V437.012H1279.82V436.266H1278.08V435.266H1279.82V433.897H1280.82Z",
    fill: "#59B974"
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1309.94 433.897V437.012H1308.94V436.266H1307.2V435.266H1308.94V433.897H1309.94Z",
    fill: "#59B974"
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    d: "M1200.24 410.841V413.333H1225.44V410.841",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    d: "M1228.24 410.841V413.333H1253.44V410.841",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    d: "M1256.24 410.841V413.333H1281.44V410.841",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    d: "M1285.36 410.841V413.333H1310.56V410.841",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    d: "M1200.8 446.358V443.866H1226V446.358",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    d: "M1228.8 446.358V443.866H1254V446.358",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    d: "M1256.8 446.358V443.866H1282V446.358",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    d: "M1285.92 446.358V443.866H1311.12V446.358",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    d: "M1200.8 415.826H1203.6V440.75H1201.36",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    d: "M1228.8 415.826H1231.6V440.75H1229.36",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    d: "M1256.8 415.826H1259.6V440.75H1257.36",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    d: "M1285.92 415.826H1288.72V440.75H1286.48",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    d: "M1224.88 416.449H1222.08V441.373H1224.32",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    d: "M1252.88 416.449H1250.08V441.373H1252.32",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    d: "M1280.88 416.449H1278.08V441.373H1280.32",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    d: "M1310 416.449H1307.2V441.373H1309.44",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    d: "M1205.28 427.665V417.072H1219.84V427.665",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    d: "M1233.28 427.665V417.072H1247.84V427.665",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    d: "M1261.28 427.665V417.072H1275.84V427.665",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    d: "M1290.4 427.665V417.072H1304.96V427.665",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    d: "M1205.28 441.996V431.403H1219.84V441.996",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    d: "M1233.28 441.996V431.403H1247.84V441.996",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    d: "M1261.28 441.996V431.403H1275.84V441.996",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    d: "M1290.4 441.996V431.403H1304.96V441.996",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    d: "M1208.12 418.012V414.634H1226.33V418.012",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    d: "M1233.41 418.012V414.634H1251.63V418.012",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    d: "M1258.71 418.012V414.634H1276.93V418.012",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    d: "M1285.02 418.012V414.634H1303.24V418.012",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1205.59 397.182V399.997H1206.59V399.371H1208.12V398.371H1206.59V397.182H1205.59Z",
    fill: "#59B974"
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1230.89 397.182V399.997H1231.89V399.371H1233.41V398.371H1231.89V397.182H1230.89Z",
    fill: "#59B974"
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1256.19 397.182V399.997H1257.19V399.371H1258.71V398.371H1257.19V397.182H1256.19Z",
    fill: "#59B974"
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1282.5 397.182V399.997H1283.5V399.371H1285.02V398.371H1283.5V397.182H1282.5Z",
    fill: "#59B974"
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1205.59 391.552V394.367H1206.59V393.741H1208.12V392.741H1206.59V391.552H1205.59Z",
    fill: "#59B974"
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1230.89 391.552V394.367H1231.89V393.741H1233.41V392.741H1231.89V391.552H1230.89Z",
    fill: "#59B974"
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1256.19 391.552V394.367H1257.19V393.741H1258.71V392.741H1257.19V391.552H1256.19Z",
    fill: "#59B974"
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1282.5 391.552V394.367H1283.5V393.741H1285.02V392.741H1283.5V391.552H1282.5Z",
    fill: "#59B974"
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1205.59 403.937V406.752H1206.59V406.126H1208.12V405.126H1206.59V403.937H1205.59Z",
    fill: "#59B974"
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1230.89 403.937V406.752H1231.89V406.126H1233.41V405.126H1231.89V403.937H1230.89Z",
    fill: "#59B974"
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1256.19 403.937V406.752H1257.19V406.126H1258.71V405.126H1257.19V403.937H1256.19Z",
    fill: "#59B974"
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1282.5 403.937V406.752H1283.5V406.126H1285.02V405.126H1283.5V403.937H1282.5Z",
    fill: "#59B974"
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1227.34 397.182V399.997H1226.34V399.371H1224.81V398.371H1226.34V397.182H1227.34Z",
    fill: "#59B974"
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1252.63 397.182V399.997H1251.63V399.371H1250.11V398.371H1251.63V397.182H1252.63Z",
    fill: "#59B974"
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1277.93 397.182V399.997H1276.93V399.371H1275.41V398.371H1276.93V397.182H1277.93Z",
    fill: "#59B974"
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1304.24 397.182V399.997H1303.24V399.371H1301.72V398.371H1303.24V397.182H1304.24Z",
    fill: "#59B974"
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1227.34 391.552V394.367H1226.34V393.741H1224.81V392.741H1226.34V391.552H1227.34Z",
    fill: "#59B974"
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1252.63 391.552V394.367H1251.63V393.741H1250.11V392.741H1251.63V391.552H1252.63Z",
    fill: "#59B974"
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1277.93 391.552V394.367H1276.93V393.741H1275.41V392.741H1276.93V391.552H1277.93Z",
    fill: "#59B974"
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1304.24 391.552V394.367H1303.24V393.741H1301.72V392.741H1303.24V391.552H1304.24Z",
    fill: "#59B974"
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1227.34 403.937V406.752H1226.34V406.126H1224.81V405.126H1226.34V403.937H1227.34Z",
    fill: "#59B974"
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1252.63 403.937V406.752H1251.63V406.126H1250.11V405.126H1251.63V403.937H1252.63Z",
    fill: "#59B974"
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1277.93 403.937V406.752H1276.93V406.126H1275.41V405.126H1276.93V403.937H1277.93Z",
    fill: "#59B974"
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1304.24 403.937V406.752H1303.24V406.126H1301.72V405.126H1303.24V403.937H1304.24Z",
    fill: "#59B974"
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    d: "M1205.08 383.107V385.359H1227.85V383.107",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    d: "M1230.38 383.107V385.359H1253.15V383.107",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    d: "M1255.68 383.107V385.359H1278.45V383.107",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    d: "M1281.99 383.107V385.359H1304.75V383.107",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    d: "M1205.59 415.197V412.945H1228.35V415.197",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    d: "M1230.88 415.197V412.945H1253.65V415.197",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    d: "M1256.18 415.197V412.945H1278.95V415.197",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    d: "M1282.49 415.197V412.945H1305.26V415.197",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    d: "M1205.59 387.612H1208.12V410.131H1206.09",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    d: "M1230.88 387.612H1233.41V410.131H1231.39",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    d: "M1256.18 387.612H1258.71V410.131H1256.69",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    d: "M1282.49 387.612H1285.02V410.131H1283",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    d: "M1227.34 388.175H1224.81V410.694H1226.84",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    d: "M1252.64 388.175H1250.11V410.694H1252.13",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    d: "M1277.94 388.175H1275.41V410.694H1277.43",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    d: "M1304.25 388.175H1301.72V410.694H1303.74",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    d: "M1209.63 398.307V388.737H1222.79V398.307",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    d: "M1234.93 398.307V388.737H1248.09V398.307",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    d: "M1260.23 398.307V388.737H1273.38V398.307",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    d: "M1286.54 398.307V388.737H1299.7V398.307",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    d: "M1209.63 411.257V401.686H1222.79V411.257",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    d: "M1234.93 411.257V401.686H1248.09V411.257",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    d: "M1260.23 411.257V401.686H1273.38V411.257",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    d: "M1286.54 411.257V401.686H1299.7V411.257",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    d: "M417 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    d: "M420 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    d: "M424 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    d: "M428 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    d: "M431 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    d: "M435 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    d: "M439 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    d: "M442 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    d: "M445 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    d: "M505 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    d: "M567 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    d: "M627 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    d: "M688 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    d: "M749 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    d: "M448 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    d: "M508 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    d: "M570 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    d: "M630 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    d: "M691 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    d: "M752 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    d: "M452 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    d: "M512 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    d: "M573 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    d: "M634 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    d: "M695 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    d: "M756 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    d: "M456 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    d: "M516 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    d: "M577 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    d: "M638 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    d: "M699 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    d: "M760 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    d: "M459 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    d: "M519 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    d: "M580 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    d: "M641 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    d: "M702 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    d: "M763 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    d: "M463 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    d: "M523 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    d: "M584 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    d: "M645 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    d: "M706 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    d: "M767 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    d: "M467 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    d: "M527 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    d: "M588 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    d: "M649 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    d: "M710 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    d: "M771 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    d: "M469 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    d: "M530 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    d: "M591 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    d: "M652 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    d: "M713 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    d: "M774 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    d: "M473 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    d: "M534 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    d: "M595 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    d: "M656 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    d: "M717 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    d: "M778 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    d: "M477 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    d: "M538 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    d: "M599 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    d: "M660 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    d: "M721 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    d: "M782 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    d: "M480 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    d: "M541 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    d: "M602 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    d: "M663 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    d: "M724 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    d: "M784 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    d: "M484 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    d: "M545 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    d: "M606 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    d: "M667 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    d: "M728 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    d: "M788 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    d: "M488 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    d: "M549 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    d: "M610 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    d: "M671 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    d: "M732 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    d: "M792 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    d: "M491 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    d: "M552 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    d: "M613 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    d: "M674 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    d: "M735 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    d: "M795 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    d: "M495 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    d: "M556 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    d: "M617 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    d: "M678 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    d: "M739 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    d: "M799 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    d: "M499 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    d: "M560 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    d: "M621 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    d: "M681 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    d: "M743 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    d: "M803 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    d: "M502 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    d: "M563 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    d: "M624 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    d: "M684 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    d: "M746 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    d: "M806 479.212V450.212",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 768.5,
    y: 117.712,
    width: 16,
    height: 93,
    stroke: "#59B974"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 823.5,
    y: 117.712,
    width: 17,
    height: 93,
    stroke: "#59B974"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 876.5,
    y: 117.712,
    width: 16,
    height: 93,
    stroke: "#59B974"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 958.5,
    y: 30.7119,
    width: 16,
    height: 34,
    stroke: "#2CAD39"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 789.5,
    y: 117.712,
    width: 17,
    height: 93,
    stroke: "#59B974"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 842.5,
    y: 117.712,
    width: 17,
    height: 93,
    stroke: "#59B974"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 896.5,
    y: 117.712,
    width: 17,
    height: 93,
    stroke: "#59B974"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 913.5,
    y: 117.712,
    width: 17,
    height: 93,
    stroke: "#59B974"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 974.5,
    y: 30.7119,
    width: 17,
    height: 34,
    stroke: "#2CAD39"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 806.5,
    y: 117.712,
    width: 17,
    height: 93,
    stroke: "#59B974"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 859.5,
    y: 117.712,
    width: 17,
    height: 93,
    stroke: "#59B974"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 768.5,
    y: 117.712,
    width: 16,
    height: 45,
    stroke: "#59B974"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 823.5,
    y: 117.712,
    width: 17,
    height: 45,
    stroke: "#59B974"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 876.5,
    y: 117.712,
    width: 16,
    height: 45,
    stroke: "#59B974"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 789.5,
    y: 117.712,
    width: 17,
    height: 45,
    stroke: "#59B974"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 842.5,
    y: 117.712,
    width: 17,
    height: 45,
    stroke: "#59B974"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 896.5,
    y: 117.712,
    width: 17,
    height: 45,
    stroke: "#59B974"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 913.5,
    y: 117.712,
    width: 17,
    height: 45,
    stroke: "#59B974"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 930.5,
    y: 117.712,
    width: 17,
    height: 93,
    stroke: "#59B974"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 930.5,
    y: 117.712,
    width: 17,
    height: 45,
    stroke: "#59B974"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 974.5,
    y: 30.7119,
    width: 17,
    height: 16,
    stroke: "#2CAD39"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 806.5,
    y: 117.712,
    width: 17,
    height: 45,
    stroke: "#59B974"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 859.5,
    y: 117.712,
    width: 17,
    height: 45,
    stroke: "#59B974"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 21.2119,
    width: 448,
    height: 113,
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 768,
    y: 29.2119,
    width: 178,
    height: 88,
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    d: "M537 1.21191L933 1.21188",
    stroke: "#2CAD39"
  })), _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    d: "M458 144.212L646 144.212",
    stroke: "#59B974"
  })), _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    d: "M458 161.212L646 161.212",
    stroke: "#59B974"
  })), _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    d: "M458 178.212L646 178.212",
    stroke: "#59B974"
  })), _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    d: "M458 196.212L646 196.212",
    stroke: "#59B974"
  })), _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    d: "M534.857 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    d: "M537.829 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    d: "M541.792 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    d: "M545.754 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    d: "M548.726 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    d: "M552.688 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    d: "M556.65 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    d: "M559.622 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    d: "M563.585 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    d: "M567.547 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    d: "M570.519 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    d: "M574.481 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    d: "M578.443 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    d: "M581.415 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    d: "M585.378 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    d: "M589.34 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    d: "M592.312 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    d: "M595.284 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    d: "M655.71 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    d: "M717.127 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    d: "M777.554 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    d: "M838.971 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    d: "M899.397 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    d: "M598.256 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    d: "M658.682 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    d: "M720.1 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1358 || (_path1358 = /*#__PURE__*/React.createElement("path", {
    d: "M780.525 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1359 || (_path1359 = /*#__PURE__*/React.createElement("path", {
    d: "M841.942 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1360 || (_path1360 = /*#__PURE__*/React.createElement("path", {
    d: "M902.369 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1361 || (_path1361 = /*#__PURE__*/React.createElement("path", {
    d: "M602.218 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1362 || (_path1362 = /*#__PURE__*/React.createElement("path", {
    d: "M662.645 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1363 || (_path1363 = /*#__PURE__*/React.createElement("path", {
    d: "M724.062 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1364 || (_path1364 = /*#__PURE__*/React.createElement("path", {
    d: "M784.488 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1365 || (_path1365 = /*#__PURE__*/React.createElement("path", {
    d: "M845.905 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1366 || (_path1366 = /*#__PURE__*/React.createElement("path", {
    d: "M906.332 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1367 || (_path1367 = /*#__PURE__*/React.createElement("path", {
    d: "M606.181 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1368 || (_path1368 = /*#__PURE__*/React.createElement("path", {
    d: "M666.606 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1369 || (_path1369 = /*#__PURE__*/React.createElement("path", {
    d: "M728.024 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1370 || (_path1370 = /*#__PURE__*/React.createElement("path", {
    d: "M788.45 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1371 || (_path1371 = /*#__PURE__*/React.createElement("path", {
    d: "M849.867 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1372 || (_path1372 = /*#__PURE__*/React.createElement("path", {
    d: "M910.294 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1373 || (_path1373 = /*#__PURE__*/React.createElement("path", {
    d: "M609.152 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1374 || (_path1374 = /*#__PURE__*/React.createElement("path", {
    d: "M669.579 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1375 || (_path1375 = /*#__PURE__*/React.createElement("path", {
    d: "M730.996 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1376 || (_path1376 = /*#__PURE__*/React.createElement("path", {
    d: "M791.422 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1377 || (_path1377 = /*#__PURE__*/React.createElement("path", {
    d: "M852.839 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1378 || (_path1378 = /*#__PURE__*/React.createElement("path", {
    d: "M913.266 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1379 || (_path1379 = /*#__PURE__*/React.createElement("path", {
    d: "M613.114 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1380 || (_path1380 = /*#__PURE__*/React.createElement("path", {
    d: "M673.541 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1381 || (_path1381 = /*#__PURE__*/React.createElement("path", {
    d: "M734.958 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1382 || (_path1382 = /*#__PURE__*/React.createElement("path", {
    d: "M795.385 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1383 || (_path1383 = /*#__PURE__*/React.createElement("path", {
    d: "M856.802 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1384 || (_path1384 = /*#__PURE__*/React.createElement("path", {
    d: "M917.229 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1385 || (_path1385 = /*#__PURE__*/React.createElement("path", {
    d: "M617.077 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1386 || (_path1386 = /*#__PURE__*/React.createElement("path", {
    d: "M677.504 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1387 || (_path1387 = /*#__PURE__*/React.createElement("path", {
    d: "M738.921 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1388 || (_path1388 = /*#__PURE__*/React.createElement("path", {
    d: "M799.347 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1389 || (_path1389 = /*#__PURE__*/React.createElement("path", {
    d: "M860.764 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1390 || (_path1390 = /*#__PURE__*/React.createElement("path", {
    d: "M921.19 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1391 || (_path1391 = /*#__PURE__*/React.createElement("path", {
    d: "M620.049 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1392 || (_path1392 = /*#__PURE__*/React.createElement("path", {
    d: "M680.476 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1393 || (_path1393 = /*#__PURE__*/React.createElement("path", {
    d: "M741.893 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1394 || (_path1394 = /*#__PURE__*/React.createElement("path", {
    d: "M802.318 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1395 || (_path1395 = /*#__PURE__*/React.createElement("path", {
    d: "M863.736 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1396 || (_path1396 = /*#__PURE__*/React.createElement("path", {
    d: "M924.162 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1397 || (_path1397 = /*#__PURE__*/React.createElement("path", {
    d: "M624.011 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1398 || (_path1398 = /*#__PURE__*/React.createElement("path", {
    d: "M684.438 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1399 || (_path1399 = /*#__PURE__*/React.createElement("path", {
    d: "M745.854 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1400 || (_path1400 = /*#__PURE__*/React.createElement("path", {
    d: "M806.281 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1401 || (_path1401 = /*#__PURE__*/React.createElement("path", {
    d: "M867.698 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1402 || (_path1402 = /*#__PURE__*/React.createElement("path", {
    d: "M928.125 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1403 || (_path1403 = /*#__PURE__*/React.createElement("path", {
    d: "M627.974 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1404 || (_path1404 = /*#__PURE__*/React.createElement("path", {
    d: "M688.4 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1405 || (_path1405 = /*#__PURE__*/React.createElement("path", {
    d: "M749.817 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1406 || (_path1406 = /*#__PURE__*/React.createElement("path", {
    d: "M810.243 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1407 || (_path1407 = /*#__PURE__*/React.createElement("path", {
    d: "M871.66 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1408 || (_path1408 = /*#__PURE__*/React.createElement("path", {
    d: "M932.087 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1409 || (_path1409 = /*#__PURE__*/React.createElement("path", {
    d: "M630.945 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1410 || (_path1410 = /*#__PURE__*/React.createElement("path", {
    d: "M691.372 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1411 || (_path1411 = /*#__PURE__*/React.createElement("path", {
    d: "M752.789 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1412 || (_path1412 = /*#__PURE__*/React.createElement("path", {
    d: "M813.216 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1413 || (_path1413 = /*#__PURE__*/React.createElement("path", {
    d: "M874.633 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1414 || (_path1414 = /*#__PURE__*/React.createElement("path", {
    d: "M935.059 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1415 || (_path1415 = /*#__PURE__*/React.createElement("path", {
    d: "M634.908 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1416 || (_path1416 = /*#__PURE__*/React.createElement("path", {
    d: "M695.334 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1417 || (_path1417 = /*#__PURE__*/React.createElement("path", {
    d: "M756.751 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1418 || (_path1418 = /*#__PURE__*/React.createElement("path", {
    d: "M817.178 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1419 || (_path1419 = /*#__PURE__*/React.createElement("path", {
    d: "M878.595 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1420 || (_path1420 = /*#__PURE__*/React.createElement("path", {
    d: "M939.021 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1421 || (_path1421 = /*#__PURE__*/React.createElement("path", {
    d: "M638.87 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1422 || (_path1422 = /*#__PURE__*/React.createElement("path", {
    d: "M699.297 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1423 || (_path1423 = /*#__PURE__*/React.createElement("path", {
    d: "M760.714 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1424 || (_path1424 = /*#__PURE__*/React.createElement("path", {
    d: "M821.141 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1425 || (_path1425 = /*#__PURE__*/React.createElement("path", {
    d: "M882.558 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1426 || (_path1426 = /*#__PURE__*/React.createElement("path", {
    d: "M942.983 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1427 || (_path1427 = /*#__PURE__*/React.createElement("path", {
    d: "M641.842 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1428 || (_path1428 = /*#__PURE__*/React.createElement("path", {
    d: "M702.269 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1429 || (_path1429 = /*#__PURE__*/React.createElement("path", {
    d: "M763.686 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1430 || (_path1430 = /*#__PURE__*/React.createElement("path", {
    d: "M824.112 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1431 || (_path1431 = /*#__PURE__*/React.createElement("path", {
    d: "M885.529 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1432 || (_path1432 = /*#__PURE__*/React.createElement("path", {
    d: "M945.955 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1433 || (_path1433 = /*#__PURE__*/React.createElement("path", {
    d: "M645.805 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1434 || (_path1434 = /*#__PURE__*/React.createElement("path", {
    d: "M706.23 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1435 || (_path1435 = /*#__PURE__*/React.createElement("path", {
    d: "M767.647 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1436 || (_path1436 = /*#__PURE__*/React.createElement("path", {
    d: "M828.074 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1437 || (_path1437 = /*#__PURE__*/React.createElement("path", {
    d: "M889.491 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1438 || (_path1438 = /*#__PURE__*/React.createElement("path", {
    d: "M949.918 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1439 || (_path1439 = /*#__PURE__*/React.createElement("path", {
    d: "M649.767 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1440 || (_path1440 = /*#__PURE__*/React.createElement("path", {
    d: "M710.193 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1441 || (_path1441 = /*#__PURE__*/React.createElement("path", {
    d: "M771.61 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1442 || (_path1442 = /*#__PURE__*/React.createElement("path", {
    d: "M832.037 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1443 || (_path1443 = /*#__PURE__*/React.createElement("path", {
    d: "M893.454 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1444 || (_path1444 = /*#__PURE__*/React.createElement("path", {
    d: "M953.88 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1445 || (_path1445 = /*#__PURE__*/React.createElement("path", {
    d: "M652.738 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1446 || (_path1446 = /*#__PURE__*/React.createElement("path", {
    d: "M713.165 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1447 || (_path1447 = /*#__PURE__*/React.createElement("path", {
    d: "M774.582 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1448 || (_path1448 = /*#__PURE__*/React.createElement("path", {
    d: "M835.009 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1449 || (_path1449 = /*#__PURE__*/React.createElement("path", {
    d: "M896.426 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1450 || (_path1450 = /*#__PURE__*/React.createElement("path", {
    d: "M956.852 101.775V73.0479",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1451 || (_path1451 = /*#__PURE__*/React.createElement("path", {
    d: "M835.009 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1452 || (_path1452 = /*#__PURE__*/React.createElement("path", {
    d: "M837.98 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1453 || (_path1453 = /*#__PURE__*/React.createElement("path", {
    d: "M841.943 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1454 || (_path1454 = /*#__PURE__*/React.createElement("path", {
    d: "M845.905 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1455 || (_path1455 = /*#__PURE__*/React.createElement("path", {
    d: "M848.877 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1456 || (_path1456 = /*#__PURE__*/React.createElement("path", {
    d: "M852.84 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1457 || (_path1457 = /*#__PURE__*/React.createElement("path", {
    d: "M856.802 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1458 || (_path1458 = /*#__PURE__*/React.createElement("path", {
    d: "M859.773 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1459 || (_path1459 = /*#__PURE__*/React.createElement("path", {
    d: "M863.736 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1460 || (_path1460 = /*#__PURE__*/React.createElement("path", {
    d: "M867.698 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1461 || (_path1461 = /*#__PURE__*/React.createElement("path", {
    d: "M870.67 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1462 || (_path1462 = /*#__PURE__*/React.createElement("path", {
    d: "M874.633 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1463 || (_path1463 = /*#__PURE__*/React.createElement("path", {
    d: "M878.595 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1464 || (_path1464 = /*#__PURE__*/React.createElement("path", {
    d: "M881.566 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1465 || (_path1465 = /*#__PURE__*/React.createElement("path", {
    d: "M885.529 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1466 || (_path1466 = /*#__PURE__*/React.createElement("path", {
    d: "M889.491 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1467 || (_path1467 = /*#__PURE__*/React.createElement("path", {
    d: "M892.464 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1468 || (_path1468 = /*#__PURE__*/React.createElement("path", {
    d: "M895.436 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1469 || (_path1469 = /*#__PURE__*/React.createElement("path", {
    d: "M955.861 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1470 || (_path1470 = /*#__PURE__*/React.createElement("path", {
    d: "M1017.28 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1471 || (_path1471 = /*#__PURE__*/React.createElement("path", {
    d: "M1077.71 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1472 || (_path1472 = /*#__PURE__*/React.createElement("path", {
    d: "M1139.12 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1473 || (_path1473 = /*#__PURE__*/React.createElement("path", {
    d: "M1199.55 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1474 || (_path1474 = /*#__PURE__*/React.createElement("path", {
    d: "M898.407 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1475 || (_path1475 = /*#__PURE__*/React.createElement("path", {
    d: "M958.834 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1476 || (_path1476 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.25 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1477 || (_path1477 = /*#__PURE__*/React.createElement("path", {
    d: "M1080.68 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1478 || (_path1478 = /*#__PURE__*/React.createElement("path", {
    d: "M1142.09 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1479 || (_path1479 = /*#__PURE__*/React.createElement("path", {
    d: "M1202.52 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1480 || (_path1480 = /*#__PURE__*/React.createElement("path", {
    d: "M902.369 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1481 || (_path1481 = /*#__PURE__*/React.createElement("path", {
    d: "M962.796 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1482 || (_path1482 = /*#__PURE__*/React.createElement("path", {
    d: "M1024.21 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1483 || (_path1483 = /*#__PURE__*/React.createElement("path", {
    d: "M1084.64 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1484 || (_path1484 = /*#__PURE__*/React.createElement("path", {
    d: "M1146.06 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1485 || (_path1485 = /*#__PURE__*/React.createElement("path", {
    d: "M1206.48 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1486 || (_path1486 = /*#__PURE__*/React.createElement("path", {
    d: "M906.332 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1487 || (_path1487 = /*#__PURE__*/React.createElement("path", {
    d: "M966.758 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1488 || (_path1488 = /*#__PURE__*/React.createElement("path", {
    d: "M1028.18 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1489 || (_path1489 = /*#__PURE__*/React.createElement("path", {
    d: "M1088.6 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1490 || (_path1490 = /*#__PURE__*/React.createElement("path", {
    d: "M1150.02 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1491 || (_path1491 = /*#__PURE__*/React.createElement("path", {
    d: "M1210.45 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1492 || (_path1492 = /*#__PURE__*/React.createElement("path", {
    d: "M909.304 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1493 || (_path1493 = /*#__PURE__*/React.createElement("path", {
    d: "M969.73 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1494 || (_path1494 = /*#__PURE__*/React.createElement("path", {
    d: "M1031.15 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1495 || (_path1495 = /*#__PURE__*/React.createElement("path", {
    d: "M1091.57 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1496 || (_path1496 = /*#__PURE__*/React.createElement("path", {
    d: "M1152.99 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1497 || (_path1497 = /*#__PURE__*/React.createElement("path", {
    d: "M1213.42 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1498 || (_path1498 = /*#__PURE__*/React.createElement("path", {
    d: "M913.266 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1499 || (_path1499 = /*#__PURE__*/React.createElement("path", {
    d: "M973.692 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1500 || (_path1500 = /*#__PURE__*/React.createElement("path", {
    d: "M1035.11 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1501 || (_path1501 = /*#__PURE__*/React.createElement("path", {
    d: "M1095.54 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1502 || (_path1502 = /*#__PURE__*/React.createElement("path", {
    d: "M1156.95 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1503 || (_path1503 = /*#__PURE__*/React.createElement("path", {
    d: "M1217.38 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1504 || (_path1504 = /*#__PURE__*/React.createElement("path", {
    d: "M917.229 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1505 || (_path1505 = /*#__PURE__*/React.createElement("path", {
    d: "M977.655 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1506 || (_path1506 = /*#__PURE__*/React.createElement("path", {
    d: "M1039.07 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1507 || (_path1507 = /*#__PURE__*/React.createElement("path", {
    d: "M1099.5 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1508 || (_path1508 = /*#__PURE__*/React.createElement("path", {
    d: "M1160.92 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1509 || (_path1509 = /*#__PURE__*/React.createElement("path", {
    d: "M1221.34 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1510 || (_path1510 = /*#__PURE__*/React.createElement("path", {
    d: "M920.2 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1511 || (_path1511 = /*#__PURE__*/React.createElement("path", {
    d: "M980.627 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1512 || (_path1512 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.04 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1513 || (_path1513 = /*#__PURE__*/React.createElement("path", {
    d: "M1102.47 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1514 || (_path1514 = /*#__PURE__*/React.createElement("path", {
    d: "M1163.89 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1515 || (_path1515 = /*#__PURE__*/React.createElement("path", {
    d: "M1224.31 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1516 || (_path1516 = /*#__PURE__*/React.createElement("path", {
    d: "M924.162 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1517 || (_path1517 = /*#__PURE__*/React.createElement("path", {
    d: "M984.589 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1518 || (_path1518 = /*#__PURE__*/React.createElement("path", {
    d: "M1046.01 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1519 || (_path1519 = /*#__PURE__*/React.createElement("path", {
    d: "M1106.43 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1520 || (_path1520 = /*#__PURE__*/React.createElement("path", {
    d: "M1167.85 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1521 || (_path1521 = /*#__PURE__*/React.createElement("path", {
    d: "M1228.28 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1522 || (_path1522 = /*#__PURE__*/React.createElement("path", {
    d: "M928.125 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1523 || (_path1523 = /*#__PURE__*/React.createElement("path", {
    d: "M988.552 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1524 || (_path1524 = /*#__PURE__*/React.createElement("path", {
    d: "M1049.97 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1525 || (_path1525 = /*#__PURE__*/React.createElement("path", {
    d: "M1110.39 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1526 || (_path1526 = /*#__PURE__*/React.createElement("path", {
    d: "M1171.81 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1527 || (_path1527 = /*#__PURE__*/React.createElement("path", {
    d: "M1232.24 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1528 || (_path1528 = /*#__PURE__*/React.createElement("path", {
    d: "M931.097 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1529 || (_path1529 = /*#__PURE__*/React.createElement("path", {
    d: "M991.523 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1530 || (_path1530 = /*#__PURE__*/React.createElement("path", {
    d: "M1052.94 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1531 || (_path1531 = /*#__PURE__*/React.createElement("path", {
    d: "M1113.37 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1532 || (_path1532 = /*#__PURE__*/React.createElement("path", {
    d: "M1174.78 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1533 || (_path1533 = /*#__PURE__*/React.createElement("path", {
    d: "M1235.21 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1534 || (_path1534 = /*#__PURE__*/React.createElement("path", {
    d: "M935.06 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1535 || (_path1535 = /*#__PURE__*/React.createElement("path", {
    d: "M995.485 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1536 || (_path1536 = /*#__PURE__*/React.createElement("path", {
    d: "M1056.9 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1537 || (_path1537 = /*#__PURE__*/React.createElement("path", {
    d: "M1117.33 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1538 || (_path1538 = /*#__PURE__*/React.createElement("path", {
    d: "M1178.75 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1539 || (_path1539 = /*#__PURE__*/React.createElement("path", {
    d: "M1239.17 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1540 || (_path1540 = /*#__PURE__*/React.createElement("path", {
    d: "M939.021 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1541 || (_path1541 = /*#__PURE__*/React.createElement("path", {
    d: "M999.448 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1542 || (_path1542 = /*#__PURE__*/React.createElement("path", {
    d: "M1060.87 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1543 || (_path1543 = /*#__PURE__*/React.createElement("path", {
    d: "M1121.29 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1544 || (_path1544 = /*#__PURE__*/React.createElement("path", {
    d: "M1182.71 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1545 || (_path1545 = /*#__PURE__*/React.createElement("path", {
    d: "M1243.13 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1546 || (_path1546 = /*#__PURE__*/React.createElement("path", {
    d: "M941.993 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1547 || (_path1547 = /*#__PURE__*/React.createElement("path", {
    d: "M1002.42 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1548 || (_path1548 = /*#__PURE__*/React.createElement("path", {
    d: "M1063.84 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1549 || (_path1549 = /*#__PURE__*/React.createElement("path", {
    d: "M1124.26 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1550 || (_path1550 = /*#__PURE__*/React.createElement("path", {
    d: "M1185.68 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1551 || (_path1551 = /*#__PURE__*/React.createElement("path", {
    d: "M945.956 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1552 || (_path1552 = /*#__PURE__*/React.createElement("path", {
    d: "M1006.38 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1553 || (_path1553 = /*#__PURE__*/React.createElement("path", {
    d: "M1067.8 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1554 || (_path1554 = /*#__PURE__*/React.createElement("path", {
    d: "M1128.23 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1555 || (_path1555 = /*#__PURE__*/React.createElement("path", {
    d: "M1189.64 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1556 || (_path1556 = /*#__PURE__*/React.createElement("path", {
    d: "M1250.07 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1557 || (_path1557 = /*#__PURE__*/React.createElement("path", {
    d: "M949.918 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1558 || (_path1558 = /*#__PURE__*/React.createElement("path", {
    d: "M1010.34 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1559 || (_path1559 = /*#__PURE__*/React.createElement("path", {
    d: "M1071.76 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1560 || (_path1560 = /*#__PURE__*/React.createElement("path", {
    d: "M1132.19 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1561 || (_path1561 = /*#__PURE__*/React.createElement("path", {
    d: "M1193.61 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1562 || (_path1562 = /*#__PURE__*/React.createElement("path", {
    d: "M1254.03 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1563 || (_path1563 = /*#__PURE__*/React.createElement("path", {
    d: "M952.89 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1564 || (_path1564 = /*#__PURE__*/React.createElement("path", {
    d: "M1013.32 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1565 || (_path1565 = /*#__PURE__*/React.createElement("path", {
    d: "M1074.73 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1566 || (_path1566 = /*#__PURE__*/React.createElement("path", {
    d: "M1135.16 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1567 || (_path1567 = /*#__PURE__*/React.createElement("path", {
    d: "M1196.58 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1568 || (_path1568 = /*#__PURE__*/React.createElement("path", {
    d: "M1257 478.202V449.475",
    stroke: "#2CAD39",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  })), _path1569 || (_path1569 = /*#__PURE__*/React.createElement("path", {
    d: "M266.406 209.85H262.667V189.69H266.406",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1570 || (_path1570 = /*#__PURE__*/React.createElement("path", {
    d: "M266.406 181.849H262.667V161.689H266.406",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1571 || (_path1571 = /*#__PURE__*/React.createElement("path", {
    d: "M266.406 153.85H262.667V133.689H266.406",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1572 || (_path1572 = /*#__PURE__*/React.createElement("path", {
    d: "M266.406 124.729H262.667V104.568H266.406",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1573 || (_path1573 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.351 212.59H246.466V211.59H245.72V209.85H244.72V211.59H243.351V212.59Z",
    fill: "#2CAD39"
  })), _path1574 || (_path1574 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.351 184.589H246.466V183.589H245.72V181.849H244.72V183.589H243.351V184.589Z",
    fill: "#2CAD39"
  })), _path1575 || (_path1575 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.351 156.589H246.466V155.589H245.72V153.849H244.72V155.589H243.351V156.589Z",
    fill: "#2CAD39"
  })), _path1576 || (_path1576 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.351 127.468H246.466V126.468H245.72V124.728H244.72V126.468H243.351V127.468Z",
    fill: "#2CAD39"
  })), _path1577 || (_path1577 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.119 212.59H240.235V211.59H239.488V209.85H238.488V211.59H237.119V212.59Z",
    fill: "#2CAD39"
  })), _path1578 || (_path1578 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.119 184.589H240.235V183.589H239.488V181.849H238.488V183.589H237.119V184.589Z",
    fill: "#2CAD39"
  })), _path1579 || (_path1579 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.119 156.589H240.235V155.589H239.488V153.849H238.488V155.589H237.119V156.589Z",
    fill: "#2CAD39"
  })), _path1580 || (_path1580 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.119 127.468H240.235V126.468H239.488V124.728H238.488V126.468H237.119V127.468Z",
    fill: "#2CAD39"
  })), _path1581 || (_path1581 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.828 212.59H253.944V211.59H253.198V209.85H252.198V211.59H250.828V212.59Z",
    fill: "#2CAD39"
  })), _path1582 || (_path1582 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.828 184.589H253.944V183.589H253.198V181.849H252.198V183.589H250.828V184.589Z",
    fill: "#2CAD39"
  })), _path1583 || (_path1583 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.828 156.589H253.944V155.589H253.198V153.849H252.198V155.589H250.828V156.589Z",
    fill: "#2CAD39"
  })), _path1584 || (_path1584 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.828 127.468H253.944V126.468H253.198V124.728H252.198V126.468H250.828V127.468Z",
    fill: "#2CAD39"
  })), _path1585 || (_path1585 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.351 188.63H246.466V189.63H245.72V191.37H244.72V189.63H243.351V188.63Z",
    fill: "#2CAD39"
  })), _path1586 || (_path1586 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.351 160.628H246.466V161.628H245.72V163.368H244.72V161.628H243.351V160.628Z",
    fill: "#2CAD39"
  })), _path1587 || (_path1587 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.351 132.629H246.466V133.629H245.72V135.369H244.72V133.629H243.351V132.629Z",
    fill: "#2CAD39"
  })), _path1588 || (_path1588 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.351 103.507H246.466V104.507H245.72V106.247H244.72V104.507H243.351V103.507Z",
    fill: "#2CAD39"
  })), _path1589 || (_path1589 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.119 188.63H240.235V189.63H239.488V191.37H238.488V189.63H237.119V188.63Z",
    fill: "#2CAD39"
  })), _path1590 || (_path1590 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.119 160.628H240.235V161.628H239.488V163.368H238.488V161.628H237.119V160.628Z",
    fill: "#2CAD39"
  })), _path1591 || (_path1591 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.119 132.629H240.235V133.629H239.488V135.369H238.488V133.629H237.119V132.629Z",
    fill: "#2CAD39"
  })), _path1592 || (_path1592 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.119 103.507H240.235V104.507H239.488V106.247H238.488V104.507H237.119V103.507Z",
    fill: "#2CAD39"
  })), _path1593 || (_path1593 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.828 188.63H253.944V189.63H253.198V191.37H252.198V189.63H250.828V188.63Z",
    fill: "#2CAD39"
  })), _path1594 || (_path1594 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.828 160.628H253.944V161.628H253.198V163.368H252.198V161.628H250.828V160.628Z",
    fill: "#2CAD39"
  })), _path1595 || (_path1595 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.828 132.629H253.944V133.629H253.198V135.369H252.198V133.629H250.828V132.629Z",
    fill: "#2CAD39"
  })), _path1596 || (_path1596 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.828 103.507H253.944V104.507H253.198V106.247H252.198V104.507H250.828V103.507Z",
    fill: "#2CAD39"
  })), _path1597 || (_path1597 = /*#__PURE__*/React.createElement("path", {
    d: "M227.772 213.21H230.265V188.009H227.772",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1598 || (_path1598 = /*#__PURE__*/React.createElement("path", {
    d: "M227.772 185.21H230.265V160.01H227.772",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1599 || (_path1599 = /*#__PURE__*/React.createElement("path", {
    d: "M227.772 157.208H230.265V132.008H227.772",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1600 || (_path1600 = /*#__PURE__*/React.createElement("path", {
    d: "M227.772 128.088H230.265V102.888H227.772",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1601 || (_path1601 = /*#__PURE__*/React.createElement("path", {
    d: "M263.29 212.65H260.798V187.449H263.29",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1602 || (_path1602 = /*#__PURE__*/React.createElement("path", {
    d: "M263.29 184.649H260.798V159.449H263.29",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1603 || (_path1603 = /*#__PURE__*/React.createElement("path", {
    d: "M263.29 156.649H260.798V131.449H263.29",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1604 || (_path1604 = /*#__PURE__*/React.createElement("path", {
    d: "M263.29 127.528H260.798V102.328H263.29",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1605 || (_path1605 = /*#__PURE__*/React.createElement("path", {
    d: "M232.758 212.65V209.85H257.683V212.09",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1606 || (_path1606 = /*#__PURE__*/React.createElement("path", {
    d: "M232.758 184.649V181.849H257.683V184.089",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1607 || (_path1607 = /*#__PURE__*/React.createElement("path", {
    d: "M232.758 156.649V153.849H257.683V156.089",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1608 || (_path1608 = /*#__PURE__*/React.createElement("path", {
    d: "M232.758 127.528V124.728H257.683V126.968",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1609 || (_path1609 = /*#__PURE__*/React.createElement("path", {
    d: "M233.381 188.569V191.369H258.306V189.129",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1610 || (_path1610 = /*#__PURE__*/React.createElement("path", {
    d: "M233.381 160.569V163.369H258.306V161.129",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1611 || (_path1611 = /*#__PURE__*/React.createElement("path", {
    d: "M233.381 132.568V135.368H258.306V133.128",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1612 || (_path1612 = /*#__PURE__*/React.createElement("path", {
    d: "M233.381 103.447V106.247H258.306V104.007",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1613 || (_path1613 = /*#__PURE__*/React.createElement("path", {
    d: "M244.597 208.17H234.004V193.61H244.597",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1614 || (_path1614 = /*#__PURE__*/React.createElement("path", {
    d: "M244.597 180.17H234.004V165.61H244.597",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1615 || (_path1615 = /*#__PURE__*/React.createElement("path", {
    d: "M244.597 152.168H234.004V137.608H244.597",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1616 || (_path1616 = /*#__PURE__*/React.createElement("path", {
    d: "M244.597 123.048H234.004V108.488H244.597",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1617 || (_path1617 = /*#__PURE__*/React.createElement("path", {
    d: "M258.929 208.17H248.336V193.61H258.929",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1618 || (_path1618 = /*#__PURE__*/React.createElement("path", {
    d: "M258.929 180.17H248.336V165.61H258.929",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1619 || (_path1619 = /*#__PURE__*/React.createElement("path", {
    d: "M258.929 152.168H248.336V137.608H258.929",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1620 || (_path1620 = /*#__PURE__*/React.createElement("path", {
    d: "M258.929 123.048H248.336V108.488H258.929",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1621 || (_path1621 = /*#__PURE__*/React.createElement("path", {
    d: "M299.59 209.85H295.852V189.69H299.59",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1622 || (_path1622 = /*#__PURE__*/React.createElement("path", {
    d: "M299.59 181.849H295.852V161.689H299.59",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1623 || (_path1623 = /*#__PURE__*/React.createElement("path", {
    d: "M299.59 153.85H295.852V133.689H299.59",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1624 || (_path1624 = /*#__PURE__*/React.createElement("path", {
    d: "M299.59 124.729H295.852V104.568H299.59",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1625 || (_path1625 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M276.535 212.59H279.651V211.59H278.904V209.85H277.904V211.59H276.535V212.59Z",
    fill: "#2CAD39"
  })), _path1626 || (_path1626 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M276.535 184.589H279.651V183.589H278.904V181.849H277.904V183.589H276.535V184.589Z",
    fill: "#2CAD39"
  })), _path1627 || (_path1627 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M276.535 156.589H279.651V155.589H278.904V153.849H277.904V155.589H276.535V156.589Z",
    fill: "#2CAD39"
  })), _path1628 || (_path1628 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M276.535 127.468H279.651V126.468H278.904V124.728H277.904V126.468H276.535V127.468Z",
    fill: "#2CAD39"
  })), _path1629 || (_path1629 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.304 212.59H273.419V211.59H272.673V209.85H271.673V211.59H270.304V212.59Z",
    fill: "#2CAD39"
  })), _path1630 || (_path1630 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.304 184.589H273.419V183.589H272.673V181.849H271.673V183.589H270.304V184.589Z",
    fill: "#2CAD39"
  })), _path1631 || (_path1631 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.304 156.589H273.419V155.589H272.673V153.849H271.673V155.589H270.304V156.589Z",
    fill: "#2CAD39"
  })), _path1632 || (_path1632 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.304 127.468H273.419V126.468H272.673V124.728H271.673V126.468H270.304V127.468Z",
    fill: "#2CAD39"
  })), _path1633 || (_path1633 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.013 212.59H287.128V211.59H286.382V209.85H285.382V211.59H284.013V212.59Z",
    fill: "#2CAD39"
  })), _path1634 || (_path1634 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.013 184.589H287.128V183.589H286.382V181.849H285.382V183.589H284.013V184.589Z",
    fill: "#2CAD39"
  })), _path1635 || (_path1635 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.013 156.589H287.128V155.589H286.382V153.849H285.382V155.589H284.013V156.589Z",
    fill: "#2CAD39"
  })), _path1636 || (_path1636 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.013 127.468H287.128V126.468H286.382V124.728H285.382V126.468H284.013V127.468Z",
    fill: "#2CAD39"
  })), _path1637 || (_path1637 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M276.535 188.63H279.651V189.63H278.904V191.37H277.904V189.63H276.535V188.63Z",
    fill: "#2CAD39"
  })), _path1638 || (_path1638 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M276.535 160.628H279.651V161.628H278.904V163.368H277.904V161.628H276.535V160.628Z",
    fill: "#2CAD39"
  })), _path1639 || (_path1639 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M276.535 132.629H279.651V133.629H278.904V135.369H277.904V133.629H276.535V132.629Z",
    fill: "#2CAD39"
  })), _path1640 || (_path1640 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M276.535 103.507H279.651V104.507H278.904V106.247H277.904V104.507H276.535V103.507Z",
    fill: "#2CAD39"
  })), _path1641 || (_path1641 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.304 188.63H273.419V189.63H272.673V191.37H271.673V189.63H270.304V188.63Z",
    fill: "#2CAD39"
  })), _path1642 || (_path1642 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.304 160.628H273.419V161.628H272.673V163.368H271.673V161.628H270.304V160.628Z",
    fill: "#2CAD39"
  })), _path1643 || (_path1643 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.304 132.629H273.419V133.629H272.673V135.369H271.673V133.629H270.304V132.629Z",
    fill: "#2CAD39"
  })), _path1644 || (_path1644 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.304 103.507H273.419V104.507H272.673V106.247H271.673V104.507H270.304V103.507Z",
    fill: "#2CAD39"
  })), _path1645 || (_path1645 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.013 188.63H287.128V189.63H286.382V191.37H285.382V189.63H284.013V188.63Z",
    fill: "#2CAD39"
  })), _path1646 || (_path1646 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.013 160.628H287.128V161.628H286.382V163.368H285.382V161.628H284.013V160.628Z",
    fill: "#2CAD39"
  })), _path1647 || (_path1647 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.013 132.629H287.128V133.629H286.382V135.369H285.382V133.629H284.013V132.629Z",
    fill: "#2CAD39"
  })), _path1648 || (_path1648 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.013 103.507H287.128V104.507H286.382V106.247H285.382V104.507H284.013V103.507Z",
    fill: "#2CAD39"
  })), _path1649 || (_path1649 = /*#__PURE__*/React.createElement("path", {
    d: "M260.957 213.21H263.45V188.009H260.957",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1650 || (_path1650 = /*#__PURE__*/React.createElement("path", {
    d: "M260.957 185.21H263.45V160.01H260.957",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1651 || (_path1651 = /*#__PURE__*/React.createElement("path", {
    d: "M260.957 157.208H263.45V132.008H260.957",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1652 || (_path1652 = /*#__PURE__*/React.createElement("path", {
    d: "M260.957 128.088H263.45V102.888H260.957",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1653 || (_path1653 = /*#__PURE__*/React.createElement("path", {
    d: "M296.475 212.65H293.982V187.449H296.475",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1654 || (_path1654 = /*#__PURE__*/React.createElement("path", {
    d: "M296.475 184.649H293.982V159.449H296.475",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1655 || (_path1655 = /*#__PURE__*/React.createElement("path", {
    d: "M296.475 156.649H293.982V131.449H296.475",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1656 || (_path1656 = /*#__PURE__*/React.createElement("path", {
    d: "M296.475 127.528H293.982V102.328H296.475",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1657 || (_path1657 = /*#__PURE__*/React.createElement("path", {
    d: "M265.942 212.65V209.85H290.867V212.09",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1658 || (_path1658 = /*#__PURE__*/React.createElement("path", {
    d: "M265.942 184.649V181.849H290.867V184.089",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1659 || (_path1659 = /*#__PURE__*/React.createElement("path", {
    d: "M265.942 156.649V153.849H290.867V156.089",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1660 || (_path1660 = /*#__PURE__*/React.createElement("path", {
    d: "M265.942 127.528V124.728H290.867V126.968",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1661 || (_path1661 = /*#__PURE__*/React.createElement("path", {
    d: "M266.565 188.569V191.369H291.49V189.129",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1662 || (_path1662 = /*#__PURE__*/React.createElement("path", {
    d: "M266.565 160.569V163.369H291.49V161.129",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1663 || (_path1663 = /*#__PURE__*/React.createElement("path", {
    d: "M266.565 132.568V135.368H291.49V133.128",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1664 || (_path1664 = /*#__PURE__*/React.createElement("path", {
    d: "M266.565 103.447V106.247H291.49V104.007",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1665 || (_path1665 = /*#__PURE__*/React.createElement("path", {
    d: "M277.781 208.17H267.188V193.61H277.781",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1666 || (_path1666 = /*#__PURE__*/React.createElement("path", {
    d: "M277.781 180.17H267.188V165.61H277.781",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1667 || (_path1667 = /*#__PURE__*/React.createElement("path", {
    d: "M277.781 152.168H267.188V137.608H277.781",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1668 || (_path1668 = /*#__PURE__*/React.createElement("path", {
    d: "M277.781 123.048H267.188V108.488H277.781",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1669 || (_path1669 = /*#__PURE__*/React.createElement("path", {
    d: "M292.114 208.17H281.521V193.61H292.114",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1670 || (_path1670 = /*#__PURE__*/React.createElement("path", {
    d: "M292.114 180.17H281.521V165.61H292.114",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1671 || (_path1671 = /*#__PURE__*/React.createElement("path", {
    d: "M292.114 152.168H281.521V137.608H292.114",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1672 || (_path1672 = /*#__PURE__*/React.createElement("path", {
    d: "M292.114 123.048H281.521V108.488H292.114",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1673 || (_path1673 = /*#__PURE__*/React.createElement("path", {
    d: "M332.776 209.85H329.037V189.69H332.776",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1674 || (_path1674 = /*#__PURE__*/React.createElement("path", {
    d: "M332.776 181.849H329.037V161.689H332.776",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1675 || (_path1675 = /*#__PURE__*/React.createElement("path", {
    d: "M332.776 153.85H329.037V133.689H332.776",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1676 || (_path1676 = /*#__PURE__*/React.createElement("path", {
    d: "M332.776 124.729H329.037V104.568H332.776",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1677 || (_path1677 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.721 212.59H312.836V211.59H312.09V209.85H311.09V211.59H309.721V212.59Z",
    fill: "#2CAD39"
  })), _path1678 || (_path1678 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.721 184.589H312.836V183.589H312.09V181.849H311.09V183.589H309.721V184.589Z",
    fill: "#2CAD39"
  })), _path1679 || (_path1679 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.721 156.589H312.836V155.589H312.09V153.849H311.09V155.589H309.721V156.589Z",
    fill: "#2CAD39"
  })), _path1680 || (_path1680 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.721 127.468H312.836V126.468H312.09V124.728H311.09V126.468H309.721V127.468Z",
    fill: "#2CAD39"
  })), _path1681 || (_path1681 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.489 212.59H306.605V211.59H305.859V209.85H304.859V211.59H303.489V212.59Z",
    fill: "#2CAD39"
  })), _path1682 || (_path1682 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.489 184.589H306.605V183.589H305.859V181.849H304.859V183.589H303.489V184.589Z",
    fill: "#2CAD39"
  })), _path1683 || (_path1683 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.489 156.589H306.605V155.589H305.859V153.849H304.859V155.589H303.489V156.589Z",
    fill: "#2CAD39"
  })), _path1684 || (_path1684 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.489 127.468H306.605V126.468H305.859V124.728H304.859V126.468H303.489V127.468Z",
    fill: "#2CAD39"
  })), _path1685 || (_path1685 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.198 212.59H320.314V211.59H319.568V209.85H318.568V211.59H317.198V212.59Z",
    fill: "#2CAD39"
  })), _path1686 || (_path1686 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.198 184.589H320.314V183.589H319.568V181.849H318.568V183.589H317.198V184.589Z",
    fill: "#2CAD39"
  })), _path1687 || (_path1687 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.198 156.589H320.314V155.589H319.568V153.849H318.568V155.589H317.198V156.589Z",
    fill: "#2CAD39"
  })), _path1688 || (_path1688 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.198 127.468H320.314V126.468H319.568V124.728H318.568V126.468H317.198V127.468Z",
    fill: "#2CAD39"
  })), _path1689 || (_path1689 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.721 188.63H312.836V189.63H312.09V191.37H311.09V189.63H309.721V188.63Z",
    fill: "#2CAD39"
  })), _path1690 || (_path1690 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.721 160.628H312.836V161.628H312.09V163.368H311.09V161.628H309.721V160.628Z",
    fill: "#2CAD39"
  })), _path1691 || (_path1691 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.721 132.629H312.836V133.629H312.09V135.369H311.09V133.629H309.721V132.629Z",
    fill: "#2CAD39"
  })), _path1692 || (_path1692 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.721 103.507H312.836V104.507H312.09V106.247H311.09V104.507H309.721V103.507Z",
    fill: "#2CAD39"
  })), _path1693 || (_path1693 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.489 188.63H306.605V189.63H305.859V191.37H304.859V189.63H303.489V188.63Z",
    fill: "#2CAD39"
  })), _path1694 || (_path1694 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.489 160.628H306.605V161.628H305.859V163.368H304.859V161.628H303.489V160.628Z",
    fill: "#2CAD39"
  })), _path1695 || (_path1695 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.489 132.629H306.605V133.629H305.859V135.369H304.859V133.629H303.489V132.629Z",
    fill: "#2CAD39"
  })), _path1696 || (_path1696 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.489 103.507H306.605V104.507H305.859V106.247H304.859V104.507H303.489V103.507Z",
    fill: "#2CAD39"
  })), _path1697 || (_path1697 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.198 188.63H320.314V189.63H319.568V191.37H318.568V189.63H317.198V188.63Z",
    fill: "#2CAD39"
  })), _path1698 || (_path1698 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.198 160.628H320.314V161.628H319.568V163.368H318.568V161.628H317.198V160.628Z",
    fill: "#2CAD39"
  })), _path1699 || (_path1699 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.198 132.629H320.314V133.629H319.568V135.369H318.568V133.629H317.198V132.629Z",
    fill: "#2CAD39"
  })), _path1700 || (_path1700 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.198 103.507H320.314V104.507H319.568V106.247H318.568V104.507H317.198V103.507Z",
    fill: "#2CAD39"
  })), _path1701 || (_path1701 = /*#__PURE__*/React.createElement("path", {
    d: "M294.143 213.21H296.635V188.009H294.143",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1702 || (_path1702 = /*#__PURE__*/React.createElement("path", {
    d: "M294.143 185.21H296.635V160.01H294.143",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1703 || (_path1703 = /*#__PURE__*/React.createElement("path", {
    d: "M294.143 157.208H296.635V132.008H294.143",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1704 || (_path1704 = /*#__PURE__*/React.createElement("path", {
    d: "M294.143 128.088H296.635V102.888H294.143",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1705 || (_path1705 = /*#__PURE__*/React.createElement("path", {
    d: "M329.66 212.65H327.168V187.449H329.66",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1706 || (_path1706 = /*#__PURE__*/React.createElement("path", {
    d: "M329.66 184.649H327.168V159.449H329.66",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1707 || (_path1707 = /*#__PURE__*/React.createElement("path", {
    d: "M329.66 156.649H327.168V131.449H329.66",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1708 || (_path1708 = /*#__PURE__*/React.createElement("path", {
    d: "M329.66 127.528H327.168V102.328H329.66",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1709 || (_path1709 = /*#__PURE__*/React.createElement("path", {
    d: "M299.128 212.65V209.85H324.053V212.09",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1710 || (_path1710 = /*#__PURE__*/React.createElement("path", {
    d: "M299.128 184.649V181.849H324.053V184.089",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1711 || (_path1711 = /*#__PURE__*/React.createElement("path", {
    d: "M299.128 156.649V153.849H324.053V156.089",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1712 || (_path1712 = /*#__PURE__*/React.createElement("path", {
    d: "M299.128 127.528V124.728H324.053V126.968",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1713 || (_path1713 = /*#__PURE__*/React.createElement("path", {
    d: "M299.751 188.569V191.369H324.676V189.129",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1714 || (_path1714 = /*#__PURE__*/React.createElement("path", {
    d: "M299.751 160.569V163.369H324.676V161.129",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1715 || (_path1715 = /*#__PURE__*/React.createElement("path", {
    d: "M299.751 132.568V135.368H324.676V133.128",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1716 || (_path1716 = /*#__PURE__*/React.createElement("path", {
    d: "M299.751 103.447V106.247H324.676V104.007",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1717 || (_path1717 = /*#__PURE__*/React.createElement("path", {
    d: "M310.967 208.17H300.374V193.61H310.967",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1718 || (_path1718 = /*#__PURE__*/React.createElement("path", {
    d: "M310.967 180.17H300.374V165.61H310.967",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1719 || (_path1719 = /*#__PURE__*/React.createElement("path", {
    d: "M310.967 152.168H300.374V137.608H310.967",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1720 || (_path1720 = /*#__PURE__*/React.createElement("path", {
    d: "M310.967 123.048H300.374V108.488H310.967",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1721 || (_path1721 = /*#__PURE__*/React.createElement("path", {
    d: "M325.299 208.17H314.706V193.61H325.299",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1722 || (_path1722 = /*#__PURE__*/React.createElement("path", {
    d: "M325.299 180.17H314.706V165.61H325.299",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1723 || (_path1723 = /*#__PURE__*/React.createElement("path", {
    d: "M325.299 152.168H314.706V137.608H325.299",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1724 || (_path1724 = /*#__PURE__*/React.createElement("path", {
    d: "M325.299 123.048H314.706V108.488H325.299",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1725 || (_path1725 = /*#__PURE__*/React.createElement("path", {
    d: "M365.96 209.85H362.222V189.69H365.96",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1726 || (_path1726 = /*#__PURE__*/React.createElement("path", {
    d: "M365.96 181.849H362.222V161.689H365.96",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1727 || (_path1727 = /*#__PURE__*/React.createElement("path", {
    d: "M365.96 153.85H362.222V133.689H365.96",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1728 || (_path1728 = /*#__PURE__*/React.createElement("path", {
    d: "M365.96 124.729H362.222V104.568H365.96",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1729 || (_path1729 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M342.905 212.59H346.021V211.59H345.275V209.85H344.275V211.59H342.905V212.59Z",
    fill: "#2CAD39"
  })), _path1730 || (_path1730 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M342.905 184.589H346.021V183.589H345.275V181.849H344.275V183.589H342.905V184.589Z",
    fill: "#2CAD39"
  })), _path1731 || (_path1731 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M342.905 156.589H346.021V155.589H345.275V153.849H344.275V155.589H342.905V156.589Z",
    fill: "#2CAD39"
  })), _path1732 || (_path1732 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M342.905 127.468H346.021V126.468H345.275V124.728H344.275V126.468H342.905V127.468Z",
    fill: "#2CAD39"
  })), _path1733 || (_path1733 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M336.674 212.59H339.789V211.59H339.043V209.85H338.043V211.59H336.674V212.59Z",
    fill: "#2CAD39"
  })), _path1734 || (_path1734 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M336.674 184.589H339.789V183.589H339.043V181.849H338.043V183.589H336.674V184.589Z",
    fill: "#2CAD39"
  })), _path1735 || (_path1735 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M336.674 156.589H339.789V155.589H339.043V153.849H338.043V155.589H336.674V156.589Z",
    fill: "#2CAD39"
  })), _path1736 || (_path1736 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M336.674 127.468H339.789V126.468H339.043V124.728H338.043V126.468H336.674V127.468Z",
    fill: "#2CAD39"
  })), _path1737 || (_path1737 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M350.383 212.59H353.498V211.59H352.752V209.85H351.752V211.59H350.383V212.59Z",
    fill: "#2CAD39"
  })), _path1738 || (_path1738 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M350.383 184.589H353.498V183.589H352.752V181.849H351.752V183.589H350.383V184.589Z",
    fill: "#2CAD39"
  })), _path1739 || (_path1739 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M350.383 156.589H353.498V155.589H352.752V153.849H351.752V155.589H350.383V156.589Z",
    fill: "#2CAD39"
  })), _path1740 || (_path1740 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M350.383 127.468H353.498V126.468H352.752V124.728H351.752V126.468H350.383V127.468Z",
    fill: "#2CAD39"
  })), _path1741 || (_path1741 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M342.905 188.63H346.021V189.63H345.275V191.37H344.275V189.63H342.905V188.63Z",
    fill: "#2CAD39"
  })), _path1742 || (_path1742 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M342.905 160.628H346.021V161.628H345.275V163.368H344.275V161.628H342.905V160.628Z",
    fill: "#2CAD39"
  })), _path1743 || (_path1743 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M342.905 132.629H346.021V133.629H345.275V135.369H344.275V133.629H342.905V132.629Z",
    fill: "#2CAD39"
  })), _path1744 || (_path1744 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M342.905 103.507H346.021V104.507H345.275V106.247H344.275V104.507H342.905V103.507Z",
    fill: "#2CAD39"
  })), _path1745 || (_path1745 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M336.674 188.63H339.789V189.63H339.043V191.37H338.043V189.63H336.674V188.63Z",
    fill: "#2CAD39"
  })), _path1746 || (_path1746 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M336.674 160.628H339.789V161.628H339.043V163.368H338.043V161.628H336.674V160.628Z",
    fill: "#2CAD39"
  })), _path1747 || (_path1747 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M336.674 132.629H339.789V133.629H339.043V135.369H338.043V133.629H336.674V132.629Z",
    fill: "#2CAD39"
  })), _path1748 || (_path1748 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M336.674 103.507H339.789V104.507H339.043V106.247H338.043V104.507H336.674V103.507Z",
    fill: "#2CAD39"
  })), _path1749 || (_path1749 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M350.383 188.63H353.498V189.63H352.752V191.37H351.752V189.63H350.383V188.63Z",
    fill: "#2CAD39"
  })), _path1750 || (_path1750 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M350.383 160.628H353.498V161.628H352.752V163.368H351.752V161.628H350.383V160.628Z",
    fill: "#2CAD39"
  })), _path1751 || (_path1751 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M350.383 132.629H353.498V133.629H352.752V135.369H351.752V133.629H350.383V132.629Z",
    fill: "#2CAD39"
  })), _path1752 || (_path1752 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M350.383 103.507H353.498V104.507H352.752V106.247H351.752V104.507H350.383V103.507Z",
    fill: "#2CAD39"
  })), _path1753 || (_path1753 = /*#__PURE__*/React.createElement("path", {
    d: "M327.327 213.21H329.82V188.009H327.327",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1754 || (_path1754 = /*#__PURE__*/React.createElement("path", {
    d: "M327.327 185.21H329.82V160.01H327.327",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1755 || (_path1755 = /*#__PURE__*/React.createElement("path", {
    d: "M327.327 157.208H329.82V132.008H327.327",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1756 || (_path1756 = /*#__PURE__*/React.createElement("path", {
    d: "M327.327 128.088H329.82V102.888H327.327",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1757 || (_path1757 = /*#__PURE__*/React.createElement("path", {
    d: "M362.845 212.65H360.352V187.449H362.845",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1758 || (_path1758 = /*#__PURE__*/React.createElement("path", {
    d: "M362.845 184.649H360.352V159.449H362.845",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1759 || (_path1759 = /*#__PURE__*/React.createElement("path", {
    d: "M362.845 156.649H360.352V131.449H362.845",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1760 || (_path1760 = /*#__PURE__*/React.createElement("path", {
    d: "M362.845 127.528H360.352V102.328H362.845",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1761 || (_path1761 = /*#__PURE__*/React.createElement("path", {
    d: "M332.312 212.65V209.85H357.237V212.09",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1762 || (_path1762 = /*#__PURE__*/React.createElement("path", {
    d: "M332.312 184.649V181.849H357.237V184.089",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1763 || (_path1763 = /*#__PURE__*/React.createElement("path", {
    d: "M332.312 156.649V153.849H357.237V156.089",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1764 || (_path1764 = /*#__PURE__*/React.createElement("path", {
    d: "M332.312 127.528V124.728H357.237V126.968",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1765 || (_path1765 = /*#__PURE__*/React.createElement("path", {
    d: "M332.936 188.569V191.369H357.86V189.129",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1766 || (_path1766 = /*#__PURE__*/React.createElement("path", {
    d: "M332.936 160.569V163.369H357.86V161.129",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1767 || (_path1767 = /*#__PURE__*/React.createElement("path", {
    d: "M332.936 132.568V135.368H357.86V133.128",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1768 || (_path1768 = /*#__PURE__*/React.createElement("path", {
    d: "M332.936 103.447V106.247H357.86V104.007",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1769 || (_path1769 = /*#__PURE__*/React.createElement("path", {
    d: "M344.152 208.17H333.559V193.61H344.152",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1770 || (_path1770 = /*#__PURE__*/React.createElement("path", {
    d: "M344.152 180.17H333.559V165.61H344.152",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1771 || (_path1771 = /*#__PURE__*/React.createElement("path", {
    d: "M344.152 152.168H333.559V137.608H344.152",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1772 || (_path1772 = /*#__PURE__*/React.createElement("path", {
    d: "M344.152 123.048H333.559V108.488H344.152",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1773 || (_path1773 = /*#__PURE__*/React.createElement("path", {
    d: "M358.484 208.17H347.891V193.61H358.484",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1774 || (_path1774 = /*#__PURE__*/React.createElement("path", {
    d: "M358.484 180.17H347.891V165.61H358.484",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1775 || (_path1775 = /*#__PURE__*/React.createElement("path", {
    d: "M358.484 152.168H347.891V137.608H358.484",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1776 || (_path1776 = /*#__PURE__*/React.createElement("path", {
    d: "M358.484 123.048H347.891V108.488H358.484",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1777 || (_path1777 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.9395 282.632H69.212V281.632H67.6028V278.14H66.6028V281.632H63.9395V282.632Z",
    fill: "#2CAD39"
  })), _path1778 || (_path1778 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.9395 232.739H69.212V231.739H67.6028V228.248H66.6028V231.739H63.9395V232.739Z",
    fill: "#2CAD39"
  })), _path1779 || (_path1779 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.9395 180.851H69.212V179.851H67.6028V176.36H66.6028V179.851H63.9395V180.851Z",
    fill: "#2CAD39"
  })), _path1780 || (_path1780 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.3955 282.632H58.668V281.632H57.0593V278.14H56.0593V281.632H53.3955V282.632Z",
    fill: "#2CAD39"
  })), _path1781 || (_path1781 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.3955 232.739H58.668V231.739H57.0593V228.248H56.0593V231.739H53.3955V232.739Z",
    fill: "#2CAD39"
  })), _path1782 || (_path1782 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.3955 180.851H58.668V179.851H57.0593V176.36H56.0593V179.851H53.3955V180.851Z",
    fill: "#2CAD39"
  })), _path1783 || (_path1783 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.5938 282.632H81.8663V281.632H80.2576V278.14H79.2576V281.632H76.5938V282.632Z",
    fill: "#2CAD39"
  })), _path1784 || (_path1784 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.5938 232.739H81.8663V231.739H80.2576V228.248H79.2576V231.739H76.5938V232.739Z",
    fill: "#2CAD39"
  })), _path1785 || (_path1785 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.5938 180.851H81.8663V179.851H80.2576V176.36H79.2576V179.851H76.5938V180.851Z",
    fill: "#2CAD39"
  })), _path1786 || (_path1786 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.9395 240.72H69.212V241.72H67.6028V245.211H66.6028V241.72H63.9395V240.72Z",
    fill: "#2CAD39"
  })), _path1787 || (_path1787 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.9395 190.828H69.212V191.828H67.6028V195.319H66.6028V191.828H63.9395V190.828Z",
    fill: "#2CAD39"
  })), _path1788 || (_path1788 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.9395 138.939H69.212V139.939H67.6028V143.43H66.6028V139.939H63.9395V138.939Z",
    fill: "#2CAD39"
  })), _path1789 || (_path1789 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.3955 240.72H58.668V241.72H57.0593V245.211H56.0593V241.72H53.3955V240.72Z",
    fill: "#2CAD39"
  })), _path1790 || (_path1790 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.3955 190.828H58.668V191.828H57.0593V195.319H56.0593V191.828H53.3955V190.828Z",
    fill: "#2CAD39"
  })), _path1791 || (_path1791 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.3955 138.939H58.668V139.939H57.0593V143.43H56.0593V139.939H53.3955V138.939Z",
    fill: "#2CAD39"
  })), _path1792 || (_path1792 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.5938 240.72H81.8663V241.72H80.2576V245.211H79.2576V241.72H76.5938V240.72Z",
    fill: "#2CAD39"
  })), _path1793 || (_path1793 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.5938 190.828H81.8663V191.828H80.2576V195.319H79.2576V191.828H76.5938V190.828Z",
    fill: "#2CAD39"
  })), _path1794 || (_path1794 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.5938 138.939H81.8663V139.939H80.2576V143.43H79.2576V139.939H76.5938V138.939Z",
    fill: "#2CAD39"
  })), _path1795 || (_path1795 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5771 284.128H41.7952V239.225H37.5771",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1796 || (_path1796 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5771 234.235H41.7952V189.332H37.5771",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1797 || (_path1797 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5771 182.347H41.7952V137.444H37.5771",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1798 || (_path1798 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6836 283.13H93.4656V238.226H97.6836",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1799 || (_path1799 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6836 233.237H93.4656V188.334H97.6836",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1800 || (_path1800 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6836 181.349H93.4656V136.445H97.6836",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1801 || (_path1801 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0137 283.13V278.14H88.194V282.132",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1802 || (_path1802 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0137 233.237V228.248H88.194V232.239",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1803 || (_path1803 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0137 181.349V176.359H88.194V180.351",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1804 || (_path1804 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0684 240.222V245.212H89.2487V241.22",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1805 || (_path1805 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0684 190.33V195.319H89.2487V191.328",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1806 || (_path1806 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0684 138.441V143.431H89.2487V139.439",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1807 || (_path1807 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0487 275.148H48.1221V249.204H66.0487",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1808 || (_path1808 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0487 225.254H48.1221V199.31H66.0487",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1809 || (_path1809 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0487 173.366H48.1221V147.422H66.0487",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1810 || (_path1810 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3026 275.148H72.376V249.204H90.3026",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1811 || (_path1811 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3026 225.254H72.376V199.31H90.3026",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1812 || (_path1812 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3026 173.366H72.376V147.422H90.3026",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1813 || (_path1813 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.9395 429.908H69.212V428.908H67.6028V425.416H66.6028V428.908H63.9395V429.908Z",
    fill: "#2CAD39"
  })), _path1814 || (_path1814 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.9395 380.016H69.212V379.016H67.6028V375.525H66.6028V379.016H63.9395V380.016Z",
    fill: "#2CAD39"
  })), _path1815 || (_path1815 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.9395 328.128H69.212V327.128H67.6028V323.637H66.6028V327.128H63.9395V328.128Z",
    fill: "#2CAD39"
  })), _path1816 || (_path1816 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.3955 429.908H58.668V428.908H57.0593V425.416H56.0593V428.908H53.3955V429.908Z",
    fill: "#2CAD39"
  })), _path1817 || (_path1817 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.3955 380.016H58.668V379.016H57.0593V375.525H56.0593V379.016H53.3955V380.016Z",
    fill: "#2CAD39"
  })), _path1818 || (_path1818 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.3955 328.128H58.668V327.128H57.0593V323.637H56.0593V327.128H53.3955V328.128Z",
    fill: "#2CAD39"
  })), _path1819 || (_path1819 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.5938 429.908H81.8663V428.908H80.2576V425.416H79.2576V428.908H76.5938V429.908Z",
    fill: "#2CAD39"
  })), _path1820 || (_path1820 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.5938 380.016H81.8663V379.016H80.2576V375.525H79.2576V379.016H76.5938V380.016Z",
    fill: "#2CAD39"
  })), _path1821 || (_path1821 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.5938 328.128H81.8663V327.128H80.2576V323.637H79.2576V327.128H76.5938V328.128Z",
    fill: "#2CAD39"
  })), _path1822 || (_path1822 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.9395 387.997H69.212V388.997H67.6028V392.488H66.6028V388.997H63.9395V387.997Z",
    fill: "#2CAD39"
  })), _path1823 || (_path1823 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.9395 338.105H69.212V339.105H67.6028V342.596H66.6028V339.105H63.9395V338.105Z",
    fill: "#2CAD39"
  })), _path1824 || (_path1824 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.9395 286.214H69.212V287.214H67.6028V290.705H66.6028V287.214H63.9395V286.214Z",
    fill: "#2CAD39"
  })), _path1825 || (_path1825 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.3955 387.997H58.668V388.997H57.0593V392.488H56.0593V388.997H53.3955V387.997Z",
    fill: "#2CAD39"
  })), _path1826 || (_path1826 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.3955 338.105H58.668V339.105H57.0593V342.596H56.0593V339.105H53.3955V338.105Z",
    fill: "#2CAD39"
  })), _path1827 || (_path1827 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.3955 286.214H58.668V287.214H57.0593V290.705H56.0593V287.214H53.3955V286.214Z",
    fill: "#2CAD39"
  })), _path1828 || (_path1828 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.5938 387.997H81.8663V388.997H80.2576V392.488H79.2576V388.997H76.5938V387.997Z",
    fill: "#2CAD39"
  })), _path1829 || (_path1829 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.5938 338.105H81.8663V339.105H80.2576V342.596H79.2576V339.105H76.5938V338.105Z",
    fill: "#2CAD39"
  })), _path1830 || (_path1830 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.5938 286.214H81.8663V287.214H80.2576V290.705H79.2576V287.214H76.5938V286.214Z",
    fill: "#2CAD39"
  })), _path1831 || (_path1831 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5771 431.404H41.7952V386.501H37.5771",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1832 || (_path1832 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5771 381.512H41.7952V336.608H37.5771",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1833 || (_path1833 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5771 329.623H41.7952V284.72H37.5771",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1834 || (_path1834 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6836 430.406H93.4656V385.503H97.6836",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1835 || (_path1835 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6836 380.513H93.4656V335.61H97.6836",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1836 || (_path1836 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6836 328.625H93.4656V283.722H97.6836",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1837 || (_path1837 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0137 430.406V425.417H88.194V429.408",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1838 || (_path1838 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0137 380.513V375.524H88.194V379.515",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1839 || (_path1839 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0137 328.625V323.636H88.194V327.627",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1840 || (_path1840 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0684 387.499V392.488H89.2487V388.497",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1841 || (_path1841 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0684 337.605V342.594H89.2487V338.603",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1842 || (_path1842 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0684 285.718V290.707H89.2487V286.716",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1843 || (_path1843 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0487 422.424H48.1221V396.48H66.0487",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1844 || (_path1844 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0487 372.531H48.1221V346.586H66.0487",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1845 || (_path1845 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0487 320.642H48.1221V294.698H66.0487",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1846 || (_path1846 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3026 422.424H72.376V396.48H90.3026",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1847 || (_path1847 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3026 372.531H72.376V346.586H90.3026",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1848 || (_path1848 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3026 320.642H72.376V294.698H90.3026",
    stroke: "#59B974",
    strokeWidth: 1.5
  })), _path1849 || (_path1849 = /*#__PURE__*/React.createElement("path", {
    d: "M594 1.21191V18.2119H613V1.21191",
    stroke: "#2CAD39"
  })), _path1850 || (_path1850 = /*#__PURE__*/React.createElement("path", {
    d: "M514 144.212V161.212H533V144.212",
    stroke: "#59B974"
  })), _path1851 || (_path1851 = /*#__PURE__*/React.createElement("path", {
    d: "M514 161.212V178.212H533V161.212",
    stroke: "#59B974"
  })), _path1852 || (_path1852 = /*#__PURE__*/React.createElement("path", {
    d: "M514 178.212V196.212H533V178.212",
    stroke: "#59B974"
  })), _path1853 || (_path1853 = /*#__PURE__*/React.createElement("path", {
    d: "M514 196.212V213.212H533V196.212",
    stroke: "#59B974"
  })), _path1854 || (_path1854 = /*#__PURE__*/React.createElement("path", {
    d: "M575 1.21191V18.2119H594V1.21191",
    stroke: "#2CAD39"
  })), _path1855 || (_path1855 = /*#__PURE__*/React.createElement("path", {
    d: "M495 144.212V161.212H514V144.212",
    stroke: "#59B974"
  })), _path1856 || (_path1856 = /*#__PURE__*/React.createElement("path", {
    d: "M495 161.212V178.212H514V161.212",
    stroke: "#59B974"
  })), _path1857 || (_path1857 = /*#__PURE__*/React.createElement("path", {
    d: "M495 178.212V196.212H514V178.212",
    stroke: "#59B974"
  })), _path1858 || (_path1858 = /*#__PURE__*/React.createElement("path", {
    d: "M495 196.212V213.212H514V196.212",
    stroke: "#59B974"
  })), _path1859 || (_path1859 = /*#__PURE__*/React.createElement("path", {
    d: "M557 1.21191V18.2119H575V1.21191",
    stroke: "#2CAD39"
  })), _path1860 || (_path1860 = /*#__PURE__*/React.createElement("path", {
    d: "M538 1.21191V18.2119H557V1.21191",
    stroke: "#2CAD39"
  })), _path1861 || (_path1861 = /*#__PURE__*/React.createElement("path", {
    d: "M476 144.212V161.212H495V144.212",
    stroke: "#59B974"
  })), _path1862 || (_path1862 = /*#__PURE__*/React.createElement("path", {
    d: "M476 161.212V178.212H495V161.212",
    stroke: "#59B974"
  })), _path1863 || (_path1863 = /*#__PURE__*/React.createElement("path", {
    d: "M476 178.212V196.212H495V178.212",
    stroke: "#59B974"
  })), _path1864 || (_path1864 = /*#__PURE__*/React.createElement("path", {
    d: "M476 196.212V213.212H495V196.212",
    stroke: "#59B974"
  })), _path1865 || (_path1865 = /*#__PURE__*/React.createElement("path", {
    d: "M458 144.212V161.212H476V144.212",
    stroke: "#59B974"
  })), _path1866 || (_path1866 = /*#__PURE__*/React.createElement("path", {
    d: "M458 161.212V178.212H476V161.212",
    stroke: "#59B974"
  })), _path1867 || (_path1867 = /*#__PURE__*/React.createElement("path", {
    d: "M458 178.212V196.212H476V178.212",
    stroke: "#59B974"
  })), _path1868 || (_path1868 = /*#__PURE__*/React.createElement("path", {
    d: "M458 196.212V213.212H476V196.212",
    stroke: "#59B974"
  })), _path1869 || (_path1869 = /*#__PURE__*/React.createElement("path", {
    d: "M651 1.21191V18.2119H670V1.21191",
    stroke: "#2CAD39"
  })), _path1870 || (_path1870 = /*#__PURE__*/React.createElement("path", {
    d: "M571 144.212V161.212H589V144.212",
    stroke: "#59B974"
  })), _path1871 || (_path1871 = /*#__PURE__*/React.createElement("path", {
    d: "M571 161.212V178.212H589V161.212",
    stroke: "#59B974"
  })), _path1872 || (_path1872 = /*#__PURE__*/React.createElement("path", {
    d: "M571 178.212V196.212H589V178.212",
    stroke: "#59B974"
  })), _path1873 || (_path1873 = /*#__PURE__*/React.createElement("path", {
    d: "M571 196.212V213.212H589V196.212",
    stroke: "#59B974"
  })), _path1874 || (_path1874 = /*#__PURE__*/React.createElement("path", {
    d: "M707 1.21191V18.2119H726V1.21191",
    stroke: "#2CAD39"
  })), _path1875 || (_path1875 = /*#__PURE__*/React.createElement("path", {
    d: "M764 1.21191V18.2119H783V1.21191",
    stroke: "#2CAD39"
  })), _path1876 || (_path1876 = /*#__PURE__*/React.createElement("path", {
    d: "M820 1.21191V18.2119H839V1.21191",
    stroke: "#2CAD39"
  })), _path1877 || (_path1877 = /*#__PURE__*/React.createElement("path", {
    d: "M613 1.21191V18.2119H632V1.21191",
    stroke: "#2CAD39"
  })), _path1878 || (_path1878 = /*#__PURE__*/React.createElement("path", {
    d: "M533 144.212V161.212H552V144.212",
    stroke: "#59B974"
  })), _path1879 || (_path1879 = /*#__PURE__*/React.createElement("path", {
    d: "M533 161.212V178.212H552V161.212",
    stroke: "#59B974"
  })), _path1880 || (_path1880 = /*#__PURE__*/React.createElement("path", {
    d: "M533 178.212V196.212H552V178.212",
    stroke: "#59B974"
  })), _path1881 || (_path1881 = /*#__PURE__*/React.createElement("path", {
    d: "M533 196.212V213.212H552V196.212",
    stroke: "#59B974"
  })), _path1882 || (_path1882 = /*#__PURE__*/React.createElement("path", {
    d: "M670 1.21191V18.2119H688V1.21191",
    stroke: "#2CAD39"
  })), _path1883 || (_path1883 = /*#__PURE__*/React.createElement("path", {
    d: "M589 144.212V161.212H608V144.212",
    stroke: "#59B974"
  })), _path1884 || (_path1884 = /*#__PURE__*/React.createElement("path", {
    d: "M589 161.212V178.212H608V161.212",
    stroke: "#59B974"
  })), _path1885 || (_path1885 = /*#__PURE__*/React.createElement("path", {
    d: "M589 178.212V196.212H608V178.212",
    stroke: "#59B974"
  })), _path1886 || (_path1886 = /*#__PURE__*/React.createElement("path", {
    d: "M589 196.212V213.212H608V196.212",
    stroke: "#59B974"
  })), _path1887 || (_path1887 = /*#__PURE__*/React.createElement("path", {
    d: "M608 144.212V161.212H627V144.212",
    stroke: "#59B974"
  })), _path1888 || (_path1888 = /*#__PURE__*/React.createElement("path", {
    d: "M608 161.212V178.212H627V161.212",
    stroke: "#59B974"
  })), _path1889 || (_path1889 = /*#__PURE__*/React.createElement("path", {
    d: "M608 178.212V196.212H627V178.212",
    stroke: "#59B974"
  })), _path1890 || (_path1890 = /*#__PURE__*/React.createElement("path", {
    d: "M608 196.212V213.212H627V196.212",
    stroke: "#59B974"
  })), _path1891 || (_path1891 = /*#__PURE__*/React.createElement("path", {
    d: "M627 144.212V161.212H646V144.212",
    stroke: "#59B974"
  })), _path1892 || (_path1892 = /*#__PURE__*/React.createElement("path", {
    d: "M627 161.212V178.212H646V161.212",
    stroke: "#59B974"
  })), _path1893 || (_path1893 = /*#__PURE__*/React.createElement("path", {
    d: "M627 178.212V196.212H646V178.212",
    stroke: "#59B974"
  })), _path1894 || (_path1894 = /*#__PURE__*/React.createElement("path", {
    d: "M627 196.212V213.212H646V196.212",
    stroke: "#59B974"
  })), _path1895 || (_path1895 = /*#__PURE__*/React.createElement("path", {
    d: "M538 1.21191V9.21191H933V1.21191",
    stroke: "#2CAD39",
    strokeDasharray: "2 2"
  })), _path1896 || (_path1896 = /*#__PURE__*/React.createElement("path", {
    d: "M726 9.21191V18.2119H745V9.21191",
    stroke: "#2CAD39"
  })), _path1897 || (_path1897 = /*#__PURE__*/React.createElement("path", {
    d: "M783 1.21191V18.2119H801V1.21191",
    stroke: "#2CAD39"
  })), _path1898 || (_path1898 = /*#__PURE__*/React.createElement("path", {
    d: "M839 1.21191V18.2119H858V1.21191",
    stroke: "#2CAD39"
  })), _path1899 || (_path1899 = /*#__PURE__*/React.createElement("path", {
    d: "M632 1.21191V18.2119H651V1.21191",
    stroke: "#2CAD39"
  })), _path1900 || (_path1900 = /*#__PURE__*/React.createElement("path", {
    d: "M552 144.212V161.212H571V144.212",
    stroke: "#59B974"
  })), _path1901 || (_path1901 = /*#__PURE__*/React.createElement("path", {
    d: "M552 161.212V178.212H571V161.212",
    stroke: "#59B974"
  })), _path1902 || (_path1902 = /*#__PURE__*/React.createElement("path", {
    d: "M552 178.212V196.212H571V178.212",
    stroke: "#59B974"
  })), _path1903 || (_path1903 = /*#__PURE__*/React.createElement("path", {
    d: "M552 196.212V213.212H571V196.212",
    stroke: "#59B974"
  })), _path1904 || (_path1904 = /*#__PURE__*/React.createElement("path", {
    d: "M688 1.21191V18.2119H707V1.21191",
    stroke: "#2CAD39"
  })), _path1905 || (_path1905 = /*#__PURE__*/React.createElement("path", {
    d: "M745 1.21191V18.2119H764V1.21191",
    stroke: "#2CAD39"
  })), _path1906 || (_path1906 = /*#__PURE__*/React.createElement("path", {
    d: "M801 1.21191V18.2119H820V1.21191",
    stroke: "#2CAD39"
  })), _path1907 || (_path1907 = /*#__PURE__*/React.createElement("path", {
    d: "M858 1.21191V18.2119H877V1.21191",
    stroke: "#2CAD39"
  })), _path1908 || (_path1908 = /*#__PURE__*/React.createElement("path", {
    d: "M877 1.21191V18.2119H895V1.21191",
    stroke: "#2CAD39"
  })), _path1909 || (_path1909 = /*#__PURE__*/React.createElement("path", {
    d: "M895 1.21191V18.2119H914V1.21191",
    stroke: "#2CAD39"
  })), _path1910 || (_path1910 = /*#__PURE__*/React.createElement("path", {
    d: "M914 1.21191V18.2119H933V1.21191",
    stroke: "#2CAD39"
  })), _path1911 || (_path1911 = /*#__PURE__*/React.createElement("path", {
    d: "M109 125.212H32V437.212H109V125.212Z",
    stroke: "#59B974",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path1912 || (_path1912 = /*#__PURE__*/React.createElement("path", {
    d: "M781 480.212V626.212H1333V480.212",
    stroke: "#59B974",
    strokeWidth: 2
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 785,
    y: 598.001,
    width: 153,
    height: 21,
    rx: 5,
    fill: "#0E64A9",
    fillOpacity: 0.11
  })), _path1913 || (_path1913 = /*#__PURE__*/React.createElement("path", {
    d: "M793.454 613.671V610.431H795.704C798.179 610.431 799.454 608.841 799.454 606.966C799.454 605.091 798.179 603.501 795.704 603.501H791.759C791.579 603.501 791.444 603.651 791.444 603.816V613.671C791.444 613.851 791.579 614.001 791.759 614.001H793.139C793.319 614.001 793.454 613.851 793.454 613.671ZM793.454 608.661V605.271H795.569C796.574 605.271 797.369 605.916 797.369 606.966C797.369 608.016 796.574 608.661 795.569 608.661H793.454ZM809.254 614.001C809.494 614.001 809.599 613.761 809.479 613.581L807.034 609.636C808.714 609.111 809.209 607.641 809.209 606.666C809.209 604.866 807.799 603.501 805.579 603.501H800.959C800.749 603.501 800.644 603.666 800.644 603.816V613.671C800.644 613.851 800.779 614.001 800.959 614.001H802.339C802.519 614.001 802.654 613.851 802.654 613.671V609.981H804.979L807.199 613.671C807.334 613.911 807.469 614.001 807.724 614.001H809.254ZM805.354 608.346H802.654V605.271H805.384C806.389 605.271 807.094 605.856 807.094 606.771C807.094 607.701 806.389 608.346 805.354 608.346ZM821.163 608.751C821.163 605.661 818.733 603.291 815.643 603.291C812.568 603.291 810.123 605.661 810.123 608.751C810.123 611.841 812.568 614.211 815.643 614.211C818.733 614.211 821.163 611.841 821.163 608.751ZM819.078 608.751C819.078 610.776 817.638 612.351 815.643 612.351C813.648 612.351 812.223 610.776 812.223 608.751C812.223 606.726 813.648 605.151 815.643 605.151C817.638 605.151 819.078 606.726 819.078 608.751ZM826.773 603.501H822.843C822.663 603.501 822.528 603.651 822.528 603.816V613.671C822.528 613.851 822.663 614.001 822.843 614.001H826.773C830.088 614.001 832.188 611.856 832.188 608.736C832.188 605.601 830.088 603.501 826.773 603.501ZM826.803 612.156H824.538V605.346H826.803C828.753 605.346 830.088 606.726 830.088 608.736C830.088 610.731 828.753 612.156 826.803 612.156ZM842.183 610.251V603.816C842.183 603.651 842.033 603.501 841.868 603.501H840.503C840.323 603.501 840.173 603.651 840.173 603.816V610.131C840.173 611.526 839.303 612.381 837.833 612.381C836.363 612.381 835.508 611.526 835.508 610.131V603.816C835.508 603.651 835.358 603.501 835.178 603.501H833.813C833.633 603.501 833.498 603.651 833.498 603.816V610.266C833.498 612.996 835.568 614.211 837.833 614.211C840.113 614.211 842.183 612.981 842.183 610.251ZM848.983 614.211C851.263 614.211 853.303 613.011 853.993 610.956C854.038 610.821 854.053 610.686 853.828 610.626L852.328 610.251C852.103 610.206 852.043 610.356 851.998 610.461C851.458 611.556 850.453 612.351 848.998 612.351C847.003 612.351 845.563 610.776 845.563 608.751C845.563 606.726 847.003 605.151 848.998 605.151C850.453 605.151 851.458 605.946 851.998 607.041C852.043 607.146 852.103 607.296 852.328 607.251L853.828 606.876C854.053 606.816 854.038 606.681 853.993 606.546C853.303 604.491 851.263 603.291 848.983 603.291C845.893 603.291 843.463 605.661 843.463 608.751C843.463 611.841 845.893 614.211 848.983 614.211ZM854.136 605.031C854.136 605.211 854.271 605.346 854.451 605.346H857.571V613.671C857.571 613.851 857.706 614.001 857.886 614.001H859.311C859.491 614.001 859.641 613.851 859.641 613.671V605.346H862.761C862.941 605.346 863.076 605.211 863.076 605.031V603.831C863.076 603.651 862.941 603.501 862.761 603.501H854.451C854.271 603.501 854.136 603.651 854.136 603.831V605.031ZM865.898 614.001C866.078 614.001 866.213 613.851 866.213 613.671V603.816C866.213 603.651 866.078 603.501 865.898 603.501H864.518C864.338 603.501 864.203 603.651 864.203 603.816V613.671C864.203 613.851 864.338 614.001 864.518 614.001H865.898ZM878.614 608.751C878.614 605.661 876.184 603.291 873.094 603.291C870.019 603.291 867.574 605.661 867.574 608.751C867.574 611.841 870.019 614.211 873.094 614.211C876.184 614.211 878.614 611.841 878.614 608.751ZM876.529 608.751C876.529 610.776 875.089 612.351 873.094 612.351C871.099 612.351 869.674 610.776 869.674 608.751C869.674 606.726 871.099 605.151 873.094 605.151C875.089 605.151 876.529 606.726 876.529 608.751ZM886.49 613.686C886.625 613.911 886.82 614.001 887.135 614.001H888.62C888.785 614.001 888.95 613.866 888.95 613.686V603.816C888.95 603.651 888.785 603.501 888.62 603.501H887.24C887.075 603.501 886.94 603.651 886.94 603.816V610.656L882.545 603.756C882.425 603.561 882.26 603.501 882.08 603.501H880.295C880.115 603.501 879.98 603.651 879.98 603.816V613.686C879.98 613.866 880.115 614.001 880.295 614.001H881.675C881.855 614.001 881.99 613.866 881.99 613.686V606.681L886.49 613.686ZM900.738 613.716C900.813 613.896 900.888 614.001 901.068 614.001H902.643C902.883 614.001 903.048 613.821 902.928 613.521L899.133 603.816C899.043 603.591 898.863 603.501 898.713 603.501H896.853C896.703 603.501 896.523 603.591 896.433 603.816L892.653 613.536C892.548 613.821 892.683 614.001 892.908 614.001H894.393C894.558 614.001 894.663 613.881 894.723 613.716L895.578 611.451H899.868L900.738 613.716ZM896.208 609.756L897.708 605.766L899.223 609.756H896.208ZM912.466 614.001C912.706 614.001 912.811 613.761 912.691 613.581L910.246 609.636C911.926 609.111 912.421 607.641 912.421 606.666C912.421 604.866 911.011 603.501 908.791 603.501H904.171C903.961 603.501 903.856 603.666 903.856 603.816V613.671C903.856 613.851 903.991 614.001 904.171 614.001H905.551C905.731 614.001 905.866 613.851 905.866 613.671V609.981H908.191L910.411 613.671C910.546 613.911 910.681 614.001 910.936 614.001H912.466ZM908.566 608.346H905.866V605.271H908.596C909.601 605.271 910.306 605.856 910.306 606.771C910.306 607.701 909.601 608.346 908.566 608.346ZM914.294 603.501C914.114 603.501 913.979 603.651 913.979 603.816V613.671C913.979 613.851 914.114 614.001 914.294 614.001H921.779C921.959 614.001 922.109 613.851 922.109 613.671V612.471C922.109 612.291 921.959 612.156 921.779 612.156H915.989V609.621H918.959C919.139 609.621 919.274 609.471 919.274 609.291V608.151C919.274 607.971 919.139 607.821 918.959 607.821H915.989V605.346H921.689C921.869 605.346 922.004 605.211 922.004 605.031V603.831C922.004 603.651 921.869 603.501 921.689 603.501H914.294ZM930.357 613.716C930.433 613.896 930.508 614.001 930.688 614.001H932.263C932.503 614.001 932.668 613.821 932.548 613.521L928.753 603.816C928.663 603.591 928.483 603.501 928.333 603.501H926.473C926.323 603.501 926.143 603.591 926.053 603.816L922.272 613.536C922.167 613.821 922.302 614.001 922.528 614.001H924.013C924.178 614.001 924.283 613.881 924.343 613.716L925.198 611.451H929.488L930.357 613.716ZM925.828 609.756L927.328 605.766L928.843 609.756H925.828Z",
    fill: "#59B974"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 1050,
    y: 41,
    width: 158,
    height: 21,
    rx: 5,
    fill: "#0E64A9",
    fillOpacity: 0.11
  })), _path1914 || (_path1914 = /*#__PURE__*/React.createElement("path", {
    d: "M1060.96 46.4998H1057.03C1056.85 46.4998 1056.71 46.6498 1056.71 46.8148V56.6698C1056.71 56.8498 1056.85 56.9998 1057.03 56.9998H1060.96C1064.27 56.9998 1066.37 54.8548 1066.37 51.7348C1066.37 48.5998 1064.27 46.4998 1060.96 46.4998ZM1060.99 55.1548H1058.72V48.3448H1060.99C1062.94 48.3448 1064.27 49.7248 1064.27 51.7348C1064.27 53.7298 1062.94 55.1548 1060.99 55.1548ZM1069.47 56.9998C1069.65 56.9998 1069.78 56.8498 1069.78 56.6698V46.8148C1069.78 46.6498 1069.65 46.4998 1069.47 46.4998H1068.09C1067.91 46.4998 1067.77 46.6498 1067.77 46.8148V56.6698C1067.77 56.8498 1067.91 56.9998 1068.09 56.9998H1069.47ZM1075.31 46.2898C1073 46.2898 1071.31 47.5948 1071.31 49.4398C1071.31 50.8948 1072.22 51.8698 1073.86 52.2898L1075.76 52.7848C1076.8 53.0548 1077.34 53.4298 1077.34 54.1498C1077.34 54.7948 1076.71 55.4248 1075.45 55.4248C1074.19 55.4248 1073.38 54.8548 1072.78 54.2698C1072.57 54.0598 1072.36 53.9398 1072.07 54.1648L1071.25 54.8098C1070.96 55.0348 1071.02 55.3798 1071.25 55.6348C1071.92 56.3998 1073.27 57.2098 1075.33 57.2098C1078.18 57.2098 1079.53 55.5448 1079.53 53.9548C1079.53 52.2898 1078.42 51.4198 1076.72 50.9698L1074.67 50.4298C1073.74 50.1898 1073.47 49.7848 1073.47 49.3048C1073.47 48.5098 1074.26 48.0598 1075.25 48.0598C1076.15 48.0598 1076.89 48.4498 1077.58 48.9748C1077.89 49.2148 1078.16 49.1848 1078.37 48.9748L1079 48.3148C1079.15 48.1648 1079.3 47.9098 1078.94 47.5648C1078.25 46.9048 1076.96 46.2898 1075.31 46.2898ZM1079.81 48.0298C1079.81 48.2098 1079.94 48.3448 1080.12 48.3448H1083.24V56.6698C1083.24 56.8498 1083.38 56.9998 1083.56 56.9998H1084.98C1085.16 56.9998 1085.31 56.8498 1085.31 56.6698V48.3448H1088.43C1088.61 48.3448 1088.75 48.2098 1088.75 48.0298V46.8298C1088.75 46.6498 1088.61 46.4998 1088.43 46.4998H1080.12C1079.94 46.4998 1079.81 46.6498 1079.81 46.8298V48.0298ZM1098.48 56.9998C1098.72 56.9998 1098.83 56.7598 1098.71 56.5798L1096.26 52.6348C1097.94 52.1098 1098.44 50.6398 1098.44 49.6648C1098.44 47.8648 1097.03 46.4998 1094.81 46.4998H1090.19C1089.98 46.4998 1089.87 46.6648 1089.87 46.8148V56.6698C1089.87 56.8498 1090.01 56.9998 1090.19 56.9998H1091.57C1091.75 56.9998 1091.88 56.8498 1091.88 56.6698V52.9798H1094.21L1096.43 56.6698C1096.56 56.9098 1096.7 56.9998 1096.95 56.9998H1098.48ZM1094.58 51.3448H1091.88V48.2698H1094.61C1095.62 48.2698 1096.32 48.8548 1096.32 49.7698C1096.32 50.6998 1095.62 51.3448 1094.58 51.3448ZM1101.69 56.9998C1101.87 56.9998 1102.01 56.8498 1102.01 56.6698V46.8148C1102.01 46.6498 1101.87 46.4998 1101.69 46.4998H1100.31C1100.13 46.4998 1100 46.6498 1100 46.8148V56.6698C1100 56.8498 1100.13 56.9998 1100.31 56.9998H1101.69ZM1108.81 46.4998H1104.24C1104.04 46.4998 1103.92 46.6498 1103.92 46.8148V56.6848C1103.92 56.8648 1104.06 56.9998 1104.24 56.9998H1109.22C1111.51 56.9998 1112.73 55.4998 1112.73 53.9398C1112.73 52.8598 1112.16 51.7948 1110.78 51.3298C1111.71 50.9398 1112.19 50.0998 1112.19 49.1548C1112.19 47.9548 1111.3 46.4998 1108.81 46.4998ZM1110.12 49.4248C1110.12 50.2198 1109.56 50.7748 1108.54 50.7748H1105.93V48.0898H1108.54C1109.56 48.0898 1110.12 48.6448 1110.12 49.4248ZM1108.9 52.2898C1109.88 52.2898 1110.64 52.9048 1110.64 53.8498C1110.64 54.8098 1109.86 55.4098 1108.9 55.4098H1105.93V52.2898H1108.9ZM1122.65 53.2498V46.8148C1122.65 46.6498 1122.5 46.4998 1122.34 46.4998H1120.97C1120.79 46.4998 1120.64 46.6498 1120.64 46.8148V53.1298C1120.64 54.5248 1119.77 55.3798 1118.3 55.3798C1116.83 55.3798 1115.98 54.5248 1115.98 53.1298V46.8148C1115.98 46.6498 1115.83 46.4998 1115.65 46.4998H1114.28C1114.1 46.4998 1113.97 46.6498 1113.97 46.8148V53.2648C1113.97 55.9948 1116.04 57.2098 1118.3 57.2098C1120.58 57.2098 1122.65 55.9798 1122.65 53.2498ZM1123.69 48.0298C1123.69 48.2098 1123.83 48.3448 1124.01 48.3448H1127.13V56.6698C1127.13 56.8498 1127.26 56.9998 1127.44 56.9998H1128.87C1129.05 56.9998 1129.2 56.8498 1129.2 56.6698V48.3448H1132.32C1132.5 48.3448 1132.63 48.2098 1132.63 48.0298V46.8298C1132.63 46.6498 1132.5 46.4998 1132.32 46.4998H1124.01C1123.83 46.4998 1123.69 46.6498 1123.69 46.8298V48.0298ZM1135.46 56.9998C1135.64 56.9998 1135.77 56.8498 1135.77 56.6698V46.8148C1135.77 46.6498 1135.64 46.4998 1135.46 46.4998H1134.08C1133.9 46.4998 1133.76 46.6498 1133.76 46.8148V56.6698C1133.76 56.8498 1133.9 56.9998 1134.08 56.9998H1135.46ZM1148.17 51.7498C1148.17 48.6598 1145.74 46.2898 1142.65 46.2898C1139.58 46.2898 1137.13 48.6598 1137.13 51.7498C1137.13 54.8398 1139.58 57.2098 1142.65 57.2098C1145.74 57.2098 1148.17 54.8398 1148.17 51.7498ZM1146.09 51.7498C1146.09 53.7748 1144.65 55.3498 1142.65 55.3498C1140.66 55.3498 1139.23 53.7748 1139.23 51.7498C1139.23 49.7248 1140.66 48.1498 1142.65 48.1498C1144.65 48.1498 1146.09 49.7248 1146.09 51.7498ZM1156.05 56.6848C1156.18 56.9098 1156.38 56.9998 1156.69 56.9998H1158.18C1158.34 56.9998 1158.51 56.8648 1158.51 56.6848V46.8148C1158.51 46.6498 1158.34 46.4998 1158.18 46.4998H1156.8C1156.63 46.4998 1156.5 46.6498 1156.5 46.8148V53.6548L1152.1 46.7548C1151.98 46.5598 1151.82 46.4998 1151.64 46.4998H1149.85C1149.67 46.4998 1149.54 46.6498 1149.54 46.8148V56.6848C1149.54 56.8648 1149.67 56.9998 1149.85 56.9998H1151.23C1151.41 56.9998 1151.55 56.8648 1151.55 56.6848V49.6798L1156.05 56.6848ZM1170.3 56.7148C1170.37 56.8948 1170.45 56.9998 1170.63 56.9998H1172.2C1172.44 56.9998 1172.61 56.8198 1172.49 56.5198L1168.69 46.8148C1168.6 46.5898 1168.42 46.4998 1168.27 46.4998H1166.41C1166.26 46.4998 1166.08 46.5898 1165.99 46.8148L1162.21 56.5348C1162.11 56.8198 1162.24 56.9998 1162.47 56.9998H1163.95C1164.12 56.9998 1164.22 56.8798 1164.28 56.7148L1165.14 54.4498H1169.43L1170.3 56.7148ZM1165.77 52.7548L1167.27 48.7648L1168.78 52.7548H1165.77ZM1182.02 56.9998C1182.26 56.9998 1182.37 56.7598 1182.25 56.5798L1179.8 52.6348C1181.48 52.1098 1181.98 50.6398 1181.98 49.6648C1181.98 47.8648 1180.57 46.4998 1178.35 46.4998H1173.73C1173.52 46.4998 1173.41 46.6648 1173.41 46.8148V56.6698C1173.41 56.8498 1173.55 56.9998 1173.73 56.9998H1175.11C1175.29 56.9998 1175.42 56.8498 1175.42 56.6698V52.9798H1177.75L1179.97 56.6698C1180.1 56.9098 1180.24 56.9998 1180.49 56.9998H1182.02ZM1178.12 51.3448H1175.42V48.2698H1178.15C1179.16 48.2698 1179.86 48.8548 1179.86 49.7698C1179.86 50.6998 1179.16 51.3448 1178.12 51.3448ZM1183.85 46.4998C1183.67 46.4998 1183.54 46.6498 1183.54 46.8148V56.6698C1183.54 56.8498 1183.67 56.9998 1183.85 56.9998H1191.34C1191.52 56.9998 1191.67 56.8498 1191.67 56.6698V55.4698C1191.67 55.2898 1191.52 55.1548 1191.34 55.1548H1185.55V52.6198H1188.52C1188.7 52.6198 1188.83 52.4698 1188.83 52.2898V51.1498C1188.83 50.9698 1188.7 50.8198 1188.52 50.8198H1185.55V48.3448H1191.25C1191.43 48.3448 1191.56 48.2098 1191.56 48.0298V46.8298C1191.56 46.6498 1191.43 46.4998 1191.25 46.4998H1183.85ZM1199.92 56.7148C1199.99 56.8948 1200.07 56.9998 1200.25 56.9998H1201.82C1202.06 56.9998 1202.23 56.8198 1202.11 56.5198L1198.31 46.8148C1198.22 46.5898 1198.04 46.4998 1197.89 46.4998H1196.03C1195.88 46.4998 1195.7 46.5898 1195.61 46.8148L1191.83 56.5348C1191.73 56.8198 1191.86 56.9998 1192.09 56.9998H1193.57C1193.74 56.9998 1193.84 56.8798 1193.9 56.7148L1194.76 54.4498H1199.05L1199.92 56.7148ZM1195.39 52.7548L1196.89 48.7648L1198.4 52.7548H1195.39Z",
    fill: "#59B974"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 811,
    y: 43.001,
    width: 96,
    height: 21,
    rx: 5,
    fill: "#0E64A9",
    fillOpacity: 0.11
  })), _path1915 || (_path1915 = /*#__PURE__*/React.createElement("path", {
    d: "M822.194 58.671V55.431H824.444C826.919 55.431 828.194 53.841 828.194 51.966C828.194 50.091 826.919 48.501 824.444 48.501H820.499C820.319 48.501 820.184 48.651 820.184 48.816V58.671C820.184 58.851 820.319 59.001 820.499 59.001H821.879C822.059 59.001 822.194 58.851 822.194 58.671ZM822.194 53.661V50.271H824.309C825.314 50.271 826.109 50.916 826.109 51.966C826.109 53.016 825.314 53.661 824.309 53.661H822.194ZM835.552 58.716C835.627 58.896 835.702 59.001 835.882 59.001H837.457C837.697 59.001 837.862 58.821 837.742 58.521L833.947 48.816C833.857 48.591 833.677 48.501 833.527 48.501H831.667C831.517 48.501 831.337 48.591 831.247 48.816L827.467 58.536C827.362 58.821 827.497 59.001 827.722 59.001H829.207C829.372 59.001 829.477 58.881 829.537 58.716L830.392 56.451H834.682L835.552 58.716ZM831.022 54.756L832.522 50.766L834.037 54.756H831.022ZM846.005 57.471C846.005 57.291 845.855 57.156 845.675 57.156H840.68V48.831C840.68 48.651 840.53 48.501 840.35 48.501H838.985C838.805 48.501 838.67 48.651 838.67 48.831V58.686C838.67 58.851 838.805 59.001 838.985 59.001H845.675C845.855 59.001 846.005 58.851 846.005 58.671V57.471ZM854.428 57.471C854.428 57.291 854.278 57.156 854.098 57.156H849.103V48.831C849.103 48.651 848.953 48.501 848.773 48.501H847.408C847.228 48.501 847.093 48.651 847.093 48.831V58.686C847.093 58.851 847.228 59.001 847.408 59.001H854.098C854.278 59.001 854.428 58.851 854.428 58.671V57.471ZM855.831 48.501C855.651 48.501 855.516 48.651 855.516 48.816V58.671C855.516 58.851 855.651 59.001 855.831 59.001H863.316C863.496 59.001 863.646 58.851 863.646 58.671V57.471C863.646 57.291 863.496 57.156 863.316 57.156H857.526V54.621H860.496C860.676 54.621 860.811 54.471 860.811 54.291V53.151C860.811 52.971 860.676 52.821 860.496 52.821H857.526V50.346H863.226C863.406 50.346 863.541 50.211 863.541 50.031V48.831C863.541 48.651 863.406 48.501 863.226 48.501H855.831ZM864.14 50.031C864.14 50.211 864.275 50.346 864.455 50.346H867.575V58.671C867.575 58.851 867.71 59.001 867.89 59.001H869.315C869.495 59.001 869.645 58.851 869.645 58.671V50.346H872.765C872.945 50.346 873.08 50.211 873.08 50.031V48.831C873.08 48.651 872.945 48.501 872.765 48.501H864.455C864.275 48.501 864.14 48.651 864.14 48.831V50.031ZM875.903 59.001C876.083 59.001 876.218 58.851 876.218 58.671V48.816C876.218 48.651 876.083 48.501 875.903 48.501H874.523C874.343 48.501 874.208 48.651 874.208 48.816V58.671C874.208 58.851 874.343 59.001 874.523 59.001H875.903ZM884.643 58.686C884.778 58.911 884.973 59.001 885.288 59.001H886.773C886.938 59.001 887.103 58.866 887.103 58.686V48.816C887.103 48.651 886.938 48.501 886.773 48.501H885.393C885.228 48.501 885.093 48.651 885.093 48.816V55.656L880.698 48.756C880.578 48.561 880.413 48.501 880.233 48.501H878.448C878.268 48.501 878.133 48.651 878.133 48.816V58.686C878.133 58.866 878.268 59.001 878.448 59.001H879.828C880.008 59.001 880.143 58.866 880.143 58.686V51.681L884.643 58.686ZM894.042 48.291C890.907 48.291 888.462 50.661 888.462 53.751C888.462 56.841 890.742 59.211 893.802 59.211C895.527 59.211 896.622 58.521 897.297 57.591V58.671C897.297 58.851 897.447 59.001 897.627 59.001H898.812C898.992 59.001 899.142 58.851 899.142 58.671V54.066C899.142 53.886 898.992 53.751 898.812 53.751H894.297C894.117 53.751 893.967 53.886 893.967 54.066V55.056C893.967 55.221 894.117 55.371 894.297 55.371H897.177C896.667 56.556 895.512 57.381 894.072 57.381C892.032 57.381 890.562 55.851 890.562 53.781C890.562 51.756 892.047 50.151 894.042 50.151C895.572 50.151 896.622 50.916 897.207 52.041C897.252 52.146 897.312 52.296 897.537 52.251L899.022 51.876C899.247 51.816 899.232 51.651 899.187 51.546C898.437 49.521 896.367 48.291 894.042 48.291Z",
    fill: "#59B974"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 374,
    y: 42.001,
    width: 118.488,
    height: 20.9602,
    rx: 5,
    fill: "#0E64A9",
    fillOpacity: 0.11
  })), _path1916 || (_path1916 = /*#__PURE__*/React.createElement("path", {
    d: "M392.02 59.712V56.472H394.27C396.745 56.472 398.02 54.882 398.02 53.007C398.02 51.132 396.745 49.542 394.27 49.542H390.325C390.145 49.542 390.01 49.692 390.01 49.857V59.712C390.01 59.892 390.145 60.042 390.325 60.042H391.705C391.885 60.042 392.02 59.892 392.02 59.712ZM392.02 54.702V51.312H394.135C395.14 51.312 395.935 51.957 395.935 53.007C395.935 54.057 395.14 54.702 394.135 54.702H392.02ZM405.378 59.757C405.453 59.937 405.528 60.042 405.708 60.042H407.283C407.523 60.042 407.688 59.862 407.568 59.562L403.773 49.857C403.683 49.632 403.503 49.542 403.353 49.542H401.493C401.343 49.542 401.163 49.632 401.073 49.857L397.293 59.577C397.188 59.862 397.323 60.042 397.548 60.042H399.033C399.198 60.042 399.303 59.922 399.363 59.757L400.218 57.492H404.508L405.378 59.757ZM400.848 55.797L402.348 51.807L403.863 55.797H400.848ZM413.066 60.252C415.346 60.252 417.386 59.052 418.076 56.997C418.121 56.862 418.136 56.727 417.911 56.667L416.411 56.292C416.186 56.247 416.126 56.397 416.081 56.502C415.541 57.597 414.536 58.392 413.081 58.392C411.086 58.392 409.646 56.817 409.646 54.792C409.646 52.767 411.086 51.192 413.081 51.192C414.536 51.192 415.541 51.987 416.081 53.082C416.126 53.187 416.186 53.337 416.411 53.292L417.911 52.917C418.136 52.857 418.121 52.722 418.076 52.587C417.386 50.532 415.346 49.332 413.066 49.332C409.976 49.332 407.546 51.702 407.546 54.792C407.546 57.882 409.976 60.252 413.066 60.252ZM428.009 49.977C428.159 49.797 428.069 49.542 427.829 49.542H426.284C426.014 49.542 425.849 49.632 425.699 49.827L422.564 53.817H421.244V49.857C421.244 49.692 421.094 49.542 420.914 49.542H419.549C419.369 49.542 419.234 49.692 419.234 49.857V59.712C419.234 59.892 419.369 60.042 419.549 60.042H420.914C421.094 60.042 421.244 59.892 421.244 59.712V55.587H422.579L425.669 59.787C425.819 59.997 425.954 60.042 426.209 60.042H427.889C428.054 60.042 428.189 59.862 428.039 59.652L424.229 54.552L428.009 49.977ZM436.038 59.757C436.113 59.937 436.188 60.042 436.368 60.042H437.943C438.183 60.042 438.348 59.862 438.228 59.562L434.433 49.857C434.343 49.632 434.163 49.542 434.013 49.542H432.153C432.003 49.542 431.823 49.632 431.733 49.857L427.953 59.577C427.848 59.862 427.983 60.042 428.208 60.042H429.693C429.858 60.042 429.963 59.922 430.023 59.757L430.878 57.492H435.168L436.038 59.757ZM431.508 55.797L433.008 51.807L434.523 55.797H431.508ZM443.785 49.332C440.65 49.332 438.205 51.702 438.205 54.792C438.205 57.882 440.485 60.252 443.545 60.252C445.27 60.252 446.365 59.562 447.04 58.632V59.712C447.04 59.892 447.19 60.042 447.37 60.042H448.555C448.735 60.042 448.885 59.892 448.885 59.712V55.107C448.885 54.927 448.735 54.792 448.555 54.792H444.04C443.86 54.792 443.71 54.927 443.71 55.107V56.097C443.71 56.262 443.86 56.412 444.04 56.412H446.92C446.41 57.597 445.255 58.422 443.815 58.422C441.775 58.422 440.305 56.892 440.305 54.822C440.305 52.797 441.79 51.192 443.785 51.192C445.315 51.192 446.365 51.957 446.95 53.082C446.995 53.187 447.055 53.337 447.28 53.292L448.765 52.917C448.99 52.857 448.975 52.692 448.93 52.587C448.18 50.562 446.11 49.332 443.785 49.332ZM452.174 60.042C452.354 60.042 452.489 59.892 452.489 59.712V49.857C452.489 49.692 452.354 49.542 452.174 49.542H450.794C450.614 49.542 450.479 49.692 450.479 49.857V59.712C450.479 59.892 450.614 60.042 450.794 60.042H452.174ZM460.915 59.727C461.05 59.952 461.245 60.042 461.56 60.042H463.045C463.21 60.042 463.375 59.907 463.375 59.727V49.857C463.375 49.692 463.21 49.542 463.045 49.542H461.665C461.5 49.542 461.365 49.692 461.365 49.857V56.697L456.97 49.797C456.85 49.602 456.685 49.542 456.505 49.542H454.72C454.54 49.542 454.405 49.692 454.405 49.857V59.727C454.405 59.907 454.54 60.042 454.72 60.042H456.1C456.28 60.042 456.415 59.907 456.415 59.727V52.722L460.915 59.727ZM470.314 49.332C467.179 49.332 464.734 51.702 464.734 54.792C464.734 57.882 467.014 60.252 470.074 60.252C471.799 60.252 472.894 59.562 473.569 58.632V59.712C473.569 59.892 473.719 60.042 473.899 60.042H475.084C475.264 60.042 475.414 59.892 475.414 59.712V55.107C475.414 54.927 475.264 54.792 475.084 54.792H470.569C470.389 54.792 470.239 54.927 470.239 55.107V56.097C470.239 56.262 470.389 56.412 470.569 56.412H473.449C472.939 57.597 471.784 58.422 470.344 58.422C468.304 58.422 466.834 56.892 466.834 54.822C466.834 52.797 468.319 51.192 470.314 51.192C471.844 51.192 472.894 51.957 473.479 53.082C473.524 53.187 473.584 53.337 473.809 53.292L475.294 52.917C475.519 52.857 475.504 52.692 475.459 52.587C474.709 50.562 472.639 49.332 470.314 49.332Z",
    fill: "#59B974"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    y: 357.001,
    width: 144,
    height: 21,
    rx: 5,
    transform: "rotate(-90 0 357.001)",
    fill: "#0E64A9",
    fillOpacity: 0.11
  })), _path1917 || (_path1917 = /*#__PURE__*/React.createElement("path", {
    d: "M16.041 351.191C16.041 351.011 15.891 350.876 15.711 350.876H5.85602C5.69101 350.876 5.54101 351.011 5.54101 351.191V352.571C5.54101 352.751 5.69101 352.886 5.85602 352.886H15.711C15.891 352.886 16.041 352.751 16.041 352.571V351.191ZM15.726 342.45C15.951 342.315 16.041 342.12 16.041 341.805V340.32C16.041 340.155 15.906 339.99 15.726 339.99H5.85602C5.69101 339.99 5.54101 340.155 5.54101 340.32V341.7C5.54101 341.865 5.69101 342 5.85602 342H12.696L5.79602 346.395C5.60102 346.515 5.54101 346.68 5.54101 346.86V348.645C5.54101 348.825 5.69101 348.96 5.85602 348.96H15.726C15.906 348.96 16.041 348.825 16.041 348.645V347.265C16.041 347.085 15.906 346.95 15.726 346.95H8.72102L15.726 342.45ZM5.33101 334.461C5.33101 336.771 6.63602 338.466 8.48102 338.466C9.93602 338.466 10.911 337.551 11.331 335.916L11.826 334.011C12.096 332.976 12.471 332.436 13.191 332.436C13.836 332.436 14.466 333.066 14.466 334.326C14.466 335.586 13.896 336.396 13.311 336.996C13.101 337.206 12.981 337.416 13.206 337.701L13.851 338.526C14.076 338.811 14.421 338.751 14.676 338.526C15.441 337.851 16.251 336.501 16.251 334.446C16.251 331.596 14.586 330.246 12.996 330.246C11.331 330.246 10.461 331.356 10.011 333.051L9.47102 335.106C9.23102 336.036 8.82602 336.306 8.34602 336.306C7.55101 336.306 7.10102 335.511 7.10102 334.521C7.10102 333.621 7.49101 332.886 8.01602 332.196C8.25601 331.881 8.22602 331.611 8.01602 331.401L7.35601 330.771C7.20601 330.621 6.95102 330.471 6.60602 330.831C5.94602 331.521 5.33101 332.811 5.33101 334.461ZM15.711 326.94H12.471V324.69C12.471 322.215 10.881 320.94 9.00602 320.94C7.13102 320.94 5.54101 322.215 5.54101 324.69V328.635C5.54101 328.815 5.69101 328.95 5.85602 328.95H15.711C15.891 328.95 16.041 328.815 16.041 328.635V327.255C16.041 327.075 15.891 326.94 15.711 326.94ZM10.701 326.94H7.31102L7.31102 324.825C7.31102 323.82 7.95602 323.025 9.00602 323.025C10.056 323.025 10.701 323.82 10.701 324.825V326.94ZM5.54101 319.436C5.54101 319.616 5.69101 319.751 5.85602 319.751H15.711C15.891 319.751 16.041 319.616 16.041 319.436V311.951C16.041 311.771 15.891 311.621 15.711 311.621H14.511C14.331 311.621 14.196 311.771 14.196 311.951V317.741H11.661V314.771C11.661 314.591 11.511 314.456 11.331 314.456H10.191C10.011 314.456 9.86102 314.591 9.86102 314.771V317.741H7.38602L7.38602 312.041C7.38602 311.861 7.25102 311.726 7.07101 311.726H5.87102C5.69101 311.726 5.54101 311.861 5.54101 312.041V319.436ZM16.251 305.689C16.251 303.409 15.051 301.369 12.996 300.679C12.861 300.634 12.726 300.619 12.666 300.844L12.291 302.344C12.246 302.569 12.396 302.629 12.501 302.674C13.596 303.214 14.391 304.219 14.391 305.674C14.391 307.669 12.816 309.109 10.791 309.109C8.76602 309.109 7.19102 307.669 7.19102 305.674C7.19102 304.219 7.98602 303.214 9.08102 302.674C9.18602 302.629 9.33602 302.569 9.29102 302.344L8.91602 300.844C8.85602 300.619 8.72102 300.634 8.58602 300.679C6.53102 301.369 5.33101 303.409 5.33101 305.689C5.33101 308.779 7.70101 311.209 10.791 311.209C13.881 311.209 16.251 308.779 16.251 305.689ZM7.07101 300.536C7.25102 300.536 7.38602 300.401 7.38602 300.221L7.38602 297.101H15.711C15.891 297.101 16.041 296.966 16.041 296.786V295.361C16.041 295.181 15.891 295.031 15.711 295.031H7.38602L7.38602 291.911C7.38602 291.731 7.25102 291.596 7.07101 291.596H5.87102C5.69101 291.596 5.54101 291.731 5.54101 291.911L5.54101 300.221C5.54101 300.401 5.69101 300.536 5.87102 300.536H7.07101ZM16.041 288.774C16.041 288.594 15.891 288.459 15.711 288.459H5.85602C5.69101 288.459 5.54101 288.594 5.54101 288.774V290.154C5.54101 290.334 5.69101 290.469 5.85602 290.469H15.711C15.891 290.469 16.041 290.334 16.041 290.154V288.774ZM10.791 276.058C7.70101 276.058 5.33101 278.488 5.33101 281.578C5.33101 284.653 7.70101 287.098 10.791 287.098C13.881 287.098 16.251 284.653 16.251 281.578C16.251 278.488 13.881 276.058 10.791 276.058ZM10.791 278.143C12.816 278.143 14.391 279.583 14.391 281.578C14.391 283.573 12.816 284.998 10.791 284.998C8.76602 284.998 7.19102 283.573 7.19102 281.578C7.19102 279.583 8.76602 278.143 10.791 278.143ZM15.726 268.182C15.951 268.047 16.041 267.852 16.041 267.537V266.052C16.041 265.887 15.906 265.722 15.726 265.722H5.85602C5.69101 265.722 5.54101 265.887 5.54101 266.052V267.432C5.54101 267.597 5.69101 267.732 5.85602 267.732H12.696L5.79602 272.127C5.60102 272.247 5.54101 272.412 5.54101 272.592V274.377C5.54101 274.557 5.69101 274.692 5.85602 274.692H15.726C15.906 274.692 16.041 274.557 16.041 274.377V272.997C16.041 272.817 15.906 272.682 15.726 272.682H8.72102L15.726 268.182ZM15.756 253.933C15.936 253.858 16.041 253.783 16.041 253.603V252.028C16.041 251.788 15.861 251.623 15.561 251.743L5.85602 255.538C5.63102 255.628 5.54101 255.808 5.54101 255.958V257.818C5.54101 257.968 5.63102 258.148 5.85602 258.238L15.576 262.018C15.861 262.123 16.041 261.988 16.041 261.763V260.278C16.041 260.113 15.921 260.008 15.756 259.948L13.491 259.093L13.491 254.803L15.756 253.933ZM11.796 258.463L7.80602 256.963L11.796 255.448L11.796 258.463ZM16.041 242.205C16.041 241.965 15.801 241.86 15.621 241.98L11.676 244.425C11.151 242.745 9.68102 242.25 8.70602 242.25C6.90602 242.25 5.54101 243.66 5.54101 245.88L5.54101 250.5C5.54101 250.71 5.70602 250.815 5.85602 250.815H15.711C15.891 250.815 16.041 250.68 16.041 250.5V249.12C16.041 248.94 15.891 248.805 15.711 248.805H12.021V246.48L15.711 244.26C15.951 244.125 16.041 243.99 16.041 243.735V242.205ZM10.386 246.105V248.805H7.31102L7.31102 246.075C7.31102 245.07 7.89601 244.365 8.81102 244.365C9.74102 244.365 10.386 245.07 10.386 246.105ZM5.54101 240.378C5.54101 240.558 5.69101 240.693 5.85602 240.693H15.711C15.891 240.693 16.041 240.558 16.041 240.378V232.893C16.041 232.713 15.891 232.563 15.711 232.563H14.511C14.331 232.563 14.196 232.713 14.196 232.893V238.683H11.661V235.713C11.661 235.533 11.511 235.398 11.331 235.398H10.191C10.011 235.398 9.86102 235.533 9.86102 235.713V238.683H7.38602L7.38602 232.983C7.38602 232.803 7.25102 232.668 7.07101 232.668H5.87102C5.69101 232.668 5.54101 232.803 5.54101 232.983L5.54101 240.378ZM15.756 224.314C15.936 224.239 16.041 224.164 16.041 223.984V222.409C16.041 222.169 15.861 222.004 15.561 222.124L5.85602 225.919C5.63102 226.009 5.54101 226.189 5.54101 226.339V228.199C5.54101 228.349 5.63102 228.529 5.85602 228.619L15.576 232.399C15.861 232.504 16.041 232.369 16.041 232.144L16.041 230.659C16.041 230.494 15.921 230.389 15.756 230.329L13.491 229.474V225.184L15.756 224.314ZM11.796 228.844L7.80602 227.344L11.796 225.829V228.844Z",
    fill: "#59B974"
  })), _path1918 || (_path1918 = /*#__PURE__*/React.createElement("path", {
    d: "M1024 132.212H1014V153.212H1024V132.212Z",
    stroke: "#59B974",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path1919 || (_path1919 = /*#__PURE__*/React.createElement("path", {
    d: "M1024 189.212H1014V209.212H1024V189.212Z",
    stroke: "#59B974",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path1920 || (_path1920 = /*#__PURE__*/React.createElement("path", {
    d: "M1079 132.212H1069V153.212H1079V132.212Z",
    stroke: "#59B974",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path1921 || (_path1921 = /*#__PURE__*/React.createElement("path", {
    d: "M1079 189.212H1069V209.212H1079V189.212Z",
    stroke: "#59B974",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path1922 || (_path1922 = /*#__PURE__*/React.createElement("path", {
    d: "M1135 132.212H1125V153.212H1135V132.212Z",
    stroke: "#59B974",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path1923 || (_path1923 = /*#__PURE__*/React.createElement("path", {
    d: "M1135 189.212H1125V209.212H1135V189.212Z",
    stroke: "#59B974",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path1924 || (_path1924 = /*#__PURE__*/React.createElement("path", {
    d: "M1190 132.212H1181V153.212H1190V132.212Z",
    stroke: "#59B974",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path1925 || (_path1925 = /*#__PURE__*/React.createElement("path", {
    d: "M1190 189.212H1181V209.212H1190V189.212Z",
    stroke: "#59B974",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path1926 || (_path1926 = /*#__PURE__*/React.createElement("path", {
    d: "M1060 132.212H1050V153.212H1060V132.212Z",
    stroke: "#59B974",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path1927 || (_path1927 = /*#__PURE__*/React.createElement("path", {
    d: "M1060 189.212H1050V209.212H1060V189.212Z",
    stroke: "#59B974",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path1928 || (_path1928 = /*#__PURE__*/React.createElement("path", {
    d: "M1116 132.212H1106V153.212H1116V132.212Z",
    stroke: "#59B974",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path1929 || (_path1929 = /*#__PURE__*/React.createElement("path", {
    d: "M1116 189.212H1106V209.212H1116V189.212Z",
    stroke: "#59B974",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path1930 || (_path1930 = /*#__PURE__*/React.createElement("path", {
    d: "M1171 132.212H1162V153.212H1171V132.212Z",
    stroke: "#59B974",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path1931 || (_path1931 = /*#__PURE__*/React.createElement("path", {
    d: "M1171 189.212H1162V209.212H1171V189.212Z",
    stroke: "#59B974",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path1932 || (_path1932 = /*#__PURE__*/React.createElement("path", {
    d: "M1227 132.212H1217V153.212H1227V132.212Z",
    stroke: "#59B974",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path1933 || (_path1933 = /*#__PURE__*/React.createElement("path", {
    d: "M1227 189.212H1217V209.212H1227V189.212Z",
    stroke: "#59B974",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path1934 || (_path1934 = /*#__PURE__*/React.createElement("path", {
    d: "M1060 121.212H1019V115.717V110.212H1060V115.717V121.212Z",
    stroke: "#59B974",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path1935 || (_path1935 = /*#__PURE__*/React.createElement("path", {
    d: "M1060 178.212H1019V172.217V166.212H1060V172.217V178.212Z",
    stroke: "#59B974",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path1936 || (_path1936 = /*#__PURE__*/React.createElement("path", {
    d: "M1116 121.212H1074V115.717V110.212H1116V115.717V121.212Z",
    stroke: "#59B974",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path1937 || (_path1937 = /*#__PURE__*/React.createElement("path", {
    d: "M1116 178.212H1074V172.217V166.212H1116V172.217V178.212Z",
    stroke: "#59B974",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path1938 || (_path1938 = /*#__PURE__*/React.createElement("path", {
    d: "M1171 121.212H1130V115.717V110.212H1171V115.717V121.212Z",
    stroke: "#59B974",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path1939 || (_path1939 = /*#__PURE__*/React.createElement("path", {
    d: "M1171 178.212H1130V172.217V166.212H1171V172.217V178.212Z",
    stroke: "#59B974",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path1940 || (_path1940 = /*#__PURE__*/React.createElement("path", {
    d: "M1227 121.212H1186V115.717V110.212H1227V115.717V121.212Z",
    stroke: "#59B974",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path1941 || (_path1941 = /*#__PURE__*/React.createElement("path", {
    d: "M1227 178.212H1186V172.217V166.212H1227V172.217V178.212Z",
    stroke: "#59B974",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path1942 || (_path1942 = /*#__PURE__*/React.createElement("path", {
    d: "M1020 116.212H1060",
    stroke: "#59B974",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path1943 || (_path1943 = /*#__PURE__*/React.createElement("path", {
    d: "M1020 172.212H1060",
    stroke: "#59B974",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path1944 || (_path1944 = /*#__PURE__*/React.createElement("path", {
    d: "M1075 116.212H1116",
    stroke: "#59B974",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path1945 || (_path1945 = /*#__PURE__*/React.createElement("path", {
    d: "M1075 172.212H1116",
    stroke: "#59B974",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path1946 || (_path1946 = /*#__PURE__*/React.createElement("path", {
    d: "M1131 116.212H1171",
    stroke: "#59B974",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path1947 || (_path1947 = /*#__PURE__*/React.createElement("path", {
    d: "M1131 172.212H1171",
    stroke: "#59B974",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path1948 || (_path1948 = /*#__PURE__*/React.createElement("path", {
    d: "M1186 116.212H1227",
    stroke: "#59B974",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path1949 || (_path1949 = /*#__PURE__*/React.createElement("path", {
    d: "M1186 172.212H1227",
    stroke: "#59B974",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path1950 || (_path1950 = /*#__PURE__*/React.createElement("path", {
    d: "M1046 126.212H1028V159.212H1046V126.212Z",
    stroke: "#59B974",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path1951 || (_path1951 = /*#__PURE__*/React.createElement("path", {
    d: "M1046 183.212H1028V215.212H1046V183.212Z",
    stroke: "#59B974",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path1952 || (_path1952 = /*#__PURE__*/React.createElement("path", {
    d: "M1102 126.212H1084V159.212H1102V126.212Z",
    stroke: "#59B974",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path1953 || (_path1953 = /*#__PURE__*/React.createElement("path", {
    d: "M1102 183.212H1084V215.212H1102V183.212Z",
    stroke: "#59B974",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path1954 || (_path1954 = /*#__PURE__*/React.createElement("path", {
    d: "M1157 126.212H1139V159.212H1157V126.212Z",
    stroke: "#59B974",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path1955 || (_path1955 = /*#__PURE__*/React.createElement("path", {
    d: "M1157 183.212H1139V215.212H1157V183.212Z",
    stroke: "#59B974",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path1956 || (_path1956 = /*#__PURE__*/React.createElement("path", {
    d: "M1213 126.212H1195V159.212H1213V126.212Z",
    stroke: "#59B974",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path1957 || (_path1957 = /*#__PURE__*/React.createElement("path", {
    d: "M1213 183.212H1195V215.212H1213V183.212Z",
    stroke: "#59B974",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path1958 || (_path1958 = /*#__PURE__*/React.createElement("path", {
    d: "M1046 126.212H1037V159.212H1046V126.212Z",
    stroke: "#59B974",
    strokeWidth: 1.4142,
    strokeMiterlimit: 10
  })), _path1959 || (_path1959 = /*#__PURE__*/React.createElement("path", {
    d: "M1046 183.212H1037V215.212H1046V183.212Z",
    stroke: "#59B974",
    strokeWidth: 1.4142,
    strokeMiterlimit: 10
  })), _path1960 || (_path1960 = /*#__PURE__*/React.createElement("path", {
    d: "M1102 126.212H1093V159.212H1102V126.212Z",
    stroke: "#59B974",
    strokeWidth: 1.4142,
    strokeMiterlimit: 10
  })), _path1961 || (_path1961 = /*#__PURE__*/React.createElement("path", {
    d: "M1102 183.212H1093V215.212H1102V183.212Z",
    stroke: "#59B974",
    strokeWidth: 1.4142,
    strokeMiterlimit: 10
  })), _path1962 || (_path1962 = /*#__PURE__*/React.createElement("path", {
    d: "M1157 126.212H1148V159.212H1157V126.212Z",
    stroke: "#59B974",
    strokeWidth: 1.4142,
    strokeMiterlimit: 10
  })), _path1963 || (_path1963 = /*#__PURE__*/React.createElement("path", {
    d: "M1157 183.212H1148V215.212H1157V183.212Z",
    stroke: "#59B974",
    strokeWidth: 1.4142,
    strokeMiterlimit: 10
  })), _path1964 || (_path1964 = /*#__PURE__*/React.createElement("path", {
    d: "M1213 126.212H1204V159.212H1213V126.212Z",
    stroke: "#59B974",
    strokeWidth: 1.4142,
    strokeMiterlimit: 10
  })), _path1965 || (_path1965 = /*#__PURE__*/React.createElement("path", {
    d: "M1213 183.212H1204V215.212H1213V183.212Z",
    stroke: "#59B974",
    strokeWidth: 1.4142,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloormapMain);
export default __webpack_public_path__ + "static/media/floormap-main.c1d7a219f3a64fd740e30a567cc16ea7.svg";
export { ForwardRef as ReactComponent };